webpackJsonp([3],{

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Div = _styledComponents2.default.div.withConfig({
  displayName: 'PropItem__Div'
})(['font-size:0.9em;']);
var HostProp = function HostProp(_ref) {
  var label = _ref.label,
      semicolon = _ref.semicolon,
      children = _ref.children;
  return _react2.default.createElement(
    _styledCommon.Flex,
    { justifyContent: 'space-between' },
    _react2.default.createElement(
      'div',
      null,
      label ? '' + label + (semicolon ? ': ' : '') : ''
    ),
    _react2.default.createElement(
      Div,
      null,
      children
    )
  );
};
exports.default = HostProp;

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arkInfo = __webpack_require__(1318);
var conanInfo = __webpack_require__(1319);
var rustInfo = __webpack_require__(1320);
var sevenDaysToDieInfo = __webpack_require__(1321);
var terrariaInfo = __webpack_require__(1322);
var unturnedInfo = __webpack_require__(1323);
var armaInfo = __webpack_require__(1324);
var pixarkInfo = __webpack_require__(1325);
var gmodInfo = __webpack_require__(1326);
var spaceEngineersInfo = __webpack_require__(1327);
var starboundInfo = __webpack_require__(1328);
var csgoInfo = __webpack_require__(1329);
var hurtworldInfo = __webpack_require__(1330);
var atlasInfo = __webpack_require__(1331);
var dayzInfo = __webpack_require__(1332);
var outlawsInfo = __webpack_require__(1333);
var hytaleInfo = __webpack_require__(1334);
var heatInfo = __webpack_require__(1335);
var minecraftInfo = __webpack_require__(1336);
var dbdInfo = __webpack_require__(1337);
var scumInfo = __webpack_require__(1338);
var vRisingInfo = __webpack_require__(1339);
module.exports = [arkInfo, rustInfo, unturnedInfo, terrariaInfo, sevenDaysToDieInfo, armaInfo, conanInfo, pixarkInfo, gmodInfo, spaceEngineersInfo, starboundInfo, csgoInfo, hurtworldInfo, atlasInfo, dayzInfo, dbdInfo, heatInfo, hytaleInfo, minecraftInfo, outlawsInfo, scumInfo, vRisingInfo];

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [{
    title: 'Cluster Support',
    name: 'clusterSupport',
    type: 'object',
    fields: [{
        title: 'Available',
        name: 'available',
        type: 'boolean'
    }, {
        title: 'Price',
        name: 'price',
        type: 'number',
        description: "If cluster support costs extra. how much? If it's free set to zero."
    }]
}, {
    title: 'Procedural Map Generation (PGARK)',
    name: 'proceduralMaps',
    type: 'object',
    fields: [{
        title: 'Available',
        name: 'available',
        type: 'boolean'
    }, {
        title: 'Price',
        name: 'price',
        type: 'number',
        description: "If procedural maps cost extra, specify the price in USD here. If it's free, it should be zero"
    }]
}];
module.exports = {
    sanityTypeDef: {
        title: 'ARK: Survival Evolved',
        name: 'ark',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'ARK: Survival Evolved' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Conan: Exiles',
        name: 'conan',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Conan: Exiles' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Rust',
        name: 'rust',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Rust' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: '7 Days to Die',
        name: '7d2d',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: '7 Days to Die' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Terraria',
        name: 'terraria',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Terraria' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Unturned',
        name: 'unturned',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Unturned' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Arma III',
        name: 'arma',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Arma III' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'PixARK',
        name: 'pixark',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'PixARK' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: "Garry's Mod",
        name: 'gmod',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: "Garry's Mod" };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Space Engineers',
        name: 'spaceEngineers',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Space Engineers' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Starbound',
        name: 'starbound',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Starbound' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Counter Strike: Global Offensive',
        name: 'csgo',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Counter Strike: Global Offensive' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Hurtworld',
        name: 'hurtworld',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Hurtworld' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'ATLAS',
        name: 'atlas',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'ATLAS' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'DayZ',
        name: 'dayz',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'DayZ' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Outlaws of the Old West',
        name: 'outlaws',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Outlaws of the Old West' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Hytale',
        name: 'hytale',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Hytale' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Heat',
        name: 'heat',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Heat' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Minecraft',
        name: 'minecraft',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Minecraft' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'Dead by Daylight',
        name: 'dbd',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'Dead by Daylight' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'SCUM',
        name: 'scum',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'SCUM' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var baseFields = __webpack_require__(701);
var fields = [];
module.exports = {
    sanityTypeDef: {
        title: 'V Rising',
        name: 'vrising',
        type: 'object',
        fields: [].concat(_toConsumableArray(baseFields), fields),
        preview: {
            select: {},
            prepare: function prepare() {
                return { title: 'V Rising' };
            }
        }
    },
    fields: fields
};

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _row = __webpack_require__(109);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(108);

var _col2 = _interopRequireDefault(_col);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(165);

__webpack_require__(164);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentWrapper = function (_PureComponent) {
    _inherits(ContentWrapper, _PureComponent);

    function ContentWrapper() {
        _classCallCheck(this, ContentWrapper);

        return _possibleConstructorReturn(this, (ContentWrapper.__proto__ || Object.getPrototypeOf(ContentWrapper)).apply(this, arguments));
    }

    _createClass(ContentWrapper, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                layout = _props.layout,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['layout', 'children']);

            var colLayout = _extends({}, ContentWrapper.defaultLayout, layout);
            return _react2.default.createElement(
                _row2.default,
                props,
                _react2.default.createElement(
                    _col2.default,
                    colLayout,
                    children
                )
            );
        }
    }]);

    return ContentWrapper;
}(_react.PureComponent);

exports.default = ContentWrapper;

ContentWrapper.propTypes = {
    layout: _propTypes2.default.object
};
ContentWrapper.defaultLayout = {
    xs: { span: 22, offset: 1 },
    sm: { span: 20, offset: 2 },
    md: { span: 20, offset: 2 },
    lg: { span: 20, offset: 2 },
    xl: { span: 20, offset: 2 },
    xxl: { span: 20, offset: 2 }
};

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _row = __webpack_require__(109);

var _row2 = _interopRequireDefault(_row);

var _button = __webpack_require__(705);

var _button2 = _interopRequireDefault(_button);

var _icon = __webpack_require__(75);

var _icon2 = _interopRequireDefault(_icon);

var _rate = __webpack_require__(763);

var _rate2 = _interopRequireDefault(_rate);

var _card = __webpack_require__(285);

var _card2 = _interopRequireDefault(_card);

var _col = __webpack_require__(108);

var _col2 = _interopRequireDefault(_col);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(165);

__webpack_require__(706);

__webpack_require__(263);

__webpack_require__(764);

__webpack_require__(286);

__webpack_require__(164);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

var _utils = __webpack_require__(261);

var _currencies = __webpack_require__(275);

var _cells = __webpack_require__(787);

var _PropItem = __webpack_require__(1019);

var _PropItem2 = _interopRequireDefault(_PropItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Img = _styledComponents2.default.img.withConfig({
  displayName: 'HostOverview__Img'
})(['max-width:100%;max-height:100%;']);
var ProCon = _styledComponents2.default.div.withConfig({
  displayName: 'HostOverview__ProCon'
})(['.anticon{font-size:0.9em;margin-right:6px;}']);
var gutter = {
  xs: 8,
  sm: 8,
  md: 24,
  lg: 48,
  xl: 48
};
var colMarginTop = 40;
var StCol = (0, _styledComponents2.default)(_col2.default).withConfig({
  displayName: 'HostOverview__StCol'
})(['margin-top:', 'px;ul{padding-left:0;}h2{margin-bottom:8px;}'], colMarginTop);
var StCard = (0, _styledComponents2.default)(_card2.default).withConfig({
  displayName: 'HostOverview__StCard'
})(['&.ant-card{color:', ';border-color:', ';overflow:hidden;.ant-card-cover{background:', ';padding:20px;height:140px;}.ant-card-actions{background:', ';span{display:none;}}.ant-card-body{background:', ';color:#fff;}}h1{text-align:center;margin:0;}'], function (p) {
  return p.theme.offBlack;
}, function (p) {
  return p.theme.textOffwhite;
}, function (p) {
  return p.theme.darkBlue;
}, function (p) {
  return p.theme.darkBlue;
}, function (p) {
  return p.theme.antLink;
});
var Locations = (0, _styledComponents2.default)(_cells.LocationsCell).withConfig({
  displayName: 'HostOverview__Locations'
})(['font-size:0.8em;text-align:left;text-align:start;.bah-flag .flag-icon{box-shadow:2px 2px 4px 1px #000;border:1px solid rgba(255,255,255,0.1);background-size:cover;}']);
var RatingScore = _styledComponents2.default.span.withConfig({
  displayName: 'HostOverview__RatingScore'
})(['font-size:0.7em;margin-right:5px;color:', ';'], function (p) {
  return p.theme.textOffwhite;
});
var Rater = (0, _styledComponents2.default)(_rate2.default).withConfig({
  displayName: 'HostOverview__Rater'
})(['&.ant-rate-disabled .ant-rate-star{cursor:pointer;}']);
var StDivider = (0, _styledComponents2.default)(_styledCommon.Divider).withConfig({
  displayName: 'HostOverview__StDivider'
})(['&.ant-divider{margin-top:0;margin-bottom:8px;}']);
var Table = _styledComponents2.default.table.withConfig({
  displayName: 'HostOverview__Table'
})(['width:100%;caption{font-family:\'Saira\',\'Segoe UI\',\'Monospaced Number\',\'Chinese Quote\',-apple-system,BlinkMacSystemFont,Roboto,\'PingFang SC\',\'Hiragino Sans GB\',\'Microsoft YaHei\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;caption-side:top;font-size:1.5em;padding:0;color:#fff;font-weight:500;margin-bottom:8px;}']);

var HostOverview = function (_Component) {
  _inherits(HostOverview, _Component);

  function HostOverview() {
    _classCallCheck(this, HostOverview);

    var _this = _possibleConstructorReturn(this, (HostOverview.__proto__ || Object.getPrototypeOf(HostOverview)).apply(this, arguments));

    _this.state = {
      currSymbol: '$'
    };
    return _this;
  }

  _createClass(HostOverview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$host = _props.host,
          id = _props$host.id,
          logo = _props$host.logo,
          name = _props$host.name,
          ratings = _props$host.ratings,
          homepageUrl = _props$host.homepageUrl,
          baseCurrency = _props$host.baseCurrency,
          established = _props$host.established,
          hostPros = _props$host.pros,
          hostCons = _props$host.cons,
          _props$host$promoCode = _props$host.promoCodes,
          promoCodes = _props$host$promoCode === undefined ? [] : _props$host$promoCode,
          moneyBack = _props$host.moneyBack,
          currency = _props$host.currency,
          _props$host$gameInfo = _props$host.gameInfo,
          packages = _props$host$gameInfo.packages,
          gamePros = _props$host$gameInfo.pros,
          gameCons = _props$host$gameInfo.cons,
          locations = _props$host$gameInfo.locations,
          orderUrl = _props$host$gameInfo.orderUrl,
          landingPageUrl = _props$host$gameInfo.landingPageUrl,
          site = _props.siteData.site,
          theme = _props.theme,
          props = _objectWithoutProperties(_props, ['host', 'siteData', 'theme']);

      var pros = [].concat(_toConsumableArray(new Set((hostPros || []).concat(gamePros || []))));
      var cons = [].concat(_toConsumableArray(new Set((hostCons || []).concat(gameCons || []))));
      var currSymbol = this.state.currSymbol;

      var affiliateLink = '/go/' + id;
      var cardCover = _react2.default.createElement(
        'div',
        { style: { height: '100%' } },
        _react2.default.createElement(
          _styledCommon.Flex,
          { style: { height: '100%' } },
          _react2.default.createElement(Img, { alt: name + ' ' + site.game.shortName + ' Server Hosting', src: (0, _utils.addQuery)(logo, { h: '140' }) })
        )
      );
      var cardActions = [_react2.default.createElement(_react.Fragment, null)];
      var pack = packages && packages.length && _extends({}, packages[0]);
      var establishedDate = established && new Date(established).toLocaleDateString('en-us', {
        year: 'numeric',
        month: 'long'
      });
      var moneyBackText = 'Unknown';
      if (moneyBack) {
        if (moneyBack.time < 0) moneyBackText = 'None';else if (moneyBack.time > 0) {
          moneyBackText = moneyBack.time + ' ' + (moneyBack.unit === 'd' ? 'Days' : 'Hours');
        }
      }
      return _react2.default.createElement(
        _row2.default,
        _extends({ gutter: gutter }, props),
        _react2.default.createElement(
          StCol,
          { xs: 24, lg: 12, xxl: 6 },
          _react2.default.createElement(
            'a',
            { href: affiliateLink, rel: 'nofollow noopener' },
            _react2.default.createElement(
              StCard,
              { actions: cardActions, cover: cardCover },
              _react2.default.createElement(
                'h1',
                null,
                name,
                ' ',
                _react2.default.createElement('br', null),
                ' ',
                site.game.shortName,
                ' Server Hosting'
              )
            )
          )
        ),
        _react2.default.createElement(
          StCol,
          { xs: 24, lg: 12, xxl: 6 },
          _react2.default.createElement(
            Table,
            null,
            _react2.default.createElement(
              'caption',
              null,
              'Overview'
            ),
            _react2.default.createElement(
              'tbody',
              null,
              established && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Established'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  establishedDate
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Website'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    _styledCommon.StyledAnchor,
                    { style: { color: theme.antLink }, href: affiliateLink, rel: 'nofollow noopener' },
                    homepageUrl
                  )
                )
              ),
              !ratings || !ratings.score ? null : _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'TrustPilot Rating'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: ratings.url, target: '_blank', rel: 'nofollow noreferrer noopener' },
                    _react2.default.createElement(Rater, { disabled: true, allowHalf: true, value: ratings.stars, defaultValue: ratings.stars }),
                    _react2.default.createElement(
                      RatingScore,
                      null,
                      '(',
                      ratings.score,
                      '/5)'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Money Back Guarantee'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  moneyBackText
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Pay Using'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  currency.join(', ')
                )
              )
            )
          ),
          _react2.default.createElement(
            'h2',
            { style: { marginTop: '20px' } },
            'Locations'
          ),
          _react2.default.createElement(Locations, { currency: baseCurrency, locations: locations, justifyContent: 'start' })
        ),
        _react2.default.createElement(
          StCol,
          { xs: 24, lg: 12, xxl: 7 },
          _react2.default.createElement(
            'h2',
            null,
            'Pros and Cons'
          ),
          _react2.default.createElement(
            'ul',
            null,
            pros.map(function (text, i) {
              return _react2.default.createElement(
                'li',
                { key: 'pros' + i },
                _react2.default.createElement(
                  ProCon,
                  null,
                  _react2.default.createElement(_icon2.default, { type: 'plus-circle', theme: 'twoTone', twoToneColor: '#3bb300' }),
                  text
                )
              );
            }),
            cons.map(function (text, i) {
              return _react2.default.createElement(
                'li',
                { key: 'cons' + i },
                _react2.default.createElement(
                  ProCon,
                  { key: 'cons' + i },
                  _react2.default.createElement(_icon2.default, { type: 'minus-circle', theme: 'twoTone', twoToneColor: '#d41f82' }),
                  text
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          StCol,
          { xs: 24, lg: 12, xxl: 4 },
          pack && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              Table,
              null,
              _react2.default.createElement(
                'caption',
                null,
                'Example Package'
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Slots'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    pack.slots
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Price'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    currSymbol,
                    pack.price.toFixed(2),
                    ' per slot'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Location'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    pack.location
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Total'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    currSymbol,
                    (pack.slots * pack.price).toFixed(2),
                    '/mo'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'a',
              { href: affiliateLink, target: '_blank', rel: 'nofollow noopener' },
              _react2.default.createElement(
                _button2.default,
                { style: { marginTop: 10, width: '100%' }, type: 'primary', size: 'large' },
                'Buy / Customize'
              )
            )
          ),
          !!promoCodes.length && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'h2',
              { style: { marginTop: 20 } },
              'Promo Codes'
            ),
            promoCodes.filter(function (_ref) {
              var validUntil = _ref.validUntil;
              return !validUntil || new Date(validUntil) > Date.now();
            }).map(function (_ref2) {
              var title = _ref2.title,
                  code = _ref2.code;
              return _react2.default.createElement(
                _PropItem2.default,
                { key: code, label: title },
                code
              );
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        currSymbol: (0, _currencies.symbolByCode)(nextProps.host.baseCurrency)
      };
    }
  }]);

  return HostOverview;
}(_react.Component);

HostOverview.propTypes = {
  host: _propTypes2.default.object.isRequired
};
exports.default = (0, _reactStatic.withSiteData)((0, _styledComponents.withTheme)((0, _styledComponents2.default)(HostOverview).withConfig({
  displayName: 'HostOverview'
})(['font-size:1.1em;color:', ';margin-top:', 'px;'], function (p) {
  return p.theme.textOffwhite;
}, -colMarginTop)));

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _row = __webpack_require__(109);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(108);

var _col2 = _interopRequireDefault(_col);

var _icon = __webpack_require__(75);

var _icon2 = _interopRequireDefault(_icon);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(165);

__webpack_require__(164);

__webpack_require__(263);

var _blockContentToReact = __webpack_require__(171);

var _blockContentToReact2 = _interopRequireDefault(_blockContentToReact);

var _imageUrl = __webpack_require__(166);

var _imageUrl2 = _interopRequireDefault(_imageUrl);

var _polished = __webpack_require__(262);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _games = __webpack_require__(1317);

var _games2 = _interopRequireDefault(_games);

var _ContentWrapper = __webpack_require__(1340);

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _Gallery = __webpack_require__(765);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _HostOverview = __webpack_require__(1341);

var _HostOverview2 = _interopRequireDefault(_HostOverview);

var _PropItem = __webpack_require__(1019);

var _PropItem2 = _interopRequireDefault(_PropItem);

var _Seperator = __webpack_require__(719);

var _Seperator2 = _interopRequireDefault(_Seperator);

var _styledCommon = __webpack_require__(260);

var _utils = __webpack_require__(261);

var _currencies = __webpack_require__(275);

var _sanitySerializers = __webpack_require__(269);

var _sanitySerializers2 = _interopRequireDefault(_sanitySerializers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propColLayout = {
  xs: 24,
  md: 12,
  xl: 8,
  xxl: 6
};
var CheckProp = function CheckProp(_ref) {
  var available = _ref.available,
      price = _ref.price,
      currSymbol = _ref.currSymbol;
  return available ? _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_icon2.default, { type: 'check' }),
    ' ',
    Number.isFinite(price) && (price === 0 ? 'Free' : currSymbol + price.toFixed(2))
  ) : _react2.default.createElement(_icon2.default, { type: 'close' });
};
var DisclaimerBlock = _styledComponents2.default.div.withConfig({
  displayName: 'Host__DisclaimerBlock'
})(['margin-top:30px;font-size:13px;p{margin:0;}']);
var InterviewWrapper = (0, _styledComponents2.default)(_ContentWrapper2.default).withConfig({
  displayName: 'Host__InterviewWrapper'
})(['color:', ';h3{color:#fff;}h3:not(:first-child){margin-top:2em;}figure{margin:0;display:inline-block;}'], function (p) {
  return p.theme.textGrey;
});
var SectionHeading = _styledComponents2.default.h2.withConfig({
  displayName: 'Host__SectionHeading'
})(['color:', ';'], function (p) {
  return p.theme.antLink;
});
var ScreenshotsGallery = (0, _styledComponents2.default)(_Gallery2.default).withConfig({
  displayName: 'Host__ScreenshotsGallery'
})(['margin-top:-17px;a{width:30%;margin:20px 1% 0;border:2px solid ', ';background:', ';img{width:100%;border-radius:3px;}}'], function (p) {
  return (0, _polished.darken)(0.15, p.theme.antLink);
}, function (p) {
  return (0, _polished.darken)(0.15, p.theme.antLink);
});

var Host = function (_Component) {
  _inherits(Host, _Component);

  function Host(props) {
    _classCallCheck(this, Host);

    var _this = _possibleConstructorReturn(this, (Host.__proto__ || Object.getPrototypeOf(Host)).call(this, props));

    _this.state = {};

    var _getSerializers = (0, _sanitySerializers2.default)(props.siteData),
        marks = _getSerializers.marks,
        types = _getSerializers.types;

    _this._serializers = {
      marks: marks,
      types: {
        image: types.galleryImage
      }
    };
    return _this;
  }

  _createClass(Host, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          host = _props.host,
          _props$siteData = _props.siteData,
          site = _props$siteData.site,
          _props$siteData$textB = _props$siteData.textBlocks,
          dataDisclaimer = _props$siteData$textB.dataDisclaimer,
          interviewPrompt = _props$siteData$textB.interviewPrompt,
          noScreenshots = _props$siteData$textB.noScreenshots,
          _props$siteData$sanit = _props$siteData.sanityConfig,
          projectId = _props$siteData$sanit.projectId,
          dataset = _props$siteData$sanit.dataset,
          theme = _props.theme;
      var name = host.name,
          ratings = host.ratings,
          id = host.id,
          baseCurrency = host.baseCurrency,
          ddos = host.ddos,
          debranding = host.debranding,
          customerSupport = host.customerSupport,
          autoUpdates = host.autoUpdates,
          autoBackups = host.autoBackups,
          locationSwitching = host.locationSwitching,
          interview = host.interview,
          ftpAccess = host.ftpAccess,
          notes = host.notes,
          gameInfo = host.gameInfo,
          _host$gameInfo = host.gameInfo,
          price = _host$gameInfo.price,
          mods = _host$gameInfo.mods,
          platforms = _host$gameInfo.platforms,
          slots = _host$gameInfo.slots,
          content = _host$gameInfo.content;

      var currSymbol = (0, _currencies.symbolByCode)(baseCurrency);
      var exclusiveFields = _games2.default.find(function (f) {
        return f.sanityTypeDef.name === gameInfo._type;
      }).fields.map(function (_ref2) {
        var title = _ref2.title,
            name = _ref2.name;
        return _react2.default.createElement(
          _PropItem2.default,
          { label: title, key: name },
          _react2.default.createElement(CheckProp, { available: gameInfo[name].available, price: gameInfo[name].price, currSymbol: currSymbol })
        );
      });
      /*     let serverListSection = null
           if (serverList && serverList.serverListUrl) {
        serverListSection = <ServerList {...serverList} />
      }
      serverListSection = <ServerList {...serverList} /> */
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _reactStatic.Head,
          null,
          _react2.default.createElement('meta', { name: 'description', content: 'We gathered all the information about ' + name + ' that you need to know before renting an ' + site.game.shortName + ' server. Ratings, Reviews, Configuration options, Customer Support, Control Panel Screenshots, Mods, Interviews and more.' }),
          _react2.default.createElement(
            'title',
            null,
            name + ' ' + site.game.shortName + ' Server Hosting Information and Reviews - ' + site.domain
          ),
          _react2.default.createElement(
            'script',
            { type: 'application/ld+json' },
            '{\n              "@context": "http://schema.org/",\n              "@type": "Product",\n              "identifier": "' + id + '",\n              "name": "' + name + ' ' + site.game.name + ' Server Hosting",\n              "image":\n                "' + this.state.logo + '",\n              "offers": {\n                "@type": "AggregateOffer",\n                "availability": "http://schema.org/InStock",\n                "lowPrice": ' + (price.max * slots.min).toFixed(2) + ',\n                "highPrice": ' + (price.min * slots.max).toFixed(2) + ',\n                "priceCurrency": "' + baseCurrency + '",\n                "url": "/go/' + id + '"\n              },\n              "category": "' + site.game.name + ' Server Hosting Rental",\n              "aggregateRating": {\n                "@type": "AggregateRating",\n                "bestRating": 5,\n                "worstRating": 0,\n                "ratingValue": ' + ratings.score + ',\n                "ratingCount": ' + (ratings.reviewCount || Math.round(ratings.score * 7)) + '\n                },\n              "url": "/go/' + id + '"\n              }'
          )
        ),
        _react2.default.createElement(
          _ContentWrapper2.default,
          { style: { background: theme.offBlack, padding: '40px 0' } },
          _react2.default.createElement(_HostOverview2.default, { host: _extends({}, host, { logo: this.state.logo }) })
        ),
        _react2.default.createElement(_Seperator2.default, null),
        _react2.default.createElement(
          _ContentWrapper2.default,
          { style: { background: theme.blue2, padding: '40px 0' } },
          _react2.default.createElement(
            SectionHeading,
            null,
            'Details'
          ),
          _react2.default.createElement(
            _row2.default,
            { gutter: { xs: 0, sm: 0, md: 24, lg: 48, xl: 48, xxl: 48 } },
            _react2.default.createElement(
              _col2.default,
              propColLayout,
              _react2.default.createElement(
                'h3',
                null,
                'Configuration Options'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Minimum Slots' },
                slots.min
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Maximum Slots' },
                slots.max
              ),
              price.min === price.max ? _react2.default.createElement(
                _PropItem2.default,
                { label: 'Price per slot' },
                currSymbol,
                price.min.toFixed(2)
              ) : _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: 'Price per slot (' + slots.min + ' slots)' },
                  currSymbol,
                  price.max.toFixed(2)
                ),
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: 'Price per slot (' + slots.max + ' slots)' },
                  currSymbol,
                  price.min.toFixed(2)
                )
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Price for ' + slots.min + ' slots' },
                currSymbol,
                (price.max * slots.min).toFixed(2),
                '/mo'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Price for ' + slots.max + ' slots' },
                currSymbol,
                (price.min * slots.max).toFixed(2),
                '/mo'
              ),
              _react2.default.createElement(_styledCommon.Divider, { color: theme.textWhite }),
              _react2.default.createElement(
                'h3',
                null,
                'Features'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Supported Platforms' },
                platforms.map(function (p) {
                  return p === 'pc' ? 'PC' : p === 'playstation' ? 'PS4' : 'Xbox';
                }).join(', ')
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Control Panel Type' },
                this.state.controlPanel.type === 'tcadmin' ? 'TCAdmin' : 'Custom'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'DDoS Protection' },
                _react2.default.createElement(CheckProp, _extends({}, ddos, { currSymbol: currSymbol }))
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Debranding' },
                _react2.default.createElement(_icon2.default, { type: 'check' }),
                ' ',
                (debranding || 0) === 0 ? 'Free' : currSymbol + (debranding > 0 ? debranding : debranding + ' Discount')
              ),
              _react2.default.createElement(_styledCommon.Divider, { color: theme.textOffwhite }),
              exclusiveFields.length > 0 && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  site.game.name,
                  ' Exclusive Features'
                ),
                exclusiveFields,
                _react2.default.createElement(_styledCommon.Divider, { color: theme.textOffwhite })
              ),
              notes && !!notes.length && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Notes'
                ),
                notes.map(function (n, i) {
                  return _react2.default.createElement(
                    'div',
                    { key: i },
                    n
                  );
                })
              )
            ),
            _react2.default.createElement(
              _col2.default,
              propColLayout,
              _react2.default.createElement(
                _col2.default,
                { xs: 24, md: 0 },
                _react2.default.createElement(_styledCommon.Divider, { color: theme.textWhite })
              ),
              mods.supported && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Mods'
                ),
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: 'Mod Support' },
                  _react2.default.createElement(CheckProp, { available: mods.supported })
                ),
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: 'Mod Manager GUI' },
                  _react2.default.createElement(CheckProp, { available: mods.modManager })
                ),
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: '1-Click Mod Install' },
                  _react2.default.createElement(CheckProp, { available: mods.oneclick })
                ),
                _react2.default.createElement(
                  _PropItem2.default,
                  { label: 'Auto Updating Mods' },
                  _react2.default.createElement(CheckProp, { available: mods.autoUpdate })
                ),
                _react2.default.createElement(_styledCommon.Divider, { color: theme.textWhite })
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Customer Support'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: '24/7' },
                _react2.default.createElement(CheckProp, { available: customerSupport.is247 })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Email' },
                _react2.default.createElement(CheckProp, { available: customerSupport.email })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Ticket System' },
                _react2.default.createElement(CheckProp, { available: customerSupport.ticket })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Chat' },
                _react2.default.createElement(CheckProp, { available: customerSupport.chat })
              ),
              _react2.default.createElement(_styledCommon.Divider, { color: theme.textWhite }),
              _react2.default.createElement(
                'h3',
                null,
                'Maintenance'
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Automatic Backups' },
                _react2.default.createElement(CheckProp, { available: autoBackups })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Automatic Updates' },
                _react2.default.createElement(CheckProp, { available: autoUpdates })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'Location Switching' },
                _react2.default.createElement(CheckProp, { available: locationSwitching })
              ),
              _react2.default.createElement(
                _PropItem2.default,
                { label: 'FTP Access' },
                _react2.default.createElement(CheckProp, { available: ftpAccess })
              )
            ),
            _react2.default.createElement(
              _col2.default,
              { xs: 24, xl: 0 },
              _react2.default.createElement(_styledCommon.Divider, { color: theme.textOffwhite })
            ),
            _react2.default.createElement(
              _col2.default,
              { xs: 24, xl: 8, xxl: 12 },
              _react2.default.createElement(
                'h3',
                null,
                'Control Panel Screenshots'
              ),
              this.state.controlPanelScreenshots.length === 0 ? _react2.default.createElement(_blockContentToReact2.default, { blocks: noScreenshots.body, serializers: this._serializers }) : _react2.default.createElement(ScreenshotsGallery, { images: this.state.controlPanelScreenshots })
            )
          ),
          _react2.default.createElement(
            DisclaimerBlock,
            null,
            _react2.default.createElement(_blockContentToReact2.default, { blocks: dataDisclaimer.body, serializers: this._serializers })
          )
        ),
        _react2.default.createElement(_Seperator2.default, null),
        content ? _react2.default.createElement(
          InterviewWrapper,
          { layout: {
              xl: { span: 10, offset: 7 },
              xxl: { span: 10, offset: 7 }
            }, style: { margin: '40px 0' } },
          _react2.default.createElement(_blockContentToReact2.default, { serializers: this._serializers, projectId: projectId, dataset: dataset, imageOptions: {
              thumbnail: { width: 320, fit: 'max' },
              full: { width: 1024, height: 768, fit: 'max' }
            }, blocks: content, isInline: true })
        ) : interview && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            InterviewWrapper,
            { layout: {
                xl: { span: 10, offset: 7 },
                xxl: { span: 10, offset: 7 }
              }, style: { margin: '40px 0' } },
            _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { style: { marginBottom: 40 } },
                _react2.default.createElement(_blockContentToReact2.default, { className: 'interview-prompt', blocks: interviewPrompt.body, serializers: this._serializers })
              ),
              _react2.default.createElement(
                SectionHeading,
                null,
                name,
                ' Interview'
              ),
              _react2.default.createElement(_blockContentToReact2.default, { serializers: this._serializers, projectId: projectId, dataset: dataset, imageOptions: {
                  thumbnail: { width: 320, fit: 'max' },
                  full: { width: 1024, height: 768, fit: 'max' }
                }, blocks: interview, isInline: true })
            )
          )
        ),
        (content || interview) && _react2.default.createElement(_Seperator2.default, null)
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      var Builder = (0, _imageUrl2.default)(Object.assign({}, nextProps.siteData.sanityConfig, {
        baseUrl: 'https://cdn.sanity.io'
      }));
      var controlPanel = (0, _utils.getControlPanelFromHost)(nextProps.host);
      return {
        logo: Builder.image(nextProps.host.logo).url(),
        controlPanel: controlPanel,
        controlPanelScreenshots: (controlPanel.screenshots || []).map(function (ss) {
          return {
            src: Builder.image(ss).url(),
            thumbnail: Builder.image(ss).fit('crop').width(240).height(140).focalPoint(0, 0).url(),
            thumbnailWidth: 240,
            thumbnailHeight: 140,
            srcset: [240, 360, 500, 750, 900, 1080, 1300, 1600].map(function (w) {
              return Builder.image(ss).fit('max').width(w).url() + ' ' + w + 'w';
            }),
            thumbnailCaption: ss.caption,
            caption: ss.caption
          };
        })
      };
    }
  }]);

  return Host;
}(_react.Component);

exports.default = (0, _reactStatic.withSiteData)((0, _reactStatic.withRouteData)((0, _styledComponents.withTheme)(Host)));

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// ==============================
// THEME
// ==============================

var theme = {};

// container
theme.container = {
	background: 'rgba(0, 0, 0, 0.8)',
	gutter: {
		horizontal: 10,
		vertical: 10
	},
	zIndex: 2001
};

// header
theme.header = {
	height: 40
};
theme.close = {
	fill: 'white'
};

// footer
theme.footer = {
	color: 'white',
	count: {
		color: 'rgba(255, 255, 255, 0.75)',
		fontSize: '0.85em'
	},
	height: 40,
	gutter: {
		horizontal: 0,
		vertical: 5
	}
};

// thumbnails
theme.thumbnail = {
	activeBorderColor: 'white',
	size: 50,
	gutter: 2
};

// arrow
theme.arrow = {
	background: 'none',
	fill: 'white',
	height: 120
};

exports.default = theme;

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(840);


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
    title: 'Visible',
    description: 'Should a host be visible in this game site',
    name: 'visible',
    type: 'boolean'
}, {
    title: 'Content',
    description: 'Host page main content',
    name: 'content',
    type: 'blockContent'
}, {
    title: 'Landing Page',
    description: 'If the host has a dedicated landing page for the game put it here. e.g. https://www.survivalservers.com/services/game_servers/ark_survival_evolved/',
    name: 'landingPageUrl',
    type: 'url'
}, {
    title: 'Order Page URL',
    description: "The URL on the 'Add to cart' button. Note: check the url on the actual button, not the url in the address bar after clicking it",
    name: 'orderUrl',
    type: 'url'
}, {
    title: 'Affiliate Url',
    name: 'affiliateUrl',
    description: 'Affiliate url for this specific game',
    type: 'url'
}, {
    title: 'Locations',
    description: 'All the locations where you can host an this game. Leave empty if the same as above locations. Overwrites the above locations.',
    name: 'locations',
    type: 'array',
    of: [{ type: 'location' }]
}, {
    title: 'Slots',
    name: 'slots',
    type: 'object',
    fields: [{
        title: 'Minimum',
        name: 'min',
        description: 'The smallest amount of slots available with this host for this game',
        type: 'number',
        validation: function validation(Rule) {
            return Rule.required().max(Rule.valueOfField('max'));
        }
    }, {
        title: 'Maximum',
        name: 'max',
        description: 'The biggest amount of slots available with this host for this game',
        type: 'number',
        validation: function validation(Rule) {
            return Rule.required().min(Rule.valueOfField('min'));
        }
    }]
}, {
    title: 'Prices',
    name: 'price',
    type: 'object',
    fields: [{
        title: 'Minimum',
        name: 'min',
        type: 'number',
        description: 'The minimum price per slot'
    }, {
        title: 'Maximum',
        name: 'max',
        type: 'number',
        description: 'The maximum price per slot. If the price per slot is the same across all number of slots, use the same value as minimum'
    }]
}, {
    title: 'Example packages',
    type: 'array',
    name: 'packages',
    of: [{
        type: 'object',
        fields: [{
            title: 'Slots',
            type: 'number',
            name: 'slots'
        }, {
            title: 'Price',
            description: 'Price per slot',
            type: 'number',
            name: 'price'
        }, {
            title: 'Total',
            description: 'Total price for package',
            type: 'number',
            name: 'total'
        }, {
            title: 'Location',
            type: 'string',
            name: 'location'
        }],
        preview: {
            select: {
                slots: 'slots',
                price: 'price',
                location: 'location',
                total: 'total'
            },
            prepare: function prepare(_ref) {
                var slots = _ref.slots,
                    price = _ref.price,
                    location = _ref.location,
                    total = _ref.total;
                return {
                    title: slots + ' Slots | ' + price + '/slot  |  ' + (total || price * slots) + '/mo  |  ' + location
                };
            }
        }
    }]
}, {
    title: 'Control Panel',
    name: 'controlPanel',
    type: 'object',
    fields: [{
        title: 'Type',
        name: 'type',
        type: 'string',
        description: 'What type of control panel is it?',
        options: {
            list: [{ title: 'TCAdmin', value: 'tcadmin' }, { title: 'Custom', value: 'custom' }]
        }
    }, {
        title: 'Screenshots',
        name: 'screenshots',
        type: 'array',
        description: 'Try to find images of the control panel. Ask via customer support channel for examples',
        of: [{
            type: 'image',
            fields: [{
                name: 'caption',
                type: 'string',
                title: 'Caption',
                options: {
                    isHighlighted: true
                }
            }]
        }]
    }]
}, {
    title: 'Platforms',
    name: 'platforms',
    type: 'array',
    of: [{ type: 'string' }],
    description: "Which platforms does this host support for this game? Note: Check that you can actually order now and it's not pre-order",
    options: {
        list: [{
            title: 'PC',
            value: 'pc'
        }, {
            title: 'PS4',
            value: 'playstation'
        }, {
            title: 'Xbox',
            value: 'xbox'
        }]
    }
}, {
    title: 'Mods Support',
    name: 'mods',
    type: 'object',
    fields: [{
        title: 'Supported',
        name: 'supported',
        type: 'boolean',
        description: 'Can you install mods with this host'
    }, {
        title: 'Mod Manager GUI',
        name: 'modManager',
        type: 'boolean',
        description: 'Does this host have a custom point and click mod manager gui? or is it though INI?'
    }, {
        title: 'Auto Updated',
        name: 'autoUpdate',
        type: 'boolean',
        description: 'Does this host have auto updating mods'
    }, {
        title: '1-Click Install',
        name: 'oneclick',
        type: 'boolean',
        description: 'Does the host have a 1-click mod install feature?'
    }, {
        title: 'Other notes',
        name: 'notes',
        type: 'text',
        description: 'Please specify other things you think are worth mentitiong.'
    }]
}, {
    title: 'Pros',
    name: 'pros',
    type: 'array',
    of: [{ type: 'string' }]
}, {
    title: 'Cons',
    name: 'cons',
    type: 'array',
    of: [{ type: 'string' }]
}, {
    title: 'Notes',
    name: 'notes',
    type: 'array',
    of: [{ type: 'string' }]
}];

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function deepMerge(target) {
	var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var extended = _extends({}, target);

	Object.keys(source).forEach(function (key) {
		if (_typeof(source[key]) !== 'object' || !source[key]) {
			extended[key] = source[key];
		} else {
			if (!target[key]) {
				extended[key] = source[key];
			} else {
				extended[key] = deepMerge(target[key], source[key]);
			}
		}
	});

	return extended;
}

exports.default = deepMerge;

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(852)();
}


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(744);

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = __webpack_require__(747);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_button2['default'].Group = _buttonGroup2['default'];
exports['default'] = _button2['default'];
module.exports = exports['default'];

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(33);

__webpack_require__(758);

/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return getCountries;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return getCountryCodes;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
  return getFlips;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
  return getRotates;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "e", function () {
  return getSizes;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__static_enums__ = __webpack_require__(797);

var getCountries = function getCountries() {
  return __WEBPACK_IMPORTED_MODULE_0__static_enums__["a" /* countries */];
};

var getCountryCodes = function getCountryCodes() {
  return __WEBPACK_IMPORTED_MODULE_0__static_enums__["a" /* countries */].map(function (country) {
    return country.code;
  });
};

var getFlips = function getFlips() {
  return __WEBPACK_IMPORTED_MODULE_0__static_enums__["b" /* flips */];
};

var getRotates = function getRotates() {
  return __WEBPACK_IMPORTED_MODULE_0__static_enums__["c" /* rotates */];
};

var getSizes = function getSizes() {
  return __WEBPACK_IMPORTED_MODULE_0__static_enums__["d" /* sizes */];
};

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

// returns a style object with a single concated prefixed value string

exports.default = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
    return replacer(prefix, value);
  }));
};

module.exports = exports['default'];

/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__classnames__ = __webpack_require__(794);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "makeClassnames", function () {
  return __WEBPACK_IMPORTED_MODULE_0__classnames__["a"];
});
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "makeClassesObject", function () {
  return __WEBPACK_IMPORTED_MODULE_0__classnames__["b"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(796);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "makeFlagIconOptions", function () {
  return __WEBPACK_IMPORTED_MODULE_1__options__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(726);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "makeStyles", function () {
  return __WEBPACK_IMPORTED_MODULE_2__styles__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__countries__ = __webpack_require__(799);
/* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "countries", function () {
  return __WEBPACK_IMPORTED_MODULE_3__countries__;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(724);
/* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "constants", function () {
  return __WEBPACK_IMPORTED_MODULE_4__constants__;
});

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// {K1: V1, K2: V2, ...} -> [[K1, V1], [K2, V2]]


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var objectToPairs = function objectToPairs(obj) {
    return Object.keys(obj).map(function (key) {
        return [key, obj[key]];
    });
};

exports.objectToPairs = objectToPairs;
// [[K1, V1], [K2, V2]] -> {K1: V1, K2: V2, ...}
var pairsToObject = function pairsToObject(pairs) {
    var result = {};
    pairs.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var key = _ref2[0];
        var val = _ref2[1];

        result[key] = val;
    });
    return result;
};

var mapObj = function mapObj(obj, fn) {
    return pairsToObject(objectToPairs(obj).map(fn));
};

exports.mapObj = mapObj;
// Flattens an array one level
// [[A], [B, C, [D]]] -> [A, B, C, [D]]
var flatten = function flatten(list) {
    return list.reduce(function (memo, x) {
        return memo.concat(x);
    }, []);
};

exports.flatten = flatten;
var UPPERCASE_RE = /([A-Z])/g;
var MS_RE = /^ms-/;

var kebabify = function kebabify(string) {
    return string.replace(UPPERCASE_RE, '-$1').toLowerCase();
};
var kebabifyStyleName = function kebabifyStyleName(string) {
    return kebabify(string).replace(MS_RE, '-ms-');
};

exports.kebabifyStyleName = kebabifyStyleName;
var recursiveMerge = function recursiveMerge(a, b) {
    // TODO(jlfwong): Handle malformed input where a and b are not the same
    // type.

    if (typeof a !== 'object') {
        return b;
    }

    var ret = _extends({}, a);

    Object.keys(b).forEach(function (key) {
        if (ret.hasOwnProperty(key)) {
            ret[key] = recursiveMerge(a[key], b[key]);
        } else {
            ret[key] = b[key];
        }
    });

    return ret;
};

exports.recursiveMerge = recursiveMerge;
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */
var isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,

    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};

/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js
Object.keys(isUnitlessNumber).forEach(function (prop) {
    prefixes.forEach(function (prefix) {
        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
    });
});

var stringifyValue = function stringifyValue(key, prop) {
    if (typeof prop === "number") {
        if (isUnitlessNumber[key]) {
            return "" + prop;
        } else {
            return prop + "px";
        }
    } else {
        return prop;
    }
};

exports.stringifyValue = stringifyValue;
/**
 * JS Implementation of MurmurHash2
 *
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 *
 * @param {string} str ASCII only
 * @return {string} Base 36 encoded hash result
 */
function murmurhash2_32_gc(str) {
    var l = str.length;
    var h = l;
    var i = 0;
    var k = undefined;

    while (l >= 4) {
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

        l -= 4;
        ++i;
    }

    switch (l) {
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }

    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;

    return (h >>> 0).toString(36);
}

// Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.
var hashObject = function hashObject(object) {
    return murmurhash2_32_gc(JSON.stringify(object));
};

exports.hashObject = hashObject;
var IMPORTANT_RE = /^([^:]+:.*?)( !important)?;$/;

// Given a single style rule string like "a: b;", adds !important to generate
// "a: b !important;".
var importantify = function importantify(string) {
    return string.replace(IMPORTANT_RE, function (_, base, important) {
        return base + " !important;";
    });
};
exports.importantify = importantify;

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(782);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /*
   * React FitText
   * https://github.com/kennethormandy/react-fittext
   * Kenneth Ormandy
   * 
   * A rewrite of https://github.com/gianu/react-fittext (MIT)
   * …which is based on the FitText jQuery plugin
   * http://github.com/davatron5000/FitText.js
   *
   */

var FitText = function (_React$Component) {
  _inherits(FitText, _React$Component);

  function FitText(props) {
    _classCallCheck(this, FitText);

    var _this = _possibleConstructorReturn(this, (FitText.__proto__ || Object.getPrototypeOf(FitText)).call(this, props));

    var defaultFontSize = props.defaultFontSize;

    if (typeof props.defaultFontSize === 'number') {
      defaultFontSize = props.defaultFontSize + 'px';
    }

    _this.state = {
      fontSize: defaultFontSize
    };

    _this._onBodyResize = _this._onBodyResize.bind(_this);
    _this._parentNode = null;
    return _this;
  }

  _createClass(FitText, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // When a new parent ID is passed in, or the new parentNode
      // is available, run resize again
      if (this.props.parent !== prevProps.parent) {
        this._onBodyResize();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (0 >= this.props.compressor) {
        console.warn('Warning: The compressor should be greater than 0.');
      }

      if (this.props.parent) {
        this._parentNode = typeof this.props.parent === 'string' ? document.getElementById(this.props.parent) : this.props.parent;
      }

      window.addEventListener('resize', (0, _lodash2.default)(this._onBodyResize, this.props.debounce));
      this._onBodyResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', (0, _lodash2.default)(this._onBodyResize, this.props.debounce));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      // If the new fontSize is the same as the old one,
      // don’t bother re-rendering.
      if (nextState.fontSize === this.state.fontSize) {
        return false;
      }

      return true;
    }
  }, {
    key: '_getFontSize',
    value: function _getFontSize(value) {
      var props = this.props;

      return Math.max(Math.min(value / (props.compressor * 10), props.maxFontSize), props.minFontSize);
    }
  }, {
    key: '_onBodyResize',
    value: function _onBodyResize() {
      if (this.element && this.element.offsetWidth) {
        var value = this.element.offsetWidth;

        if (this.props.vertical) {
          var parent = this._parentNode || this.element.parentNode;
          value = parent.offsetHeight;
        }

        var newFontSize = this._getFontSize(value);

        this.setState({
          fontSize: newFontSize + 'px'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        ref: function ref(el) {
          return _this2.element = el;
        },
        style: { fontSize: this.state.fontSize } }, this.props.children);
    }
  }]);

  return FitText;
}(_react2.default.Component);

FitText.defaultProps = {
  compressor: 1.0,
  debounce: 100,
  defaultFontSize: 'inherit',
  minFontSize: Number.NEGATIVE_INFINITY,
  maxFontSize: Number.POSITIVE_INFINITY
};

FitText.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  compressor: _propTypes2.default.number,
  debounce: _propTypes2.default.number,
  defaultFontSize: _propTypes2.default.string,
  minFontSize: _propTypes2.default.number,
  maxFontSize: _propTypes2.default.number,
  parent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = FitText;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var _Event = __webpack_require__(745);

var _Event2 = _interopRequireDefault(_Event);

var _raf = __webpack_require__(746);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styleForPesudo = void 0;
// Where el is the DOM element you'd like to test for visibility
function isHidden(element) {
    if (false) {
        return false;
    }
    return !element || element.offsetParent === null;
}

var Wave = function (_React$Component) {
    (0, _inherits3['default'])(Wave, _React$Component);

    function Wave() {
        (0, _classCallCheck3['default'])(this, Wave);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Wave.__proto__ || Object.getPrototypeOf(Wave)).apply(this, arguments));

        _this.animationStart = false;
        _this.destroy = false;
        _this.onClick = function (node, waveColor) {
            if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
                return;
            }
            var insertExtraNode = _this.props.insertExtraNode;

            _this.extraNode = document.createElement('div');
            var extraNode = _this.extraNode;
            extraNode.className = 'ant-click-animating-node';
            var attributeName = _this.getAttributeName();
            node.removeAttribute(attributeName);
            node.setAttribute(attributeName, 'true');
            // Not white or transparnt or grey
            styleForPesudo = styleForPesudo || document.createElement('style');
            if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && _this.isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== 'transparent') {
                extraNode.style.borderColor = waveColor;
                styleForPesudo.innerHTML = '[ant-click-animating-without-extra-node]:after { border-color: ' + waveColor + '; }';
                if (!document.body.contains(styleForPesudo)) {
                    document.body.appendChild(styleForPesudo);
                }
            }
            if (insertExtraNode) {
                node.appendChild(extraNode);
            }
            _Event2['default'].addStartEventListener(node, _this.onTransitionStart);
            _Event2['default'].addEndEventListener(node, _this.onTransitionEnd);
        };
        _this.bindAnimationEvent = function (node) {
            if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
                return;
            }
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
                    return;
                }
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
                getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
                _this.clickWaveTimeoutId = window.setTimeout(function () {
                    return _this.onClick(node, waveColor);
                }, 0);
                _raf2['default'].cancel(_this.animationStartId);
                _this.animationStart = true;
                // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
                _this.animationStartId = (0, _raf2['default'])(function () {
                    _this.animationStart = false;
                }, 10);
            };
            node.addEventListener('click', onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener('click', onClick, true);
                }
            };
        };
        _this.onTransitionStart = function (e) {
            if (_this.destroy) return;
            var node = (0, _reactDom.findDOMNode)(_this);
            if (!e || e.target !== node) {
                return;
            }
            if (!_this.animationStart) {
                _this.resetEffect(node);
            }
        };
        _this.onTransitionEnd = function (e) {
            if (!e || e.animationName !== 'fadeEffect') {
                return;
            }
            _this.resetEffect(e.target);
        };
        return _this;
    }

    (0, _createClass3['default'])(Wave, [{
        key: 'isNotGrey',
        value: function isNotGrey(color) {
            var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
            if (match && match[1] && match[2] && match[3]) {
                return !(match[1] === match[2] && match[2] === match[3]);
            }
            return true;
        }
    }, {
        key: 'getAttributeName',
        value: function getAttributeName() {
            var insertExtraNode = this.props.insertExtraNode;

            return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
        }
    }, {
        key: 'resetEffect',
        value: function resetEffect(node) {
            if (!node || node === this.extraNode || !(node instanceof Element)) {
                return;
            }
            var insertExtraNode = this.props.insertExtraNode;

            var attributeName = this.getAttributeName();
            node.removeAttribute(attributeName);
            this.removeExtraStyleNode();
            if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
                node.removeChild(this.extraNode);
            }
            _Event2['default'].removeStartEventListener(node, this.onTransitionStart);
            _Event2['default'].removeEndEventListener(node, this.onTransitionEnd);
        }
    }, {
        key: 'removeExtraStyleNode',
        value: function removeExtraStyleNode() {
            if (styleForPesudo) {
                styleForPesudo.innerHTML = '';
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var node = (0, _reactDom.findDOMNode)(this);
            if (node.nodeType !== 1) {
                return;
            }
            this.instance = this.bindAnimationEvent(node);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.instance) {
                this.instance.cancel();
            }
            if (this.clickWaveTimeoutId) {
                clearTimeout(this.clickWaveTimeoutId);
            }
            this.destroy = true;
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);
    return Wave;
}(React.Component);

exports['default'] = Wave;
module.exports = exports['default'];

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pattern = __webpack_require__(720);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Patterend = _styledComponents2.default.div.withConfig({
    displayName: 'Seperator__Patterend'
})(['background-repeat:repeat;background-image:url(', ');height:', ';background-color:#4d4d4d;box-shadow:inset 0px 1px 10px 3px rgba(0,0,0,0.65);'], _pattern2.default, function (props) {
    return props.h ? parseFloat(props.h) + 'px' : '30px';
});

var Seperator = function (_Component) {
    _inherits(Seperator, _Component);

    function Seperator() {
        _classCallCheck(this, Seperator);

        return _possibleConstructorReturn(this, (Seperator.__proto__ || Object.getPrototypeOf(Seperator)).apply(this, arguments));
    }

    _createClass(Seperator, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(Patterend, this.props);
        }
    }]);

    return Seperator;
}(_react.Component);

exports.default = Seperator;

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImW3KsREAIBDDMIVhfyiWDQUdhysVDgbablie0vYime9xAFJvB2oasN26AAAAAElFTkSuQmCC"

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _tooltip = __webpack_require__(265);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Popover = function (_React$Component) {
    (0, _inherits3['default'])(Popover, _React$Component);

    function Popover() {
        (0, _classCallCheck3['default'])(this, Popover);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));

        _this.saveTooltip = function (node) {
            _this.tooltip = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Popover, [{
        key: 'getPopupDomNode',
        value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
        }
    }, {
        key: 'getOverlay',
        value: function getOverlay() {
            var _props = this.props,
                title = _props.title,
                prefixCls = _props.prefixCls,
                content = _props.content;

            (0, _warning2['default'])(!('overlay' in this.props), 'Popover[overlay] is removed, please use Popover[content] instead, ' + 'see: https://u.ant.design/popover-content');
            return React.createElement(
                'div',
                null,
                title && React.createElement(
                    'div',
                    { className: prefixCls + '-title' },
                    title
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-inner-content' },
                    content
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var props = (0, _extends3['default'])({}, this.props);
            delete props.title;
            return React.createElement(_tooltip2['default'], (0, _extends3['default'])({}, props, { ref: this.saveTooltip, overlay: this.getOverlay() }));
        }
    }]);
    return Popover;
}(React.Component);

exports['default'] = Popover;

Popover.defaultProps = {
    prefixCls: 'ant-popover',
    placement: 'top',
    transitionName: 'zoom-big',
    trigger: 'hover',
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    overlayStyle: {}
};
module.exports = exports['default'];

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(33);

__webpack_require__(790);

/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "baseThemeStyleName", function () {
  return baseThemeStyleName;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flagIconClassesPrefixName", function () {
  return flagIconClassesPrefixName;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flagIconClassesPrefix", function () {
  return flagIconClassesPrefix;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flagIconModulePath", function () {
  return flagIconModulePath;
});

var baseThemeStyleName = 'theme-base';
var flagIconClassesPrefixName = 'flag-icon';
var flagIconClassesPrefix = flagIconClassesPrefixName + '-';
var flagIconModulePath = 'node_modules/flag-icon-css';

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export MakeFlagIconPropsType */
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return MakeFlagIconOptionsPropType;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__functions_props__ = __webpack_require__(707);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__functions_propTypes__ = __webpack_require__(798);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var FlagIconSizeType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object(__WEBPACK_IMPORTED_MODULE_1__functions_props__["e" /* getSizes */])());
var FlagIconRotateType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object(__WEBPACK_IMPORTED_MODULE_1__functions_props__["d" /* getRotates */])());
var FlagIconFlipType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object(__WEBPACK_IMPORTED_MODULE_1__functions_props__["c" /* getFlips */])());

var makeFlagIconCodeType = function makeFlagIconCodeType(codes) {
  return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(codes);
};

var makeFlagIconClassesObject = function makeFlagIconClassesObject(codes) {
  return {
    code: makeFlagIconCodeType(codes).isRequired,
    size: FlagIconSizeType,
    squared: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    rotate: FlagIconRotateType,
    flip: FlagIconFlipType,
    className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    styleName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  };
};

var makeFlagIconPropsTypeObject = function makeFlagIconPropsTypeObject(codes) {
  return _extends({}, makeFlagIconClassesObject(codes), {
    children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element,
    Component: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  });
};

var MakeFlagIconPropsType = function MakeFlagIconPropsType(codes) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__functions_propTypes__["a" /* AddExactValidator */])(makeFlagIconPropsTypeObject(codes));
};

var flagIconOptionsType = {
  customCodes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  themeStyles: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  useCssModules: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var MakeFlagIconOptionsPropType = function MakeFlagIconOptionsPropType() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__functions_propTypes__["a" /* AddExactValidator */])(Object(__WEBPACK_IMPORTED_MODULE_2__functions_propTypes__["b" /* AddThemeStylesValidator */])(flagIconOptionsType));
};

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

/* unused harmony export validateStyles */
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var validateStyles = function validateStyles(styles, computedOptions, options) {
  if (false) {
    if (!computedOptions) throw Error('Passing `computedOptions` is required.');
    if (!computedOptions.useCssModules) {
      throw Error('Cannot validate global CSS.');
    }

    var userSetUseCssModules = options ? options.useCssModules : false;

    if (!Object.prototype.hasOwnProperty.call(styles, 'flag-icon')) {
      var readme = 'https://github.com/matteocng/react-flag-icon-css/blob/master/README.md';
      var readmeModules = 'https://github.com/gajus/react-css-modules#usage';

      console.error('Warning: Detected configuration mismatch/error: [react-flag-icon-css] FlagIconFactory tried to build FlagIcon with the option \'useCssModules\' set to true (' + (userSetUseCssModules ? 'by you' : 'default') + '), but it seems that your environment is not loading the stylesheets in the appropriate way. Two possibilities: \n\n 1. Your project is not using CSS Modules / you don\'t want to use them. Try building FlagIcon like this: \n\n\timport * as React from \'react\' \n\n\tconst FlagIcon = FlagIconFactory(React, { useCssModules: false }) \n\n\tSee the README for more info: ' + readme + ' \n\n 2. You are using CSS Modules but your module bundler e.g Webpack is not correctly set up for CSS modules. If you are using Webpack, the key modules to set up are \'style-loader\', \'css-loader\' and \'extract-text-webpack-plugin\' (\'sass-loader\' also comes into play if you are using SASS). The link below may help you:\n\n\t' + readmeModules);
    }
  }
};

/* harmony default export */__webpack_exports__["a"] = function (styles, options) {
  return options && options.themeStyles ? _extends({}, styles, options.themeStyles) : styles;
};

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Check = _styledCommon.Icons.Check;
var Li = _styledComponents2.default.li.withConfig({
  displayName: 'CheckListCell__Li'
})(['.svg-icon{height:1.3em;vertical-align:sub;}']);
var StCell = (0, _styledComponents2.default)(_styledCommon.Cell).withConfig({
  displayName: 'CheckListCell__StCell'
})(['justify-content:start;']);

var CheckListCell = function (_React$PureComponent) {
  _inherits(CheckListCell, _React$PureComponent);

  function CheckListCell() {
    _classCallCheck(this, CheckListCell);

    return _possibleConstructorReturn(this, (CheckListCell.__proto__ || Object.getPrototypeOf(CheckListCell)).apply(this, arguments));
  }

  _createClass(CheckListCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          props = _objectWithoutProperties(_props, ['list']);

      var items = list && list.map ? list.map(function (i, ix) {
        return _react2.default.createElement(
          Li,
          { key: ix },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(Check, null),
            ' ',
            i
          )
        );
      }) : null;
      return _react2.default.createElement(
        StCell,
        props,
        _react2.default.createElement(
          'ul',
          null,
          items
        )
      );
    }
  }]);

  return CheckListCell;
}(_react2.default.PureComponent);

exports.default = CheckListCell;

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _util = __webpack_require__(710);

var _inject = __webpack_require__(729);

var StyleSheet = {
    create: function create(sheetDefinition) {
        return (0, _util.mapObj)(sheetDefinition, function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var val = _ref2[1];

            return [key, {
                // TODO(emily): Make a 'production' mode which doesn't prepend
                // the class name here, to make the generated CSS smaller.
                _name: key + '_' + (0, _util.hashObject)(val),
                _definition: val
            }];
        });
    },

    rehydrate: function rehydrate() {
        var renderedClassNames = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

        (0, _inject.addRenderedClassNames)(renderedClassNames);
    }
};

/**
 * Utilities for using Aphrodite server-side.
 */
var StyleSheetServer = {
    renderStatic: function renderStatic(renderFunc) {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
        var html = renderFunc();
        var cssContent = (0, _inject.flushToString)();

        return {
            html: html,
            css: {
                content: cssContent,
                renderedClassNames: (0, _inject.getRenderedClassNames)()
            }
        };
    }
};

/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */
var StyleSheetTestUtils = {
    /**
     * Prevent styles from being injected into the DOM.
     *
     * This is useful in situations where you'd like to test rendering UI
     * components which use Aphrodite without any of the side-effects of
     * Aphrodite happening. Particularly useful for testing the output of
     * components when you have no DOM, e.g. testing in Node without a fake DOM.
     *
     * Should be paired with a subsequent call to
     * clearBufferAndResumeStyleInjection.
     */
    suppressStyleInjection: function suppressStyleInjection() {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
    },

    /**
     * Opposite method of preventStyleInject.
     */
    clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
        (0, _inject.reset)();
    }
};

var css = function css() {
    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
    }

    var useImportant = true; // Append !important to all style definitions
    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports['default'] = {
    StyleSheet: StyleSheet,
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    css: css
};
module.exports = exports['default'];

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _asap = __webpack_require__(818);

var _asap2 = _interopRequireDefault(_asap);

var _generate = __webpack_require__(820);

var _util = __webpack_require__(710);

// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.
var styleTag = null;

// Inject a string of styles into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.
var injectStyleTag = function injectStyleTag(cssContents) {
    if (styleTag == null) {
        // Try to find a style tag with the `data-aphrodite` attribute first.
        styleTag = document.querySelector("style[data-aphrodite]");

        // If that doesn't work, generate a new style tag.
        if (styleTag == null) {
            // Taken from
            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
            var head = document.head || document.getElementsByTagName('head')[0];
            styleTag = document.createElement('style');

            styleTag.type = 'text/css';
            styleTag.setAttribute("data-aphrodite", "");
            head.appendChild(styleTag);
        }
    }

    if (styleTag.styleSheet) {
        styleTag.styleSheet.cssText += cssContents;
    } else {
        styleTag.appendChild(document.createTextNode(cssContents));
    }
};

// Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)
var stringHandlers = {
    // With fontFamily we look for objects that are passed in and interpret
    // them as @font-face rules that we need to inject. The value of fontFamily
    // can either be a string (as normal), an object (a single font face), or
    // an array of objects and strings.
    fontFamily: function fontFamily(val) {
        if (Array.isArray(val)) {
            return val.map(fontFamily).join(",");
        } else if (typeof val === "object") {
            injectStyleOnce(val.fontFamily, "@font-face", [val], false);
            return '"' + val.fontFamily + '"';
        } else {
            return val;
        }
    },

    // With animationName we look for an object that contains keyframes and
    // inject them as an `@keyframes` block, returning a uniquely generated
    // name. The keyframes object should look like
    //  animationName: {
    //    from: {
    //      left: 0,
    //      top: 0,
    //    },
    //    '50%': {
    //      left: 15,
    //      top: 5,
    //    },
    //    to: {
    //      left: 20,
    //      top: 20,
    //    }
    //  }
    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
    // to use `animationName` here. Improve that so we can call this
    // `animation` instead of `animationName`.
    animationName: function animationName(val) {
        if (typeof val !== "object") {
            return val;
        }

        // Generate a unique name based on the hash of the object. We can't
        // just use the hash because the name can't start with a number.
        // TODO(emily): this probably makes debugging hard, allow a custom
        // name?
        var name = 'keyframe_' + (0, _util.hashObject)(val);

        // Since keyframes need 3 layers of nesting, we use `generateCSS` to
        // build the inner layers and wrap it in `@keyframes` ourselves.
        var finalVal = '@keyframes ' + name + '{';
        Object.keys(val).forEach(function (key) {
            finalVal += (0, _generate.generateCSS)(key, [val[key]], stringHandlers, false);
        });
        finalVal += '}';

        injectGeneratedCSSOnce(name, finalVal);

        return name;
    }
};

// This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)
var alreadyInjected = {};

// This is the buffer of styles which have not yet been flushed.
var injectionBuffer = "";

// A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.
var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
    if (!alreadyInjected[key]) {
        if (!isBuffering) {
            // We should never be automatically buffering on the server (or any
            // place without a document), so guard against that.
            if (typeof document === "undefined") {
                throw new Error("Cannot automatically buffer without a document");
            }

            // If we're not already buffering, schedule a call to flush the
            // current styles.
            isBuffering = true;
            (0, _asap2['default'])(flushToStyleTag);
        }

        injectionBuffer += generatedCSS;
        alreadyInjected[key] = true;
    }
};

var injectStyleOnce = function injectStyleOnce(key, selector, definitions, useImportant) {
    if (!alreadyInjected[key]) {
        var generated = (0, _generate.generateCSS)(selector, definitions, stringHandlers, useImportant);

        injectGeneratedCSSOnce(key, generated);
    }
};

exports.injectStyleOnce = injectStyleOnce;
var reset = function reset() {
    injectionBuffer = "";
    alreadyInjected = {};
    isBuffering = false;
    styleTag = null;
};

exports.reset = reset;
var startBuffering = function startBuffering() {
    if (isBuffering) {
        throw new Error("Cannot buffer while already buffering");
    }
    isBuffering = true;
};

exports.startBuffering = startBuffering;
var flushToString = function flushToString() {
    isBuffering = false;
    var ret = injectionBuffer;
    injectionBuffer = "";
    return ret;
};

exports.flushToString = flushToString;
var flushToStyleTag = function flushToStyleTag() {
    var cssContent = flushToString();
    if (cssContent.length > 0) {
        injectStyleTag(cssContent);
    }
};

exports.flushToStyleTag = flushToStyleTag;
var getRenderedClassNames = function getRenderedClassNames() {
    return Object.keys(alreadyInjected);
};

exports.getRenderedClassNames = getRenderedClassNames;
var addRenderedClassNames = function addRenderedClassNames(classNames) {
    classNames.forEach(function (className) {
        alreadyInjected[className] = true;
    });
};

exports.addRenderedClassNames = addRenderedClassNames;
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {Object[]} styleDefinitions style definition objects as returned as
 *     properties of the return value of StyleSheet.create().
 */
var injectAndGetClassName = function injectAndGetClassName(useImportant, styleDefinitions) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    var validDefinitions = styleDefinitions.filter(function (def) {
        return def;
    });

    // Break if there aren't any valid styles.
    if (validDefinitions.length === 0) {
        return "";
    }

    var className = validDefinitions.map(function (s) {
        return s._name;
    }).join("-o_O-");
    injectStyleOnce(className, '.' + className, validDefinitions.map(function (d) {
        return d._definition;
    }), useImportant);

    return className;
};
exports.injectAndGetClassName = injectAndGetClassName;

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// create defaults
var defaultProps = exports.defaultProps = {
  attributes: {},
  styles: {}
};

var PropToggle = function (_PureComponent) {
  _inherits(PropToggle, _PureComponent);

  function PropToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PropToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropToggle.__proto__ || Object.getPrototypeOf(PropToggle)).call.apply(_ref, [this].concat(args))), _this), _this.originalAttributes = {}, _this.originalStyles = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PropToggle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          attributes = _props.attributes,
          styles = _props.styles,
          _props$target = _props.target,
          target = _props$target === undefined ? document.body : _props$target;

      if (!target) return;

      this.attributeKeys = Object.keys(attributes);
      this.styleKeys = Object.keys(styles);

      // styles
      if (this.styleKeys.length) {
        this.styleKeys.forEach(function (k) {
          _this2.originalStyles[k] = target.style.getPropertyValue(k);
          target.style.setProperty(k, styles[k]);
        });
      }

      // attributes
      if (this.attributeKeys.length) {
        this.attributeKeys.forEach(function (k) {
          _this2.originalAttributes[k] = target.getAttribute(k) || '';
          target.setAttribute(k, attributes[k]);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      var _props$target2 = this.props.target,
          target = _props$target2 === undefined ? document.body : _props$target2;

      if (!target) return;

      // styles
      if (this.styleKeys.length) {
        this.styleKeys.forEach(function (k) {
          target.style.setProperty(k, _this3.originalStyles[k]);
        });
      }

      // attributes
      if (this.attributeKeys.length) {
        this.attributeKeys.forEach(function (k) {
          if (_this3.originalAttributes[k]) {
            target.setAttribute(k, _this3.originalAttributes[k]);
          } else {
            target.removeAttribute(k);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return PropToggle;
}(_react.PureComponent);

PropToggle.defaultProps = defaultProps;
exports.default = PropToggle;

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (!window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (!document || !window) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

var _Icon = __webpack_require__(735);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Arrow(_ref, _ref2) {
	var theme = _ref2.theme;

	var direction = _ref.direction,
	    icon = _ref.icon,
	    onClick = _ref.onClick,
	    size = _ref.size,
	    props = _objectWithoutProperties(_ref, ['direction', 'icon', 'onClick', 'size']);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement(
		'button',
		_extends({
			type: 'button',
			className: (0, _noImportant.css)(classes.arrow, classes['arrow__direction__' + direction], size && classes['arrow__size__' + size]),
			onClick: onClick,
			onTouchEnd: onClick
		}, props),
		_react2.default.createElement(_Icon2.default, { fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill, type: icon })
	);
}

Arrow.propTypes = {
	direction: _propTypes2.default.oneOf(['left', 'right']),
	icon: _propTypes2.default.string,
	onClick: _propTypes2.default.func.isRequired,
	size: _propTypes2.default.oneOf(['medium', 'small']).isRequired
};
Arrow.defaultProps = {
	size: 'medium'
};
Arrow.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	arrow: {
		background: 'none',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		outline: 'none',
		padding: 10, // increase hit area
		position: 'absolute',
		top: '50%',

		// disable user select
		WebkitTouchCallout: 'none',
		userSelect: 'none'
	},

	// sizes
	arrow__size__medium: {
		height: _theme2.default.arrow.height,
		marginTop: _theme2.default.arrow.height / -2,
		width: 40,

		'@media (min-width: 768px)': {
			width: 70
		}
	},
	arrow__size__small: {
		height: _theme2.default.thumbnail.size,
		marginTop: _theme2.default.thumbnail.size / -2,
		width: 30,

		'@media (min-width: 500px)': {
			width: 40
		}
	},

	// direction
	arrow__direction__right: {
		right: _theme2.default.container.gutter.horizontal
	},
	arrow__direction__left: {
		left: _theme2.default.container.gutter.horizontal
	}
};

exports.default = Arrow;

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _arrowLeft = __webpack_require__(841);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = __webpack_require__(842);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _close = __webpack_require__(843);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = { arrowLeft: _arrowLeft2.default, arrowRight: _arrowRight2.default, close: _close2.default };

var Icon = function Icon(_ref) {
	var fill = _ref.fill,
	    type = _ref.type,
	    props = _objectWithoutProperties(_ref, ['fill', 'type']);

	var icon = icons[type];

	return _react2.default.createElement('span', _extends({
		dangerouslySetInnerHTML: { __html: icon(fill) }
	}, props));
};

Icon.propTypes = {
	fill: _propTypes2.default.string,
	type: _propTypes2.default.oneOf(Object.keys(icons))
};
Icon.defaultProps = {
	fill: 'white'
};

exports.default = Icon;

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(704);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(89);

var _PropTypes = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(704);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(704);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(89);

var _ChildMapping = __webpack_require__(858);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(38);

var PropTypes = _interopRequireWildcard(_propTypes);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _wave = __webpack_require__(713);

var _wave2 = _interopRequireDefault(_wave);

var _icon = __webpack_require__(75);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child == null) {
        return;
    }
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
        return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
    }
    if (typeof child === 'string') {
        if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
        }
        return React.createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button(props) {
        (0, _classCallCheck3['default'])(this, Button);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.saveButtonRef = function (node) {
            _this.buttonNode = node;
        };
        _this.handleClick = function (e) {
            var loading = _this.state.loading;
            var onClick = _this.props.onClick;

            if (!!loading) {
                return;
            }
            if (onClick) {
                onClick(e);
            }
        };
        _this.state = {
            loading: props.loading,
            hasTwoCNChar: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Button, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentLoading = this.props.loading;
            var loading = nextProps.loading;
            if (currentLoading) {
                clearTimeout(this.delayTimeout);
            }
            if (typeof loading !== 'boolean' && loading && loading.delay) {
                this.delayTimeout = window.setTimeout(function () {
                    return _this2.setState({ loading: loading });
                }, loading.delay);
            } else {
                this.setState({ loading: loading });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
            }
        }
    }, {
        key: 'fixTwoCNChar',
        value: function fixTwoCNChar() {
            // Fix for HOC usage like <FormatMessage />
            if (!this.buttonNode) {
                return;
            }
            var buttonText = this.buttonNode.textContent || this.buttonNode.innerText;
            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
                if (!this.state.hasTwoCNChar) {
                    this.setState({
                        hasTwoCNChar: true
                    });
                }
            } else if (this.state.hasTwoCNChar) {
                this.setState({
                    hasTwoCNChar: false
                });
            }
        }
    }, {
        key: 'isNeedInserted',
        value: function isNeedInserted() {
            var _props = this.props,
                icon = _props.icon,
                children = _props.children;

            return React.Children.count(children) === 1 && !icon;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _a = this.props,
                type = _a.type,
                shape = _a.shape,
                size = _a.size,
                className = _a.className,
                children = _a.children,
                icon = _a.icon,
                prefixCls = _a.prefixCls,
                ghost = _a.ghost,
                _loadingProp = _a.loading,
                block = _a.block,
                rest = __rest(_a, ["type", "shape", "size", "className", "children", "icon", "prefixCls", "ghost", "loading", "block"]);var _state = this.state,
                loading = _state.loading,
                hasTwoCNChar = _state.hasTwoCNChar;
            // large => lg
            // small => sm

            var sizeCls = '';
            switch (size) {
                case 'large':
                    sizeCls = 'lg';
                    break;
                case 'small':
                    sizeCls = 'sm';
                default:
                    break;
            }
            var now = new Date();
            var isChristmas = now.getMonth() === 11 && now.getDate() === 25;
            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), (0, _defineProperty3['default'])(_classNames, prefixCls + '-block', block), (0, _defineProperty3['default'])(_classNames, 'christmas', isChristmas), _classNames));
            var iconType = loading ? 'loading' : icon;
            var iconNode = iconType ? React.createElement(_icon2['default'], { type: iconType }) : null;
            var kids = children || children === 0 ? React.Children.map(children, function (child) {
                return insertSpace(child, _this3.isNeedInserted());
            }) : null;
            var title = isChristmas ? 'Ho Ho Ho!' : rest.title;
            var linkButtonRestProps = rest;
            if (linkButtonRestProps.href !== undefined) {
                return React.createElement(
                    'a',
                    (0, _extends3['default'])({}, linkButtonRestProps, { className: classes, onClick: this.handleClick, title: title, ref: this.saveButtonRef }),
                    iconNode,
                    kids
                );
            }
            // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
            var _b = rest,
                htmlType = _b.htmlType,
                otherProps = __rest(_b, ["htmlType"]);
            return React.createElement(
                _wave2['default'],
                null,
                React.createElement(
                    'button',
                    (0, _extends3['default'])({}, otherProps, { type: htmlType || 'button', className: classes, onClick: this.handleClick, title: title, ref: this.saveButtonRef }),
                    iconNode,
                    kids
                )
            );
        }
    }]);
    return Button;
}(React.Component);

exports['default'] = Button;

Button.__ANT_BUTTON = true;
Button.defaultProps = {
    prefixCls: 'ant-btn',
    loading: false,
    ghost: false,
    block: false
};
Button.propTypes = {
    type: PropTypes.string,
    shape: PropTypes.oneOf(['circle', 'circle-outline']),
    size: PropTypes.oneOf(['large', 'default', 'small']),
    htmlType: PropTypes.oneOf(['submit', 'button', 'reset']),
    onClick: PropTypes.func,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    className: PropTypes.string,
    icon: PropTypes.string,
    block: PropTypes.bool
};
module.exports = exports['default'];

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = wrapperRaf;

var _raf = __webpack_require__(92);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var id = 0;
var ids = {};
// Support call raf with delay specified frame
function wrapperRaf(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var myId = id++;
    var restFrames = delayFrames;
    function internalCallback() {
        restFrames -= 1;
        if (restFrames <= 0) {
            callback();
            delete ids[id];
        } else {
            ids[id] = (0, _raf2['default'])(internalCallback);
        }
    }
    ids[id] = (0, _raf2['default'])(internalCallback);
    return myId;
}
wrapperRaf.cancel = function (id) {
    _raf2['default'].cancel(ids[id]);
    delete ids[id];
};
module.exports = exports['default'];

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ButtonGroup = function ButtonGroup(props) {
    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);
    // large => lg
    // small => sm


    var sizeCls = '';
    switch (size) {
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
        default:
            break;
    }
    var classes = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + sizeCls, sizeCls), className);
    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classes }));
};
exports['default'] = ButtonGroup;
module.exports = exports['default'];

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var deburr = __webpack_require__(783);
var escapeStringRegexp = __webpack_require__(784);
var builtinReplacements = __webpack_require__(785);
var builtinOverridableReplacements = __webpack_require__(786);

var decamelize = function decamelize(string) {
	return string.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var doCustomReplacements = function doCustomReplacements(string, replacements) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = _slicedToArray(_ref, 2);

			var key = _ref2[0];
			var value = _ref2[1];

			string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return string;
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
	return string.replace(new RegExp(separator + '{2,}', 'g'), separator).replace(new RegExp('^' + separator + '|' + separator + '$', 'g'), '');
};

module.exports = function (string, options) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string, got `' + (typeof string === 'undefined' ? 'undefined' : _typeof(string)) + '`');
	}

	options = Object.assign({
		separator: '-',
		lowercase: true,
		decamelize: true,
		customReplacements: []
	}, options);

	var separator = escapeStringRegexp(options.separator);
	var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements), _toConsumableArray(builtinReplacements)));

	string = doCustomReplacements(string, customReplacements);
	string = deburr(string);
	string = string.normalize('NFKD');

	if (options.decamelize) {
		string = decamelize(string);
	}

	var patternSlug = /[^a-zA-Z\d]+/g;

	if (options.lowercase) {
		string = string.toLowerCase();
		patternSlug = /[^a-z\d]+/g;
	}

	string = string.replace(patternSlug, separator);
	string = string.replace(/\\/g, '');
	string = removeMootSeparators(string, separator);

	return string;
};

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    regions: {
        af: 'Africa',
        as: 'Asia',
        eu: 'Europe',
        na: 'North America',
        oc: 'Oceania',
        sa: 'South America'
    },
    countries: {
        ad: {
            name: 'Andorra',
            native: 'Andorra',
            phone: '376',
            region: 'EU',
            capital: 'Andorra la Vella',
            currency: 'EUR',
            languages: { '0': 'ca' },
            emoji: '🇦🇩',
            emojiu: 'U+1F1E6 U+1F1E9'
        },
        ae: {
            name: 'United Arab Emirates',
            native: 'دولة الإمارات العربية المتحدة',
            phone: '971',
            region: 'AS',
            capital: 'Abu Dhabi',
            currency: 'AED',
            languages: { '0': 'ar' },
            emoji: '🇦🇪',
            emojiu: 'U+1F1E6 U+1F1EA'
        },
        af: {
            name: 'Afghanistan',
            native: 'افغانستان',
            phone: '93',
            region: 'AS',
            capital: 'Kabul',
            currency: 'AFN',
            languages: { '0': 'ps', '1': 'uz', '2': 'tk' },
            emoji: '🇦🇫',
            emojiu: 'U+1F1E6 U+1F1EB'
        },
        ag: {
            name: 'Antigua and Barbuda',
            native: 'Antigua and Barbuda',
            phone: '1268',
            region: 'NA',
            capital: "Saint John's",
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇦🇬',
            emojiu: 'U+1F1E6 U+1F1EC'
        },
        ai: {
            name: 'Anguilla',
            native: 'Anguilla',
            phone: '1264',
            region: 'NA',
            capital: 'The Valley',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇦🇮',
            emojiu: 'U+1F1E6 U+1F1EE'
        },
        al: {
            name: 'Albania',
            native: 'Shqipëria',
            phone: '355',
            region: 'EU',
            capital: 'Tirana',
            currency: 'ALL',
            languages: { '0': 'sq' },
            emoji: '🇦🇱',
            emojiu: 'U+1F1E6 U+1F1F1'
        },
        am: {
            name: 'Armenia',
            native: 'Հայաստան',
            phone: '374',
            region: 'AS',
            capital: 'Yerevan',
            currency: 'AMD',
            languages: { '0': 'hy', '1': 'ru' },
            emoji: '🇦🇲',
            emojiu: 'U+1F1E6 U+1F1F2'
        },
        ao: {
            name: 'Angola',
            native: 'Angola',
            phone: '244',
            region: 'AF',
            capital: 'Luanda',
            currency: 'AOA',
            languages: { '0': 'pt' },
            emoji: '🇦🇴',
            emojiu: 'U+1F1E6 U+1F1F4'
        },
        aq: {
            name: 'Antarctica',
            native: 'Antarctica',
            phone: '672',
            region: 'AN',
            capital: '',
            currency: '',
            languages: {},
            emoji: '🇦🇶',
            emojiu: 'U+1F1E6 U+1F1F6'
        },
        ar: {
            name: 'Argentina',
            native: 'Argentina',
            phone: '54',
            region: 'SA',
            capital: 'Buenos Aires',
            currency: 'ARS',
            languages: { '0': 'es', '1': 'gn' },
            emoji: '🇦🇷',
            emojiu: 'U+1F1E6 U+1F1F7'
        },
        as: {
            name: 'American Samoa',
            native: 'American Samoa',
            phone: '1684',
            region: 'OC',
            capital: 'Pago Pago',
            currency: 'USD',
            languages: { '0': 'en', '1': 'sm' },
            emoji: '🇦🇸',
            emojiu: 'U+1F1E6 U+1F1F8'
        },
        at: {
            name: 'Austria',
            native: 'Österreich',
            phone: '43',
            region: 'EU',
            capital: 'Vienna',
            currency: 'EUR',
            languages: { '0': 'de' },
            emoji: '🇦🇹',
            emojiu: 'U+1F1E6 U+1F1F9'
        },
        au: {
            name: 'Australia',
            native: 'Australia',
            phone: '61',
            region: 'OC',
            capital: 'Canberra',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇦🇺',
            emojiu: 'U+1F1E6 U+1F1FA'
        },
        aw: {
            name: 'Aruba',
            native: 'Aruba',
            phone: '297',
            region: 'NA',
            capital: 'Oranjestad',
            currency: 'AWG',
            languages: { '0': 'nl', '1': 'pa' },
            emoji: '🇦🇼',
            emojiu: 'U+1F1E6 U+1F1FC'
        },
        ax: {
            name: 'Åland',
            native: 'Åland',
            phone: '358',
            region: 'EU',
            capital: 'Mariehamn',
            currency: 'EUR',
            languages: { '0': 'sv' },
            emoji: '🇦🇽',
            emojiu: 'U+1F1E6 U+1F1FD'
        },
        az: {
            name: 'Azerbaijan',
            native: 'Azərbaycan',
            phone: '994',
            region: 'AS',
            capital: 'Baku',
            currency: 'AZN',
            languages: { '0': 'az' },
            emoji: '🇦🇿',
            emojiu: 'U+1F1E6 U+1F1FF'
        },
        ba: {
            name: 'Bosnia and Herzegovina',
            native: 'Bosna i Hercegovina',
            phone: '387',
            region: 'EU',
            capital: 'Sarajevo',
            currency: 'BAM',
            languages: { '0': 'bs', '1': 'hr', '2': 'sr' },
            emoji: '🇧🇦',
            emojiu: 'U+1F1E7 U+1F1E6'
        },
        bb: {
            name: 'Barbados',
            native: 'Barbados',
            phone: '1246',
            region: 'NA',
            capital: 'Bridgetown',
            currency: 'BBD',
            languages: { '0': 'en' },
            emoji: '🇧🇧',
            emojiu: 'U+1F1E7 U+1F1E7'
        },
        bd: {
            name: 'Bangladesh',
            native: 'Bangladesh',
            phone: '880',
            region: 'AS',
            capital: 'Dhaka',
            currency: 'BDT',
            languages: { '0': 'bn' },
            emoji: '🇧🇩',
            emojiu: 'U+1F1E7 U+1F1E9'
        },
        be: {
            name: 'Belgium',
            native: 'België',
            phone: '32',
            region: 'EU',
            capital: 'Brussels',
            currency: 'EUR',
            languages: { '0': 'nl', '1': 'fr', '2': 'de' },
            emoji: '🇧🇪',
            emojiu: 'U+1F1E7 U+1F1EA'
        },
        bf: {
            name: 'Burkina Faso',
            native: 'Burkina Faso',
            phone: '226',
            region: 'AF',
            capital: 'Ouagadougou',
            currency: 'XOF',
            languages: { '0': 'fr', '1': 'ff' },
            emoji: '🇧🇫',
            emojiu: 'U+1F1E7 U+1F1EB'
        },
        bg: {
            name: 'Bulgaria',
            native: 'България',
            phone: '359',
            region: 'EU',
            capital: 'Sofia',
            currency: 'BGN',
            languages: { '0': 'bg' },
            emoji: '🇧🇬',
            emojiu: 'U+1F1E7 U+1F1EC'
        },
        bh: {
            name: 'Bahrain',
            native: '‏البحرين',
            phone: '973',
            region: 'AS',
            capital: 'Manama',
            currency: 'BHD',
            languages: { '0': 'ar' },
            emoji: '🇧🇭',
            emojiu: 'U+1F1E7 U+1F1ED'
        },
        bi: {
            name: 'Burundi',
            native: 'Burundi',
            phone: '257',
            region: 'AF',
            capital: 'Bujumbura',
            currency: 'BIF',
            languages: { '0': 'fr', '1': 'rn' },
            emoji: '🇧🇮',
            emojiu: 'U+1F1E7 U+1F1EE'
        },
        bj: {
            name: 'Benin',
            native: 'Bénin',
            phone: '229',
            region: 'AF',
            capital: 'Porto-Novo',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇧🇯',
            emojiu: 'U+1F1E7 U+1F1EF'
        },
        bl: {
            name: 'Saint Barthélemy',
            native: 'Saint-Barthélemy',
            phone: '590',
            region: 'NA',
            capital: 'Gustavia',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇧🇱',
            emojiu: 'U+1F1E7 U+1F1F1'
        },
        bm: {
            name: 'Bermuda',
            native: 'Bermuda',
            phone: '1441',
            region: 'NA',
            capital: 'Hamilton',
            currency: 'BMD',
            languages: { '0': 'en' },
            emoji: '🇧🇲',
            emojiu: 'U+1F1E7 U+1F1F2'
        },
        bn: {
            name: 'Brunei',
            native: 'Negara Brunei Darussalam',
            phone: '673',
            region: 'AS',
            capital: 'Bandar Seri Begawan',
            currency: 'BND',
            languages: { '0': 'ms' },
            emoji: '🇧🇳',
            emojiu: 'U+1F1E7 U+1F1F3'
        },
        bo: {
            name: 'Bolivia',
            native: 'Bolivia',
            phone: '591',
            region: 'SA',
            capital: 'Sucre',
            currency: 'BOB,BOV',
            languages: { '0': 'es', '1': 'ay', '2': 'qu' },
            emoji: '🇧🇴',
            emojiu: 'U+1F1E7 U+1F1F4'
        },
        bq: {
            name: 'Bonaire',
            native: 'Bonaire',
            phone: '5997',
            region: 'NA',
            capital: 'Kralendijk',
            currency: 'USD',
            languages: { '0': 'nl' },
            emoji: '🇧🇶',
            emojiu: 'U+1F1E7 U+1F1F6'
        },
        br: {
            name: 'Brazil',
            native: 'Brasil',
            phone: '55',
            region: 'SA',
            capital: 'Brasília',
            currency: 'BRL',
            languages: { '0': 'pt' },
            emoji: '🇧🇷',
            emojiu: 'U+1F1E7 U+1F1F7'
        },
        bs: {
            name: 'Bahamas',
            native: 'Bahamas',
            phone: '1242',
            region: 'NA',
            capital: 'Nassau',
            currency: 'BSD',
            languages: { '0': 'en' },
            emoji: '🇧🇸',
            emojiu: 'U+1F1E7 U+1F1F8'
        },
        bt: {
            name: 'Bhutan',
            native: 'ʼbrug-yul',
            phone: '975',
            region: 'AS',
            capital: 'Thimphu',
            currency: 'BTN,INR',
            languages: { '0': 'dz' },
            emoji: '🇧🇹',
            emojiu: 'U+1F1E7 U+1F1F9'
        },
        bv: {
            name: 'Bouvet Island',
            native: 'Bouvetøya',
            phone: '47',
            region: 'AN',
            capital: '',
            currency: 'NOK',
            languages: {},
            emoji: '🇧🇻',
            emojiu: 'U+1F1E7 U+1F1FB'
        },
        bw: {
            name: 'Botswana',
            native: 'Botswana',
            phone: '267',
            region: 'AF',
            capital: 'Gaborone',
            currency: 'BWP',
            languages: { '0': 'en', '1': 'tn' },
            emoji: '🇧🇼',
            emojiu: 'U+1F1E7 U+1F1FC'
        },
        by: {
            name: 'Belarus',
            native: 'Белару́сь',
            phone: '375',
            region: 'EU',
            capital: 'Minsk',
            currency: 'BYR',
            languages: { '0': 'be', '1': 'ru' },
            emoji: '🇧🇾',
            emojiu: 'U+1F1E7 U+1F1FE'
        },
        bz: {
            name: 'Belize',
            native: 'Belize',
            phone: '501',
            region: 'NA',
            capital: 'Belmopan',
            currency: 'BZD',
            languages: { '0': 'en', '1': 'es' },
            emoji: '🇧🇿',
            emojiu: 'U+1F1E7 U+1F1FF'
        },
        ca: {
            name: 'Canada',
            native: 'Canada',
            phone: '1',
            region: 'NA',
            capital: 'Ottawa',
            currency: 'CAD',
            languages: { '0': 'en', '1': 'fr' },
            emoji: '🇨🇦',
            emojiu: 'U+1F1E8 U+1F1E6'
        },
        cc: {
            name: 'Cocos [Keeling] Islands',
            native: 'Cocos (Keeling) Islands',
            phone: '61',
            region: 'AS',
            capital: 'West Island',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇨🇨',
            emojiu: 'U+1F1E8 U+1F1E8'
        },
        cd: {
            name: 'Democratic Republic of the Congo',
            native: 'République démocratique du Congo',
            phone: '243',
            region: 'AF',
            capital: 'Kinshasa',
            currency: 'CDF',
            languages: { '0': 'fr', '1': 'ln', '2': 'kg', '3': 'sw', '4': 'lu' },
            emoji: '🇨🇩',
            emojiu: 'U+1F1E8 U+1F1E9'
        },
        cf: {
            name: 'Central African Republic',
            native: 'Ködörösêse tî Bêafrîka',
            phone: '236',
            region: 'AF',
            capital: 'Bangui',
            currency: 'XAF',
            languages: { '0': 'fr', '1': 'sg' },
            emoji: '🇨🇫',
            emojiu: 'U+1F1E8 U+1F1EB'
        },
        cg: {
            name: 'Republic of the Congo',
            native: 'République du Congo',
            phone: '242',
            region: 'AF',
            capital: 'Brazzaville',
            currency: 'XAF',
            languages: { '0': 'fr', '1': 'ln' },
            emoji: '🇨🇬',
            emojiu: 'U+1F1E8 U+1F1EC'
        },
        ch: {
            name: 'Switzerland',
            native: 'Schweiz',
            phone: '41',
            region: 'EU',
            capital: 'Bern',
            currency: 'CHE,CHF,CHW',
            languages: { '0': 'de', '1': 'fr', '2': 'it' },
            emoji: '🇨🇭',
            emojiu: 'U+1F1E8 U+1F1ED'
        },
        ci: {
            name: 'Ivory Coast',
            native: "Côte d'Ivoire",
            phone: '225',
            region: 'AF',
            capital: 'Yamoussoukro',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇨🇮',
            emojiu: 'U+1F1E8 U+1F1EE'
        },
        ck: {
            name: 'Cook Islands',
            native: 'Cook Islands',
            phone: '682',
            region: 'OC',
            capital: 'Avarua',
            currency: 'NZD',
            languages: { '0': 'en' },
            emoji: '🇨🇰',
            emojiu: 'U+1F1E8 U+1F1F0'
        },
        cl: {
            name: 'Chile',
            native: 'Chile',
            phone: '56',
            region: 'SA',
            capital: 'Santiago',
            currency: 'CLF,CLP',
            languages: { '0': 'es' },
            emoji: '🇨🇱',
            emojiu: 'U+1F1E8 U+1F1F1'
        },
        cm: {
            name: 'Cameroon',
            native: 'Cameroon',
            phone: '237',
            region: 'AF',
            capital: 'Yaoundé',
            currency: 'XAF',
            languages: { '0': 'en', '1': 'fr' },
            emoji: '🇨🇲',
            emojiu: 'U+1F1E8 U+1F1F2'
        },
        cn: {
            name: 'China',
            native: '中国',
            phone: '86',
            region: 'AS',
            capital: 'Beijing',
            currency: 'CNY',
            languages: { '0': 'zh' },
            emoji: '🇨🇳',
            emojiu: 'U+1F1E8 U+1F1F3'
        },
        co: {
            name: 'Colombia',
            native: 'Colombia',
            phone: '57',
            region: 'SA',
            capital: 'Bogotá',
            currency: 'COP',
            languages: { '0': 'es' },
            emoji: '🇨🇴',
            emojiu: 'U+1F1E8 U+1F1F4'
        },
        cr: {
            name: 'Costa Rica',
            native: 'Costa Rica',
            phone: '506',
            region: 'NA',
            capital: 'San José',
            currency: 'CRC',
            languages: { '0': 'es' },
            emoji: '🇨🇷',
            emojiu: 'U+1F1E8 U+1F1F7'
        },
        cu: {
            name: 'Cuba',
            native: 'Cuba',
            phone: '53',
            region: 'NA',
            capital: 'Havana',
            currency: 'CUC,CUP',
            languages: { '0': 'es' },
            emoji: '🇨🇺',
            emojiu: 'U+1F1E8 U+1F1FA'
        },
        cv: {
            name: 'Cape Verde',
            native: 'Cabo Verde',
            phone: '238',
            region: 'AF',
            capital: 'Praia',
            currency: 'CVE',
            languages: { '0': 'pt' },
            emoji: '🇨🇻',
            emojiu: 'U+1F1E8 U+1F1FB'
        },
        cw: {
            name: 'Curacao',
            native: 'Curaçao',
            phone: '5999',
            region: 'NA',
            capital: 'Willemstad',
            currency: 'ANG',
            languages: { '0': 'nl', '1': 'pa', '2': 'en' },
            emoji: '🇨🇼',
            emojiu: 'U+1F1E8 U+1F1FC'
        },
        cx: {
            name: 'Christmas Island',
            native: 'Christmas Island',
            phone: '61',
            region: 'AS',
            capital: 'Flying Fish Cove',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇨🇽',
            emojiu: 'U+1F1E8 U+1F1FD'
        },
        cy: {
            name: 'Cyprus',
            native: 'Κύπρος',
            phone: '357',
            region: 'EU',
            capital: 'Nicosia',
            currency: 'EUR',
            languages: { '0': 'el', '1': 'tr', '2': 'hy' },
            emoji: '🇨🇾',
            emojiu: 'U+1F1E8 U+1F1FE'
        },
        cz: {
            name: 'Czech Republic',
            native: 'Česká republika',
            phone: '420',
            region: 'EU',
            capital: 'Prague',
            currency: 'CZK',
            languages: { '0': 'cs', '1': 'sk' },
            emoji: '🇨🇿',
            emojiu: 'U+1F1E8 U+1F1FF'
        },
        de: {
            name: 'Germany',
            native: 'Deutschland',
            phone: '49',
            region: 'EU',
            capital: 'Berlin',
            currency: 'EUR',
            languages: { '0': 'de' },
            emoji: '🇩🇪',
            emojiu: 'U+1F1E9 U+1F1EA'
        },
        dj: {
            name: 'Djibouti',
            native: 'Djibouti',
            phone: '253',
            region: 'AF',
            capital: 'Djibouti',
            currency: 'DJF',
            languages: { '0': 'fr', '1': 'ar' },
            emoji: '🇩🇯',
            emojiu: 'U+1F1E9 U+1F1EF'
        },
        dk: {
            name: 'Denmark',
            native: 'Danmark',
            phone: '45',
            region: 'EU',
            capital: 'Copenhagen',
            currency: 'DKK',
            languages: { '0': 'da' },
            emoji: '🇩🇰',
            emojiu: 'U+1F1E9 U+1F1F0'
        },
        dm: {
            name: 'Dominica',
            native: 'Dominica',
            phone: '1767',
            region: 'NA',
            capital: 'Roseau',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇩🇲',
            emojiu: 'U+1F1E9 U+1F1F2'
        },
        do: {
            name: 'Dominican Republic',
            native: 'República Dominicana',
            phone: '1809,1829,1849',
            region: 'NA',
            capital: 'Santo Domingo',
            currency: 'DOP',
            languages: { '0': 'es' },
            emoji: '🇩🇴',
            emojiu: 'U+1F1E9 U+1F1F4'
        },
        dz: {
            name: 'Algeria',
            native: 'الجزائر',
            phone: '213',
            region: 'AF',
            capital: 'Algiers',
            currency: 'DZD',
            languages: { '0': 'ar' },
            emoji: '🇩🇿',
            emojiu: 'U+1F1E9 U+1F1FF'
        },
        ec: {
            name: 'Ecuador',
            native: 'Ecuador',
            phone: '593',
            region: 'SA',
            capital: 'Quito',
            currency: 'USD',
            languages: { '0': 'es' },
            emoji: '🇪🇨',
            emojiu: 'U+1F1EA U+1F1E8'
        },
        ee: {
            name: 'Estonia',
            native: 'Eesti',
            phone: '372',
            region: 'EU',
            capital: 'Tallinn',
            currency: 'EUR',
            languages: { '0': 'et' },
            emoji: '🇪🇪',
            emojiu: 'U+1F1EA U+1F1EA'
        },
        eg: {
            name: 'Egypt',
            native: 'مصر‎',
            phone: '20',
            region: 'AF',
            capital: 'Cairo',
            currency: 'EGP',
            languages: { '0': 'ar' },
            emoji: '🇪🇬',
            emojiu: 'U+1F1EA U+1F1EC'
        },
        eh: {
            name: 'Western Sahara',
            native: 'الصحراء الغربية',
            phone: '212',
            region: 'AF',
            capital: 'El Aaiún',
            currency: 'MAD,DZD,MRO',
            languages: { '0': 'es' },
            emoji: '🇪🇭',
            emojiu: 'U+1F1EA U+1F1ED'
        },
        er: {
            name: 'Eritrea',
            native: 'ኤርትራ',
            phone: '291',
            region: 'AF',
            capital: 'Asmara',
            currency: 'ERN',
            languages: { '0': 'ti', '1': 'ar', '2': 'en' },
            emoji: '🇪🇷',
            emojiu: 'U+1F1EA U+1F1F7'
        },
        es: {
            name: 'Spain',
            native: 'España',
            phone: '34',
            region: 'EU',
            capital: 'Madrid',
            currency: 'EUR',
            languages: { '0': 'es', '1': 'eu', '2': 'ca', '3': 'gl', '4': 'oc' },
            emoji: '🇪🇸',
            emojiu: 'U+1F1EA U+1F1F8'
        },
        et: {
            name: 'Ethiopia',
            native: 'ኢትዮጵያ',
            phone: '251',
            region: 'AF',
            capital: 'Addis Ababa',
            currency: 'ETB',
            languages: { '0': 'am' },
            emoji: '🇪🇹',
            emojiu: 'U+1F1EA U+1F1F9'
        },
        fi: {
            name: 'Finland',
            native: 'Suomi',
            phone: '358',
            region: 'EU',
            capital: 'Helsinki',
            currency: 'EUR',
            languages: { '0': 'fi', '1': 'sv' },
            emoji: '🇫🇮',
            emojiu: 'U+1F1EB U+1F1EE'
        },
        fj: {
            name: 'Fiji',
            native: 'Fiji',
            phone: '679',
            region: 'OC',
            capital: 'Suva',
            currency: 'FJD',
            languages: { '0': 'en', '1': 'fj', '2': 'hi', '3': 'ur' },
            emoji: '🇫🇯',
            emojiu: 'U+1F1EB U+1F1EF'
        },
        fk: {
            name: 'Falkland Islands',
            native: 'Falkland Islands',
            phone: '500',
            region: 'SA',
            capital: 'Stanley',
            currency: 'FKP',
            languages: { '0': 'en' },
            emoji: '🇫🇰',
            emojiu: 'U+1F1EB U+1F1F0'
        },
        fm: {
            name: 'Micronesia',
            native: 'Micronesia',
            phone: '691',
            region: 'OC',
            capital: 'Palikir',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇫🇲',
            emojiu: 'U+1F1EB U+1F1F2'
        },
        fo: {
            name: 'Faroe Islands',
            native: 'Føroyar',
            phone: '298',
            region: 'EU',
            capital: 'Tórshavn',
            currency: 'DKK',
            languages: { '0': 'fo' },
            emoji: '🇫🇴',
            emojiu: 'U+1F1EB U+1F1F4'
        },
        fr: {
            name: 'France',
            native: 'France',
            phone: '33',
            region: 'EU',
            capital: 'Paris',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇫🇷',
            emojiu: 'U+1F1EB U+1F1F7'
        },
        ga: {
            name: 'Gabon',
            native: 'Gabon',
            phone: '241',
            region: 'AF',
            capital: 'Libreville',
            currency: 'XAF',
            languages: { '0': 'fr' },
            emoji: '🇬🇦',
            emojiu: 'U+1F1EC U+1F1E6'
        },
        gb: {
            name: 'United Kingdom',
            native: 'United Kingdom',
            phone: '44',
            region: 'EU',
            capital: 'London',
            currency: 'GBP',
            languages: { '0': 'en' },
            emoji: '🇬🇧',
            emojiu: 'U+1F1EC U+1F1E7'
        },
        gd: {
            name: 'Grenada',
            native: 'Grenada',
            phone: '1473',
            region: 'NA',
            capital: "St. George's",
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇬🇩',
            emojiu: 'U+1F1EC U+1F1E9'
        },
        ge: {
            name: 'Georgia',
            native: 'საქართველო',
            phone: '995',
            region: 'AS',
            capital: 'Tbilisi',
            currency: 'GEL',
            languages: { '0': 'ka' },
            emoji: '🇬🇪',
            emojiu: 'U+1F1EC U+1F1EA'
        },
        gf: {
            name: 'French Guiana',
            native: 'Guyane française',
            phone: '594',
            region: 'SA',
            capital: 'Cayenne',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇬🇫',
            emojiu: 'U+1F1EC U+1F1EB'
        },
        gg: {
            name: 'Guernsey',
            native: 'Guernsey',
            phone: '44',
            region: 'EU',
            capital: 'St. Peter Port',
            currency: 'GBP',
            languages: { '0': 'en', '1': 'fr' },
            emoji: '🇬🇬',
            emojiu: 'U+1F1EC U+1F1EC'
        },
        gh: {
            name: 'Ghana',
            native: 'Ghana',
            phone: '233',
            region: 'AF',
            capital: 'Accra',
            currency: 'GHS',
            languages: { '0': 'en' },
            emoji: '🇬🇭',
            emojiu: 'U+1F1EC U+1F1ED'
        },
        gi: {
            name: 'Gibraltar',
            native: 'Gibraltar',
            phone: '350',
            region: 'EU',
            capital: 'Gibraltar',
            currency: 'GIP',
            languages: { '0': 'en' },
            emoji: '🇬🇮',
            emojiu: 'U+1F1EC U+1F1EE'
        },
        gl: {
            name: 'Greenland',
            native: 'Kalaallit Nunaat',
            phone: '299',
            region: 'NA',
            capital: 'Nuuk',
            currency: 'DKK',
            languages: { '0': 'kl' },
            emoji: '🇬🇱',
            emojiu: 'U+1F1EC U+1F1F1'
        },
        gm: {
            name: 'Gambia',
            native: 'Gambia',
            phone: '220',
            region: 'AF',
            capital: 'Banjul',
            currency: 'GMD',
            languages: { '0': 'en' },
            emoji: '🇬🇲',
            emojiu: 'U+1F1EC U+1F1F2'
        },
        gn: {
            name: 'Guinea',
            native: 'Guinée',
            phone: '224',
            region: 'AF',
            capital: 'Conakry',
            currency: 'GNF',
            languages: { '0': 'fr', '1': 'ff' },
            emoji: '🇬🇳',
            emojiu: 'U+1F1EC U+1F1F3'
        },
        gp: {
            name: 'Guadeloupe',
            native: 'Guadeloupe',
            phone: '590',
            region: 'NA',
            capital: 'Basse-Terre',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇬🇵',
            emojiu: 'U+1F1EC U+1F1F5'
        },
        gq: {
            name: 'Equatorial Guinea',
            native: 'Guinea Ecuatorial',
            phone: '240',
            region: 'AF',
            capital: 'Malabo',
            currency: 'XAF',
            languages: { '0': 'es', '1': 'fr' },
            emoji: '🇬🇶',
            emojiu: 'U+1F1EC U+1F1F6'
        },
        gr: {
            name: 'Greece',
            native: 'Ελλάδα',
            phone: '30',
            region: 'EU',
            capital: 'Athens',
            currency: 'EUR',
            languages: { '0': 'el' },
            emoji: '🇬🇷',
            emojiu: 'U+1F1EC U+1F1F7'
        },
        gs: {
            name: 'South Georgia and the South Sandwich Islands',
            native: 'South Georgia',
            phone: '500',
            region: 'AN',
            capital: 'King Edward Point',
            currency: 'GBP',
            languages: { '0': 'en' },
            emoji: '🇬🇸',
            emojiu: 'U+1F1EC U+1F1F8'
        },
        gt: {
            name: 'Guatemala',
            native: 'Guatemala',
            phone: '502',
            region: 'NA',
            capital: 'Guatemala City',
            currency: 'GTQ',
            languages: { '0': 'es' },
            emoji: '🇬🇹',
            emojiu: 'U+1F1EC U+1F1F9'
        },
        gu: {
            name: 'Guam',
            native: 'Guam',
            phone: '1671',
            region: 'OC',
            capital: 'Hagåtña',
            currency: 'USD',
            languages: { '0': 'en', '1': 'ch', '2': 'es' },
            emoji: '🇬🇺',
            emojiu: 'U+1F1EC U+1F1FA'
        },
        gw: {
            name: 'Guinea-Bissau',
            native: 'Guiné-Bissau',
            phone: '245',
            region: 'AF',
            capital: 'Bissau',
            currency: 'XOF',
            languages: { '0': 'pt' },
            emoji: '🇬🇼',
            emojiu: 'U+1F1EC U+1F1FC'
        },
        gy: {
            name: 'Guyana',
            native: 'Guyana',
            phone: '592',
            region: 'SA',
            capital: 'Georgetown',
            currency: 'GYD',
            languages: { '0': 'en' },
            emoji: '🇬🇾',
            emojiu: 'U+1F1EC U+1F1FE'
        },
        hk: {
            name: 'Hong Kong',
            native: '香港',
            phone: '852',
            region: 'AS',
            capital: 'City of Victoria',
            currency: 'HKD',
            languages: { '0': 'zh', '1': 'en' },
            emoji: '🇭🇰',
            emojiu: 'U+1F1ED U+1F1F0'
        },
        hm: {
            name: 'Heard Island and McDonald Islands',
            native: 'Heard Island and McDonald Islands',
            phone: '61',
            region: 'AN',
            capital: '',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇭🇲',
            emojiu: 'U+1F1ED U+1F1F2'
        },
        hn: {
            name: 'Honduras',
            native: 'Honduras',
            phone: '504',
            region: 'NA',
            capital: 'Tegucigalpa',
            currency: 'HNL',
            languages: { '0': 'es' },
            emoji: '🇭🇳',
            emojiu: 'U+1F1ED U+1F1F3'
        },
        hr: {
            name: 'Croatia',
            native: 'Hrvatska',
            phone: '385',
            region: 'EU',
            capital: 'Zagreb',
            currency: 'HRK',
            languages: { '0': 'hr' },
            emoji: '🇭🇷',
            emojiu: 'U+1F1ED U+1F1F7'
        },
        ht: {
            name: 'Haiti',
            native: 'Haïti',
            phone: '509',
            region: 'NA',
            capital: 'Port-au-Prince',
            currency: 'HTG,USD',
            languages: { '0': 'fr', '1': 'ht' },
            emoji: '🇭🇹',
            emojiu: 'U+1F1ED U+1F1F9'
        },
        hu: {
            name: 'Hungary',
            native: 'Magyarország',
            phone: '36',
            region: 'EU',
            capital: 'Budapest',
            currency: 'HUF',
            languages: { '0': 'hu' },
            emoji: '🇭🇺',
            emojiu: 'U+1F1ED U+1F1FA'
        },
        id: {
            name: 'Indonesia',
            native: 'Indonesia',
            phone: '62',
            region: 'AS',
            capital: 'Jakarta',
            currency: 'IDR',
            languages: { '0': 'id' },
            emoji: '🇮🇩',
            emojiu: 'U+1F1EE U+1F1E9'
        },
        ie: {
            name: 'Ireland',
            native: 'Éire',
            phone: '353',
            region: 'EU',
            capital: 'Dublin',
            currency: 'EUR',
            languages: { '0': 'ga', '1': 'en' },
            emoji: '🇮🇪',
            emojiu: 'U+1F1EE U+1F1EA'
        },
        il: {
            name: 'Israel',
            native: 'יִשְׂרָאֵל',
            phone: '972',
            region: 'AS',
            capital: 'Jerusalem',
            currency: 'ILS',
            languages: { '0': 'he', '1': 'ar' },
            emoji: '🇮🇱',
            emojiu: 'U+1F1EE U+1F1F1'
        },
        im: {
            name: 'Isle of Man',
            native: 'Isle of Man',
            phone: '44',
            region: 'EU',
            capital: 'Douglas',
            currency: 'GBP',
            languages: { '0': 'en', '1': 'gv' },
            emoji: '🇮🇲',
            emojiu: 'U+1F1EE U+1F1F2'
        },
        in: {
            name: 'India',
            native: 'भारत',
            phone: '91',
            region: 'AS',
            capital: 'New Delhi',
            currency: 'INR',
            languages: { '0': 'hi', '1': 'en' },
            emoji: '🇮🇳',
            emojiu: 'U+1F1EE U+1F1F3'
        },
        io: {
            name: 'British Indian Ocean Territory',
            native: 'British Indian Ocean Territory',
            phone: '246',
            region: 'AS',
            capital: 'Diego Garcia',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇮🇴',
            emojiu: 'U+1F1EE U+1F1F4'
        },
        iq: {
            name: 'Iraq',
            native: 'العراق',
            phone: '964',
            region: 'AS',
            capital: 'Baghdad',
            currency: 'IQD',
            languages: { '0': 'ar', '1': 'ku' },
            emoji: '🇮🇶',
            emojiu: 'U+1F1EE U+1F1F6'
        },
        ir: {
            name: 'Iran',
            native: 'ایران',
            phone: '98',
            region: 'AS',
            capital: 'Tehran',
            currency: 'IRR',
            languages: { '0': 'fa' },
            emoji: '🇮🇷',
            emojiu: 'U+1F1EE U+1F1F7'
        },
        is: {
            name: 'Iceland',
            native: 'Ísland',
            phone: '354',
            region: 'EU',
            capital: 'Reykjavik',
            currency: 'ISK',
            languages: { '0': 'is' },
            emoji: '🇮🇸',
            emojiu: 'U+1F1EE U+1F1F8'
        },
        it: {
            name: 'Italy',
            native: 'Italia',
            phone: '39',
            region: 'EU',
            capital: 'Rome',
            currency: 'EUR',
            languages: { '0': 'it' },
            emoji: '🇮🇹',
            emojiu: 'U+1F1EE U+1F1F9'
        },
        je: {
            name: 'Jersey',
            native: 'Jersey',
            phone: '44',
            region: 'EU',
            capital: 'Saint Helier',
            currency: 'GBP',
            languages: { '0': 'en', '1': 'fr' },
            emoji: '🇯🇪',
            emojiu: 'U+1F1EF U+1F1EA'
        },
        jm: {
            name: 'Jamaica',
            native: 'Jamaica',
            phone: '1876',
            region: 'NA',
            capital: 'Kingston',
            currency: 'JMD',
            languages: { '0': 'en' },
            emoji: '🇯🇲',
            emojiu: 'U+1F1EF U+1F1F2'
        },
        jo: {
            name: 'Jordan',
            native: 'الأردن',
            phone: '962',
            region: 'AS',
            capital: 'Amman',
            currency: 'JOD',
            languages: { '0': 'ar' },
            emoji: '🇯🇴',
            emojiu: 'U+1F1EF U+1F1F4'
        },
        jp: {
            name: 'Japan',
            native: '日本',
            phone: '81',
            region: 'AS',
            capital: 'Tokyo',
            currency: 'JPY',
            languages: { '0': 'ja' },
            emoji: '🇯🇵',
            emojiu: 'U+1F1EF U+1F1F5'
        },
        ke: {
            name: 'Kenya',
            native: 'Kenya',
            phone: '254',
            region: 'AF',
            capital: 'Nairobi',
            currency: 'KES',
            languages: { '0': 'en', '1': 'sw' },
            emoji: '🇰🇪',
            emojiu: 'U+1F1F0 U+1F1EA'
        },
        kg: {
            name: 'Kyrgyzstan',
            native: 'Кыргызстан',
            phone: '996',
            region: 'AS',
            capital: 'Bishkek',
            currency: 'KGS',
            languages: { '0': 'ky', '1': 'ru' },
            emoji: '🇰🇬',
            emojiu: 'U+1F1F0 U+1F1EC'
        },
        kh: {
            name: 'Cambodia',
            native: 'Kâmpŭchéa',
            phone: '855',
            region: 'AS',
            capital: 'Phnom Penh',
            currency: 'KHR',
            languages: { '0': 'km' },
            emoji: '🇰🇭',
            emojiu: 'U+1F1F0 U+1F1ED'
        },
        ki: {
            name: 'Kiribati',
            native: 'Kiribati',
            phone: '686',
            region: 'OC',
            capital: 'South Tarawa',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇰🇮',
            emojiu: 'U+1F1F0 U+1F1EE'
        },
        km: {
            name: 'Comoros',
            native: 'Komori',
            phone: '269',
            region: 'AF',
            capital: 'Moroni',
            currency: 'KMF',
            languages: { '0': 'ar', '1': 'fr' },
            emoji: '🇰🇲',
            emojiu: 'U+1F1F0 U+1F1F2'
        },
        kn: {
            name: 'Saint Kitts and Nevis',
            native: 'Saint Kitts and Nevis',
            phone: '1869',
            region: 'NA',
            capital: 'Basseterre',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇰🇳',
            emojiu: 'U+1F1F0 U+1F1F3'
        },
        kp: {
            name: 'North Korea',
            native: '북한',
            phone: '850',
            region: 'AS',
            capital: 'Pyongyang',
            currency: 'KPW',
            languages: { '0': 'ko' },
            emoji: '🇰🇵',
            emojiu: 'U+1F1F0 U+1F1F5'
        },
        kr: {
            name: 'South Korea',
            native: '대한민국',
            phone: '82',
            region: 'AS',
            capital: 'Seoul',
            currency: 'KRW',
            languages: { '0': 'ko' },
            emoji: '🇰🇷',
            emojiu: 'U+1F1F0 U+1F1F7'
        },
        kw: {
            name: 'Kuwait',
            native: 'الكويت',
            phone: '965',
            region: 'AS',
            capital: 'Kuwait City',
            currency: 'KWD',
            languages: { '0': 'ar' },
            emoji: '🇰🇼',
            emojiu: 'U+1F1F0 U+1F1FC'
        },
        ky: {
            name: 'Cayman Islands',
            native: 'Cayman Islands',
            phone: '1345',
            region: 'NA',
            capital: 'George Town',
            currency: 'KYD',
            languages: { '0': 'en' },
            emoji: '🇰🇾',
            emojiu: 'U+1F1F0 U+1F1FE'
        },
        kz: {
            name: 'Kazakhstan',
            native: 'Қазақстан',
            phone: '76,77',
            region: 'AS',
            capital: 'Astana',
            currency: 'KZT',
            languages: { '0': 'kk', '1': 'ru' },
            emoji: '🇰🇿',
            emojiu: 'U+1F1F0 U+1F1FF'
        },
        la: {
            name: 'Laos',
            native: 'ສປປລາວ',
            phone: '856',
            region: 'AS',
            capital: 'Vientiane',
            currency: 'LAK',
            languages: { '0': 'lo' },
            emoji: '🇱🇦',
            emojiu: 'U+1F1F1 U+1F1E6'
        },
        lb: {
            name: 'Lebanon',
            native: 'لبنان',
            phone: '961',
            region: 'AS',
            capital: 'Beirut',
            currency: 'LBP',
            languages: { '0': 'ar', '1': 'fr' },
            emoji: '🇱🇧',
            emojiu: 'U+1F1F1 U+1F1E7'
        },
        lc: {
            name: 'Saint Lucia',
            native: 'Saint Lucia',
            phone: '1758',
            region: 'NA',
            capital: 'Castries',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇱🇨',
            emojiu: 'U+1F1F1 U+1F1E8'
        },
        li: {
            name: 'Liechtenstein',
            native: 'Liechtenstein',
            phone: '423',
            region: 'EU',
            capital: 'Vaduz',
            currency: 'CHF',
            languages: { '0': 'de' },
            emoji: '🇱🇮',
            emojiu: 'U+1F1F1 U+1F1EE'
        },
        lk: {
            name: 'Sri Lanka',
            native: 'śrī laṃkāva',
            phone: '94',
            region: 'AS',
            capital: 'Colombo',
            currency: 'LKR',
            languages: { '0': 'si', '1': 'ta' },
            emoji: '🇱🇰',
            emojiu: 'U+1F1F1 U+1F1F0'
        },
        lr: {
            name: 'Liberia',
            native: 'Liberia',
            phone: '231',
            region: 'AF',
            capital: 'Monrovia',
            currency: 'LRD',
            languages: { '0': 'en' },
            emoji: '🇱🇷',
            emojiu: 'U+1F1F1 U+1F1F7'
        },
        ls: {
            name: 'Lesotho',
            native: 'Lesotho',
            phone: '266',
            region: 'AF',
            capital: 'Maseru',
            currency: 'LSL,ZAR',
            languages: { '0': 'en', '1': 'st' },
            emoji: '🇱🇸',
            emojiu: 'U+1F1F1 U+1F1F8'
        },
        lt: {
            name: 'Lithuania',
            native: 'Lietuva',
            phone: '370',
            region: 'EU',
            capital: 'Vilnius',
            currency: 'LTL',
            languages: { '0': 'lt' },
            emoji: '🇱🇹',
            emojiu: 'U+1F1F1 U+1F1F9'
        },
        lu: {
            name: 'Luxembourg',
            native: 'Luxembourg',
            phone: '352',
            region: 'EU',
            capital: 'Luxembourg',
            currency: 'EUR',
            languages: { '0': 'fr', '1': 'de', '2': 'lb' },
            emoji: '🇱🇺',
            emojiu: 'U+1F1F1 U+1F1FA'
        },
        lv: {
            name: 'Latvia',
            native: 'Latvija',
            phone: '371',
            region: 'EU',
            capital: 'Riga',
            currency: 'EUR',
            languages: { '0': 'lv' },
            emoji: '🇱🇻',
            emojiu: 'U+1F1F1 U+1F1FB'
        },
        ly: {
            name: 'Libya',
            native: '‏ليبيا',
            phone: '218',
            region: 'AF',
            capital: 'Tripoli',
            currency: 'LYD',
            languages: { '0': 'ar' },
            emoji: '🇱🇾',
            emojiu: 'U+1F1F1 U+1F1FE'
        },
        ma: {
            name: 'Morocco',
            native: 'المغرب',
            phone: '212',
            region: 'AF',
            capital: 'Rabat',
            currency: 'MAD',
            languages: { '0': 'ar' },
            emoji: '🇲🇦',
            emojiu: 'U+1F1F2 U+1F1E6'
        },
        mc: {
            name: 'Monaco',
            native: 'Monaco',
            phone: '377',
            region: 'EU',
            capital: 'Monaco',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇲🇨',
            emojiu: 'U+1F1F2 U+1F1E8'
        },
        md: {
            name: 'Moldova',
            native: 'Moldova',
            phone: '373',
            region: 'EU',
            capital: 'Chișinău',
            currency: 'MDL',
            languages: { '0': 'ro' },
            emoji: '🇲🇩',
            emojiu: 'U+1F1F2 U+1F1E9'
        },
        me: {
            name: 'Montenegro',
            native: 'Црна Гора',
            phone: '382',
            region: 'EU',
            capital: 'Podgorica',
            currency: 'EUR',
            languages: { '0': 'sr', '1': 'bs', '2': 'sq', '3': 'hr' },
            emoji: '🇲🇪',
            emojiu: 'U+1F1F2 U+1F1EA'
        },
        mf: {
            name: 'Saint Martin',
            native: 'Saint-Martin',
            phone: '590',
            region: 'NA',
            capital: 'Marigot',
            currency: 'EUR',
            languages: { '0': 'en', '1': 'fr', '2': 'nl' },
            emoji: '🇲🇫',
            emojiu: 'U+1F1F2 U+1F1EB'
        },
        mg: {
            name: 'Madagascar',
            native: 'Madagasikara',
            phone: '261',
            region: 'AF',
            capital: 'Antananarivo',
            currency: 'MGA',
            languages: { '0': 'fr', '1': 'mg' },
            emoji: '🇲🇬',
            emojiu: 'U+1F1F2 U+1F1EC'
        },
        mh: {
            name: 'Marshall Islands',
            native: 'M̧ajeļ',
            phone: '692',
            region: 'OC',
            capital: 'Majuro',
            currency: 'USD',
            languages: { '0': 'en', '1': 'mh' },
            emoji: '🇲🇭',
            emojiu: 'U+1F1F2 U+1F1ED'
        },
        mk: {
            name: 'Macedonia',
            native: 'Македонија',
            phone: '389',
            region: 'EU',
            capital: 'Skopje',
            currency: 'MKD',
            languages: { '0': 'mk' },
            emoji: '🇲🇰',
            emojiu: 'U+1F1F2 U+1F1F0'
        },
        ml: {
            name: 'Mali',
            native: 'Mali',
            phone: '223',
            region: 'AF',
            capital: 'Bamako',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇲🇱',
            emojiu: 'U+1F1F2 U+1F1F1'
        },
        mm: {
            name: 'Myanmar [Burma]',
            native: 'Myanma',
            phone: '95',
            region: 'AS',
            capital: 'Naypyidaw',
            currency: 'MMK',
            languages: { '0': 'my' },
            emoji: '🇲🇲',
            emojiu: 'U+1F1F2 U+1F1F2'
        },
        mn: {
            name: 'Mongolia',
            native: 'Монгол улс',
            phone: '976',
            region: 'AS',
            capital: 'Ulan Bator',
            currency: 'MNT',
            languages: { '0': 'mn' },
            emoji: '🇲🇳',
            emojiu: 'U+1F1F2 U+1F1F3'
        },
        mo: {
            name: 'Macao',
            native: '澳門',
            phone: '853',
            region: 'AS',
            capital: '',
            currency: 'MOP',
            languages: { '0': 'zh', '1': 'pt' },
            emoji: '🇲🇴',
            emojiu: 'U+1F1F2 U+1F1F4'
        },
        mp: {
            name: 'Northern Mariana Islands',
            native: 'Northern Mariana Islands',
            phone: '1670',
            region: 'OC',
            capital: 'Saipan',
            currency: 'USD',
            languages: { '0': 'en', '1': 'ch' },
            emoji: '🇲🇵',
            emojiu: 'U+1F1F2 U+1F1F5'
        },
        mq: {
            name: 'Martinique',
            native: 'Martinique',
            phone: '596',
            region: 'NA',
            capital: 'Fort-de-France',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇲🇶',
            emojiu: 'U+1F1F2 U+1F1F6'
        },
        mr: {
            name: 'Mauritania',
            native: 'موريتانيا',
            phone: '222',
            region: 'AF',
            capital: 'Nouakchott',
            currency: 'MRO',
            languages: { '0': 'ar' },
            emoji: '🇲🇷',
            emojiu: 'U+1F1F2 U+1F1F7'
        },
        ms: {
            name: 'Montserrat',
            native: 'Montserrat',
            phone: '1664',
            region: 'NA',
            capital: 'Plymouth',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇲🇸',
            emojiu: 'U+1F1F2 U+1F1F8'
        },
        mt: {
            name: 'Malta',
            native: 'Malta',
            phone: '356',
            region: 'EU',
            capital: 'Valletta',
            currency: 'EUR',
            languages: { '0': 'mt', '1': 'en' },
            emoji: '🇲🇹',
            emojiu: 'U+1F1F2 U+1F1F9'
        },
        mu: {
            name: 'Mauritius',
            native: 'Maurice',
            phone: '230',
            region: 'AF',
            capital: 'Port Louis',
            currency: 'MUR',
            languages: { '0': 'en' },
            emoji: '🇲🇺',
            emojiu: 'U+1F1F2 U+1F1FA'
        },
        mv: {
            name: 'Maldives',
            native: 'Maldives',
            phone: '960',
            region: 'AS',
            capital: 'Malé',
            currency: 'MVR',
            languages: { '0': 'dv' },
            emoji: '🇲🇻',
            emojiu: 'U+1F1F2 U+1F1FB'
        },
        mw: {
            name: 'Malawi',
            native: 'Malawi',
            phone: '265',
            region: 'AF',
            capital: 'Lilongwe',
            currency: 'MWK',
            languages: { '0': 'en', '1': 'ny' },
            emoji: '🇲🇼',
            emojiu: 'U+1F1F2 U+1F1FC'
        },
        mx: {
            name: 'Mexico',
            native: 'México',
            phone: '52',
            region: 'NA',
            capital: 'Mexico City',
            currency: 'MXN',
            languages: { '0': 'es' },
            emoji: '🇲🇽',
            emojiu: 'U+1F1F2 U+1F1FD'
        },
        my: {
            name: 'Malaysia',
            native: 'Malaysia',
            phone: '60',
            region: 'AS',
            capital: 'Kuala Lumpur',
            currency: 'MYR',
            languages: {},
            emoji: '🇲🇾',
            emojiu: 'U+1F1F2 U+1F1FE'
        },
        mz: {
            name: 'Mozambique',
            native: 'Moçambique',
            phone: '258',
            region: 'AF',
            capital: 'Maputo',
            currency: 'MZN',
            languages: { '0': 'pt' },
            emoji: '🇲🇿',
            emojiu: 'U+1F1F2 U+1F1FF'
        },
        na: {
            name: 'Namibia',
            native: 'Namibia',
            phone: '264',
            region: 'AF',
            capital: 'Windhoek',
            currency: 'NAD,ZAR',
            languages: { '0': 'en', '1': 'af' },
            emoji: '🇳🇦',
            emojiu: 'U+1F1F3 U+1F1E6'
        },
        nc: {
            name: 'New Caledonia',
            native: 'Nouvelle-Calédonie',
            phone: '687',
            region: 'OC',
            capital: 'Nouméa',
            currency: 'XPF',
            languages: { '0': 'fr' },
            emoji: '🇳🇨',
            emojiu: 'U+1F1F3 U+1F1E8'
        },
        ne: {
            name: 'Niger',
            native: 'Niger',
            phone: '227',
            region: 'AF',
            capital: 'Niamey',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇳🇪',
            emojiu: 'U+1F1F3 U+1F1EA'
        },
        nf: {
            name: 'Norfolk Island',
            native: 'Norfolk Island',
            phone: '672',
            region: 'OC',
            capital: 'Kingston',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇳🇫',
            emojiu: 'U+1F1F3 U+1F1EB'
        },
        ng: {
            name: 'Nigeria',
            native: 'Nigeria',
            phone: '234',
            region: 'AF',
            capital: 'Abuja',
            currency: 'NGN',
            languages: { '0': 'en' },
            emoji: '🇳🇬',
            emojiu: 'U+1F1F3 U+1F1EC'
        },
        ni: {
            name: 'Nicaragua',
            native: 'Nicaragua',
            phone: '505',
            region: 'NA',
            capital: 'Managua',
            currency: 'NIO',
            languages: { '0': 'es' },
            emoji: '🇳🇮',
            emojiu: 'U+1F1F3 U+1F1EE'
        },
        nl: {
            name: 'Netherlands',
            native: 'Nederland',
            phone: '31',
            region: 'EU',
            capital: 'Amsterdam',
            currency: 'EUR',
            languages: { '0': 'nl' },
            emoji: '🇳🇱',
            emojiu: 'U+1F1F3 U+1F1F1'
        },
        no: {
            name: 'Norway',
            native: 'Norge',
            phone: '47',
            region: 'EU',
            capital: 'Oslo',
            currency: 'NOK',
            languages: { '0': 'no', '1': 'nb', '2': 'nn' },
            emoji: '🇳🇴',
            emojiu: 'U+1F1F3 U+1F1F4'
        },
        np: {
            name: 'Nepal',
            native: 'नपल',
            phone: '977',
            region: 'AS',
            capital: 'Kathmandu',
            currency: 'NPR',
            languages: { '0': 'ne' },
            emoji: '🇳🇵',
            emojiu: 'U+1F1F3 U+1F1F5'
        },
        nr: {
            name: 'Nauru',
            native: 'Nauru',
            phone: '674',
            region: 'OC',
            capital: 'Yaren',
            currency: 'AUD',
            languages: { '0': 'en', '1': 'na' },
            emoji: '🇳🇷',
            emojiu: 'U+1F1F3 U+1F1F7'
        },
        nu: {
            name: 'Niue',
            native: 'Niuē',
            phone: '683',
            region: 'OC',
            capital: 'Alofi',
            currency: 'NZD',
            languages: { '0': 'en' },
            emoji: '🇳🇺',
            emojiu: 'U+1F1F3 U+1F1FA'
        },
        nz: {
            name: 'New Zealand',
            native: 'New Zealand',
            phone: '64',
            region: 'OC',
            capital: 'Wellington',
            currency: 'NZD',
            languages: { '0': 'en', '1': 'mi' },
            emoji: '🇳🇿',
            emojiu: 'U+1F1F3 U+1F1FF'
        },
        om: {
            name: 'Oman',
            native: 'عمان',
            phone: '968',
            region: 'AS',
            capital: 'Muscat',
            currency: 'OMR',
            languages: { '0': 'ar' },
            emoji: '🇴🇲',
            emojiu: 'U+1F1F4 U+1F1F2'
        },
        pa: {
            name: 'Panama',
            native: 'Panamá',
            phone: '507',
            region: 'NA',
            capital: 'Panama City',
            currency: 'PAB,USD',
            languages: { '0': 'es' },
            emoji: '🇵🇦',
            emojiu: 'U+1F1F5 U+1F1E6'
        },
        pe: {
            name: 'Peru',
            native: 'Perú',
            phone: '51',
            region: 'SA',
            capital: 'Lima',
            currency: 'PEN',
            languages: { '0': 'es' },
            emoji: '🇵🇪',
            emojiu: 'U+1F1F5 U+1F1EA'
        },
        pf: {
            name: 'French Polynesia',
            native: 'Polynésie française',
            phone: '689',
            region: 'OC',
            capital: 'Papeetē',
            currency: 'XPF',
            languages: { '0': 'fr' },
            emoji: '🇵🇫',
            emojiu: 'U+1F1F5 U+1F1EB'
        },
        pg: {
            name: 'Papua New Guinea',
            native: 'Papua Niugini',
            phone: '675',
            region: 'OC',
            capital: 'Port Moresby',
            currency: 'PGK',
            languages: { '0': 'en' },
            emoji: '🇵🇬',
            emojiu: 'U+1F1F5 U+1F1EC'
        },
        ph: {
            name: 'Philippines',
            native: 'Pilipinas',
            phone: '63',
            region: 'AS',
            capital: 'Manila',
            currency: 'PHP',
            languages: { '0': 'en' },
            emoji: '🇵🇭',
            emojiu: 'U+1F1F5 U+1F1ED'
        },
        pk: {
            name: 'Pakistan',
            native: 'Pakistan',
            phone: '92',
            region: 'AS',
            capital: 'Islamabad',
            currency: 'PKR',
            languages: { '0': 'en', '1': 'ur' },
            emoji: '🇵🇰',
            emojiu: 'U+1F1F5 U+1F1F0'
        },
        pl: {
            name: 'Poland',
            native: 'Polska',
            phone: '48',
            region: 'EU',
            capital: 'Warsaw',
            currency: 'PLN',
            languages: { '0': 'pl' },
            emoji: '🇵🇱',
            emojiu: 'U+1F1F5 U+1F1F1'
        },
        pm: {
            name: 'Saint Pierre and Miquelon',
            native: 'Saint-Pierre-et-Miquelon',
            phone: '508',
            region: 'NA',
            capital: 'Saint-Pierre',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇵🇲',
            emojiu: 'U+1F1F5 U+1F1F2'
        },
        pn: {
            name: 'Pitcairn Islands',
            native: 'Pitcairn Islands',
            phone: '64',
            region: 'OC',
            capital: 'Adamstown',
            currency: 'NZD',
            languages: { '0': 'en' },
            emoji: '🇵🇳',
            emojiu: 'U+1F1F5 U+1F1F3'
        },
        pr: {
            name: 'Puerto Rico',
            native: 'Puerto Rico',
            phone: '1787,1939',
            region: 'NA',
            capital: 'San Juan',
            currency: 'USD',
            languages: { '0': 'es', '1': 'en' },
            emoji: '🇵🇷',
            emojiu: 'U+1F1F5 U+1F1F7'
        },
        ps: {
            name: 'Palestine',
            native: 'فلسطين',
            phone: '970',
            region: 'AS',
            capital: 'Ramallah',
            currency: 'ILS',
            languages: { '0': 'ar' },
            emoji: '🇵🇸',
            emojiu: 'U+1F1F5 U+1F1F8'
        },
        pt: {
            name: 'Portugal',
            native: 'Portugal',
            phone: '351',
            region: 'EU',
            capital: 'Lisbon',
            currency: 'EUR',
            languages: { '0': 'pt' },
            emoji: '🇵🇹',
            emojiu: 'U+1F1F5 U+1F1F9'
        },
        pw: {
            name: 'Palau',
            native: 'Palau',
            phone: '680',
            region: 'OC',
            capital: 'Ngerulmud',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇵🇼',
            emojiu: 'U+1F1F5 U+1F1FC'
        },
        py: {
            name: 'Paraguay',
            native: 'Paraguay',
            phone: '595',
            region: 'SA',
            capital: 'Asunción',
            currency: 'PYG',
            languages: { '0': 'es', '1': 'gn' },
            emoji: '🇵🇾',
            emojiu: 'U+1F1F5 U+1F1FE'
        },
        qa: {
            name: 'Qatar',
            native: 'قطر',
            phone: '974',
            region: 'AS',
            capital: 'Doha',
            currency: 'QAR',
            languages: { '0': 'ar' },
            emoji: '🇶🇦',
            emojiu: 'U+1F1F6 U+1F1E6'
        },
        re: {
            name: 'Réunion',
            native: 'La Réunion',
            phone: '262',
            region: 'AF',
            capital: 'Saint-Denis',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇷🇪',
            emojiu: 'U+1F1F7 U+1F1EA'
        },
        ro: {
            name: 'Romania',
            native: 'România',
            phone: '40',
            region: 'EU',
            capital: 'Bucharest',
            currency: 'RON',
            languages: { '0': 'ro' },
            emoji: '🇷🇴',
            emojiu: 'U+1F1F7 U+1F1F4'
        },
        rs: {
            name: 'Serbia',
            native: 'Србија',
            phone: '381',
            region: 'EU',
            capital: 'Belgrade',
            currency: 'RSD',
            languages: { '0': 'sr' },
            emoji: '🇷🇸',
            emojiu: 'U+1F1F7 U+1F1F8'
        },
        ru: {
            name: 'Russia',
            native: 'Россия',
            phone: '7',
            region: 'EU',
            capital: 'Moscow',
            currency: 'RUB',
            languages: { '0': 'ru' },
            emoji: '🇷🇺',
            emojiu: 'U+1F1F7 U+1F1FA'
        },
        rw: {
            name: 'Rwanda',
            native: 'Rwanda',
            phone: '250',
            region: 'AF',
            capital: 'Kigali',
            currency: 'RWF',
            languages: { '0': 'rw', '1': 'en', '2': 'fr' },
            emoji: '🇷🇼',
            emojiu: 'U+1F1F7 U+1F1FC'
        },
        sa: {
            name: 'Saudi Arabia',
            native: 'العربية السعودية',
            phone: '966',
            region: 'AS',
            capital: 'Riyadh',
            currency: 'SAR',
            languages: { '0': 'ar' },
            emoji: '🇸🇦',
            emojiu: 'U+1F1F8 U+1F1E6'
        },
        sb: {
            name: 'Solomon Islands',
            native: 'Solomon Islands',
            phone: '677',
            region: 'OC',
            capital: 'Honiara',
            currency: 'SBD',
            languages: { '0': 'en' },
            emoji: '🇸🇧',
            emojiu: 'U+1F1F8 U+1F1E7'
        },
        sc: {
            name: 'Seychelles',
            native: 'Seychelles',
            phone: '248',
            region: 'AF',
            capital: 'Victoria',
            currency: 'SCR',
            languages: { '0': 'fr', '1': 'en' },
            emoji: '🇸🇨',
            emojiu: 'U+1F1F8 U+1F1E8'
        },
        sd: {
            name: 'Sudan',
            native: 'السودان',
            phone: '249',
            region: 'AF',
            capital: 'Khartoum',
            currency: 'SDG',
            languages: { '0': 'ar', '1': 'en' },
            emoji: '🇸🇩',
            emojiu: 'U+1F1F8 U+1F1E9'
        },
        se: {
            name: 'Sweden',
            native: 'Sverige',
            phone: '46',
            region: 'EU',
            capital: 'Stockholm',
            currency: 'SEK',
            languages: { '0': 'sv' },
            emoji: '🇸🇪',
            emojiu: 'U+1F1F8 U+1F1EA'
        },
        sg: {
            name: 'Singapore',
            native: 'Singapore',
            phone: '65',
            region: 'AS',
            capital: 'Singapore',
            currency: 'SGD',
            languages: { '0': 'en', '1': 'ms', '2': 'ta', '3': 'zh' },
            emoji: '🇸🇬',
            emojiu: 'U+1F1F8 U+1F1EC'
        },
        sh: {
            name: 'Saint Helena',
            native: 'Saint Helena',
            phone: '290',
            region: 'AF',
            capital: 'Jamestown',
            currency: 'SHP',
            languages: { '0': 'en' },
            emoji: '🇸🇭',
            emojiu: 'U+1F1F8 U+1F1ED'
        },
        si: {
            name: 'Slovenia',
            native: 'Slovenija',
            phone: '386',
            region: 'EU',
            capital: 'Ljubljana',
            currency: 'EUR',
            languages: { '0': 'sl' },
            emoji: '🇸🇮',
            emojiu: 'U+1F1F8 U+1F1EE'
        },
        sj: {
            name: 'Svalbard and Jan Mayen',
            native: 'Svalbard og Jan Mayen',
            phone: '4779',
            region: 'EU',
            capital: 'Longyearbyen',
            currency: 'NOK',
            languages: { '0': 'no' },
            emoji: '🇸🇯',
            emojiu: 'U+1F1F8 U+1F1EF'
        },
        sk: {
            name: 'Slovakia',
            native: 'Slovensko',
            phone: '421',
            region: 'EU',
            capital: 'Bratislava',
            currency: 'EUR',
            languages: { '0': 'sk' },
            emoji: '🇸🇰',
            emojiu: 'U+1F1F8 U+1F1F0'
        },
        sl: {
            name: 'Sierra Leone',
            native: 'Sierra Leone',
            phone: '232',
            region: 'AF',
            capital: 'Freetown',
            currency: 'SLL',
            languages: { '0': 'en' },
            emoji: '🇸🇱',
            emojiu: 'U+1F1F8 U+1F1F1'
        },
        sm: {
            name: 'San Marino',
            native: 'San Marino',
            phone: '378',
            region: 'EU',
            capital: 'City of San Marino',
            currency: 'EUR',
            languages: { '0': 'it' },
            emoji: '🇸🇲',
            emojiu: 'U+1F1F8 U+1F1F2'
        },
        sn: {
            name: 'Senegal',
            native: 'Sénégal',
            phone: '221',
            region: 'AF',
            capital: 'Dakar',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇸🇳',
            emojiu: 'U+1F1F8 U+1F1F3'
        },
        so: {
            name: 'Somalia',
            native: 'Soomaaliya',
            phone: '252',
            region: 'AF',
            capital: 'Mogadishu',
            currency: 'SOS',
            languages: { '0': 'so', '1': 'ar' },
            emoji: '🇸🇴',
            emojiu: 'U+1F1F8 U+1F1F4'
        },
        sr: {
            name: 'Suriname',
            native: 'Suriname',
            phone: '597',
            region: 'SA',
            capital: 'Paramaribo',
            currency: 'SRD',
            languages: { '0': 'nl' },
            emoji: '🇸🇷',
            emojiu: 'U+1F1F8 U+1F1F7'
        },
        ss: {
            name: 'South Sudan',
            native: 'South Sudan',
            phone: '211',
            region: 'AF',
            capital: 'Juba',
            currency: 'SSP',
            languages: { '0': 'en' },
            emoji: '🇸🇸',
            emojiu: 'U+1F1F8 U+1F1F8'
        },
        st: {
            name: 'São Tomé and Príncipe',
            native: 'São Tomé e Príncipe',
            phone: '239',
            region: 'AF',
            capital: 'São Tomé',
            currency: 'STD',
            languages: { '0': 'pt' },
            emoji: '🇸🇹',
            emojiu: 'U+1F1F8 U+1F1F9'
        },
        sv: {
            name: 'El Salvador',
            native: 'El Salvador',
            phone: '503',
            region: 'NA',
            capital: 'San Salvador',
            currency: 'SVC,USD',
            languages: { '0': 'es' },
            emoji: '🇸🇻',
            emojiu: 'U+1F1F8 U+1F1FB'
        },
        sx: {
            name: 'Sint Maarten',
            native: 'Sint Maarten',
            phone: '1721',
            region: 'NA',
            capital: 'Philipsburg',
            currency: 'ANG',
            languages: { '0': 'nl', '1': 'en' },
            emoji: '🇸🇽',
            emojiu: 'U+1F1F8 U+1F1FD'
        },
        sy: {
            name: 'Syria',
            native: 'سوريا',
            phone: '963',
            region: 'AS',
            capital: 'Damascus',
            currency: 'SYP',
            languages: { '0': 'ar' },
            emoji: '🇸🇾',
            emojiu: 'U+1F1F8 U+1F1FE'
        },
        sz: {
            name: 'Swaziland',
            native: 'Swaziland',
            phone: '268',
            region: 'AF',
            capital: 'Lobamba',
            currency: 'SZL',
            languages: { '0': 'en', '1': 'ss' },
            emoji: '🇸🇿',
            emojiu: 'U+1F1F8 U+1F1FF'
        },
        tc: {
            name: 'Turks and Caicos Islands',
            native: 'Turks and Caicos Islands',
            phone: '1649',
            region: 'NA',
            capital: 'Cockburn Town',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇹🇨',
            emojiu: 'U+1F1F9 U+1F1E8'
        },
        td: {
            name: 'Chad',
            native: 'Tchad',
            phone: '235',
            region: 'AF',
            capital: "N'Djamena",
            currency: 'XAF',
            languages: { '0': 'fr', '1': 'ar' },
            emoji: '🇹🇩',
            emojiu: 'U+1F1F9 U+1F1E9'
        },
        tf: {
            name: 'French Southern Territories',
            native: 'Territoire des Terres australes et antarctiques fr',
            phone: '262',
            region: 'AN',
            capital: 'Port-aux-Français',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇹🇫',
            emojiu: 'U+1F1F9 U+1F1EB'
        },
        tg: {
            name: 'Togo',
            native: 'Togo',
            phone: '228',
            region: 'AF',
            capital: 'Lomé',
            currency: 'XOF',
            languages: { '0': 'fr' },
            emoji: '🇹🇬',
            emojiu: 'U+1F1F9 U+1F1EC'
        },
        th: {
            name: 'Thailand',
            native: 'ประเทศไทย',
            phone: '66',
            region: 'AS',
            capital: 'Bangkok',
            currency: 'THB',
            languages: { '0': 'th' },
            emoji: '🇹🇭',
            emojiu: 'U+1F1F9 U+1F1ED'
        },
        tj: {
            name: 'Tajikistan',
            native: 'Тоҷикистон',
            phone: '992',
            region: 'AS',
            capital: 'Dushanbe',
            currency: 'TJS',
            languages: { '0': 'tg', '1': 'ru' },
            emoji: '🇹🇯',
            emojiu: 'U+1F1F9 U+1F1EF'
        },
        tk: {
            name: 'Tokelau',
            native: 'Tokelau',
            phone: '690',
            region: 'OC',
            capital: 'Fakaofo',
            currency: 'NZD',
            languages: { '0': 'en' },
            emoji: '🇹🇰',
            emojiu: 'U+1F1F9 U+1F1F0'
        },
        tl: {
            name: 'East Timor',
            native: 'Timor-Leste',
            phone: '670',
            region: 'OC',
            capital: 'Dili',
            currency: 'USD',
            languages: { '0': 'pt' },
            emoji: '🇹🇱',
            emojiu: 'U+1F1F9 U+1F1F1'
        },
        tm: {
            name: 'Turkmenistan',
            native: 'Türkmenistan',
            phone: '993',
            region: 'AS',
            capital: 'Ashgabat',
            currency: 'TMT',
            languages: { '0': 'tk', '1': 'ru' },
            emoji: '🇹🇲',
            emojiu: 'U+1F1F9 U+1F1F2'
        },
        tn: {
            name: 'Tunisia',
            native: 'تونس',
            phone: '216',
            region: 'AF',
            capital: 'Tunis',
            currency: 'TND',
            languages: { '0': 'ar' },
            emoji: '🇹🇳',
            emojiu: 'U+1F1F9 U+1F1F3'
        },
        to: {
            name: 'Tonga',
            native: 'Tonga',
            phone: '676',
            region: 'OC',
            capital: "Nuku'alofa",
            currency: 'TOP',
            languages: { '0': 'en', '1': 'to' },
            emoji: '🇹🇴',
            emojiu: 'U+1F1F9 U+1F1F4'
        },
        tr: {
            name: 'Turkey',
            native: 'Türkiye',
            phone: '90',
            region: 'AS',
            capital: 'Ankara',
            currency: 'TRY',
            languages: { '0': 'tr' },
            emoji: '🇹🇷',
            emojiu: 'U+1F1F9 U+1F1F7'
        },
        tt: {
            name: 'Trinidad and Tobago',
            native: 'Trinidad and Tobago',
            phone: '1868',
            region: 'NA',
            capital: 'Port of Spain',
            currency: 'TTD',
            languages: { '0': 'en' },
            emoji: '🇹🇹',
            emojiu: 'U+1F1F9 U+1F1F9'
        },
        tv: {
            name: 'Tuvalu',
            native: 'Tuvalu',
            phone: '688',
            region: 'OC',
            capital: 'Funafuti',
            currency: 'AUD',
            languages: { '0': 'en' },
            emoji: '🇹🇻',
            emojiu: 'U+1F1F9 U+1F1FB'
        },
        tw: {
            name: 'Taiwan',
            native: '臺灣',
            phone: '886',
            region: 'AS',
            capital: 'Taipei',
            currency: 'TWD',
            languages: { '0': 'zh' },
            emoji: '🇹🇼',
            emojiu: 'U+1F1F9 U+1F1FC'
        },
        tz: {
            name: 'Tanzania',
            native: 'Tanzania',
            phone: '255',
            region: 'AF',
            capital: 'Dodoma',
            currency: 'TZS',
            languages: { '0': 'sw', '1': 'en' },
            emoji: '🇹🇿',
            emojiu: 'U+1F1F9 U+1F1FF'
        },
        ua: {
            name: 'Ukraine',
            native: 'Україна',
            phone: '380',
            region: 'EU',
            capital: 'Kyiv',
            currency: 'UAH',
            languages: { '0': 'uk' },
            emoji: '🇺🇦',
            emojiu: 'U+1F1FA U+1F1E6'
        },
        ug: {
            name: 'Uganda',
            native: 'Uganda',
            phone: '256',
            region: 'AF',
            capital: 'Kampala',
            currency: 'UGX',
            languages: { '0': 'en', '1': 'sw' },
            emoji: '🇺🇬',
            emojiu: 'U+1F1FA U+1F1EC'
        },
        um: {
            name: 'U.S. Minor Outlying Islands',
            native: 'United States Minor Outlying Islands',
            phone: '1',
            region: 'OC',
            capital: '',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇺🇲',
            emojiu: 'U+1F1FA U+1F1F2'
        },
        us: {
            name: 'United States',
            native: 'United States',
            phone: '1',
            region: 'NA',
            capital: 'Washington D.C.',
            currency: 'USD,USN,USS',
            languages: { '0': 'en' },
            emoji: '🇺🇸',
            emojiu: 'U+1F1FA U+1F1F8'
        },
        uy: {
            name: 'Uruguay',
            native: 'Uruguay',
            phone: '598',
            region: 'SA',
            capital: 'Montevideo',
            currency: 'UYI,UYU',
            languages: { '0': 'es' },
            emoji: '🇺🇾',
            emojiu: 'U+1F1FA U+1F1FE'
        },
        uz: {
            name: 'Uzbekistan',
            native: 'O‘zbekiston',
            phone: '998',
            region: 'AS',
            capital: 'Tashkent',
            currency: 'UZS',
            languages: { '0': 'uz', '1': 'ru' },
            emoji: '🇺🇿',
            emojiu: 'U+1F1FA U+1F1FF'
        },
        va: {
            name: 'Vatican City',
            native: 'Vaticano',
            phone: '39066,379',
            region: 'EU',
            capital: 'Vatican City',
            currency: 'EUR',
            languages: { '0': 'it', '1': 'la' },
            emoji: '🇻🇦',
            emojiu: 'U+1F1FB U+1F1E6'
        },
        vc: {
            name: 'Saint Vincent and the Grenadines',
            native: 'Saint Vincent and the Grenadines',
            phone: '1784',
            region: 'NA',
            capital: 'Kingstown',
            currency: 'XCD',
            languages: { '0': 'en' },
            emoji: '🇻🇨',
            emojiu: 'U+1F1FB U+1F1E8'
        },
        ve: {
            name: 'Venezuela',
            native: 'Venezuela',
            phone: '58',
            region: 'SA',
            capital: 'Caracas',
            currency: 'VEF',
            languages: { '0': 'es' },
            emoji: '🇻🇪',
            emojiu: 'U+1F1FB U+1F1EA'
        },
        vg: {
            name: 'British Virgin Islands',
            native: 'British Virgin Islands',
            phone: '1284',
            region: 'NA',
            capital: 'Road Town',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇻🇬',
            emojiu: 'U+1F1FB U+1F1EC'
        },
        vi: {
            name: 'U.S. Virgin Islands',
            native: 'United States Virgin Islands',
            phone: '1340',
            region: 'NA',
            capital: 'Charlotte Amalie',
            currency: 'USD',
            languages: { '0': 'en' },
            emoji: '🇻🇮',
            emojiu: 'U+1F1FB U+1F1EE'
        },
        vn: {
            name: 'Vietnam',
            native: 'Việt Nam',
            phone: '84',
            region: 'AS',
            capital: 'Hanoi',
            currency: 'VND',
            languages: { '0': 'vi' },
            emoji: '🇻🇳',
            emojiu: 'U+1F1FB U+1F1F3'
        },
        vu: {
            name: 'Vanuatu',
            native: 'Vanuatu',
            phone: '678',
            region: 'OC',
            capital: 'Port Vila',
            currency: 'VUV',
            languages: { '0': 'bi', '1': 'en', '2': 'fr' },
            emoji: '🇻🇺',
            emojiu: 'U+1F1FB U+1F1FA'
        },
        wf: {
            name: 'Wallis and Futuna',
            native: 'Wallis et Futuna',
            phone: '681',
            region: 'OC',
            capital: 'Mata-Utu',
            currency: 'XPF',
            languages: { '0': 'fr' },
            emoji: '🇼🇫',
            emojiu: 'U+1F1FC U+1F1EB'
        },
        ws: {
            name: 'Samoa',
            native: 'Samoa',
            phone: '685',
            region: 'OC',
            capital: 'Apia',
            currency: 'WST',
            languages: { '0': 'sm', '1': 'en' },
            emoji: '🇼🇸',
            emojiu: 'U+1F1FC U+1F1F8'
        },
        xk: {
            name: 'Kosovo',
            native: 'Republika e Kosovës',
            phone: '377,381,386',
            region: 'EU',
            capital: 'Pristina',
            currency: 'EUR',
            languages: { '0': 'sq', '1': 'sr' },
            emoji: '🇽🇰',
            emojiu: 'U+1F1FD U+1F1F0'
        },
        ye: {
            name: 'Yemen',
            native: 'اليَمَن',
            phone: '967',
            region: 'AS',
            capital: "Sana'a",
            currency: 'YER',
            languages: { '0': 'ar' },
            emoji: '🇾🇪',
            emojiu: 'U+1F1FE U+1F1EA'
        },
        yt: {
            name: 'Mayotte',
            native: 'Mayotte',
            phone: '262',
            region: 'AF',
            capital: 'Mamoudzou',
            currency: 'EUR',
            languages: { '0': 'fr' },
            emoji: '🇾🇹',
            emojiu: 'U+1F1FE U+1F1F9'
        },
        za: {
            name: 'South Africa',
            native: 'South Africa',
            phone: '27',
            region: 'AF',
            capital: 'Pretoria',
            currency: 'ZAR',
            languages: {
                '0': 'af',
                '1': 'en',
                '2': 'nr',
                '3': 'st',
                '4': 'ss',
                '5': 'tn',
                '6': 'ts',
                '7': 've',
                '8': 'xh',
                '9': 'zu'
            },
            emoji: '🇿🇦',
            emojiu: 'U+1F1FF U+1F1E6'
        },
        zm: {
            name: 'Zambia',
            native: 'Zambia',
            phone: '260',
            region: 'AF',
            capital: 'Lusaka',
            currency: 'ZMK',
            languages: { '0': 'en' },
            emoji: '🇿🇲',
            emojiu: 'U+1F1FF U+1F1F2'
        },
        zw: {
            name: 'Zimbabwe',
            native: 'Zimbabwe',
            phone: '263',
            region: 'AF',
            capital: 'Harare',
            currency: 'ZWL',
            languages: { '0': 'en', '1': 'sn', '2': 'nd' },
            emoji: '🇿🇼',
            emojiu: 'U+1F1FF U+1F1FC'
        }
    },
    languages: {
        af: { name: 'Afrikaans', native: 'Afrikaans' },
        am: { name: 'Amharic', native: 'አማርኛ' },
        ar: { name: 'Arabic', native: 'العربية', rtl: 1 },
        ay: { name: 'Aymara', native: 'Aymar' },
        az: { name: 'Azerbaijani', native: 'Azərbaycanca / آذربايجان' },
        be: { name: 'Belarusian', native: 'Беларуская' },
        bg: { name: 'Bulgarian', native: 'Български' },
        bi: { name: 'Bislama', native: 'Bislama' },
        bn: { name: 'Bengali', native: 'বাংলা' },
        bs: { name: 'Bosnian', native: 'Bosanski' },
        ca: { name: 'Catalan', native: 'Català' },
        ch: { name: 'Chamorro', native: 'Chamoru' },
        cs: { name: 'Czech', native: 'Česky' },
        da: { name: 'Danish', native: 'Dansk' },
        de: { name: 'German', native: 'Deutsch' },
        dv: { name: 'Divehi', native: 'ދިވެހިބަސް', rtl: 1 },
        dz: { name: 'Dzongkha', native: 'ཇོང་ཁ' },
        el: { name: 'Greek', native: 'Ελληνικά' },
        en: { name: 'English', native: 'English' },
        es: { name: 'Spanish', native: 'Español' },
        et: { name: 'Estonian', native: 'Eesti' },
        eu: { name: 'Basque', native: 'Euskara' },
        fa: { name: 'Persian', native: 'فارسی', rtl: 1 },
        ff: { name: 'Peul', native: 'Fulfulde' },
        fi: { name: 'Finnish', native: 'Suomi' },
        fj: { name: 'Fijian', native: 'Na Vosa Vakaviti' },
        fo: { name: 'Faroese', native: 'Føroyskt' },
        fr: { name: 'French', native: 'Français' },
        ga: { name: 'Irish', native: 'Gaeilge' },
        gl: { name: 'Galician', native: 'Galego' },
        gn: { name: 'Guarani', native: "Avañe'ẽ" },
        gv: { name: 'Manx', native: 'Gaelg' },
        he: { name: 'Hebrew', native: 'עברית', rtl: 1 },
        hi: { name: 'Hindi', native: 'हिन्दी' },
        hr: { name: 'Croatian', native: 'Hrvatski' },
        ht: { name: 'Haitian', native: 'Krèyol ayisyen' },
        hu: { name: 'Hungarian', native: 'Magyar' },
        hy: { name: 'Armenian', native: 'Հայերեն' },
        id: { name: 'Indonesian', native: 'Bahasa Indonesia' },
        is: { name: 'Icelandic', native: 'Íslenska' },
        it: { name: 'Italian', native: 'Italiano' },
        ja: { name: 'Japanese', native: '日本語' },
        ka: { name: 'Georgian', native: 'ქართული' },
        kg: { name: 'Kongo', native: 'KiKongo' },
        kk: { name: 'Kazakh', native: 'Қазақша' },
        kl: { name: 'Greenlandic', native: 'Kalaallisut' },
        km: { name: 'Cambodian', native: 'ភាសាខ្មែរ' },
        ko: { name: 'Korean', native: '한국어' },
        ku: { name: 'Kurdish', native: 'Kurdî / كوردی', rtl: 1 },
        ky: { name: 'Kirghiz', native: 'Kırgızca / Кыргызча' },
        la: { name: 'Latin', native: 'Latina' },
        lb: { name: 'Luxembourgish', native: 'Lëtzebuergesch' },
        ln: { name: 'Lingala', native: 'Lingála' },
        lo: { name: 'Laotian', native: 'ລາວ / Pha xa lao' },
        lt: { name: 'Lithuanian', native: 'Lietuvių' },
        lu: {},
        lv: { name: 'Latvian', native: 'Latviešu' },
        mg: { name: 'Malagasy', native: 'Malagasy' },
        mh: { name: 'Marshallese', native: 'Kajin Majel / Ebon' },
        mi: { name: 'Maori', native: 'Māori' },
        mk: { name: 'Macedonian', native: 'Македонски' },
        mn: { name: 'Mongolian', native: 'Монгол' },
        ms: { name: 'Malay', native: 'Bahasa Melayu' },
        mt: { name: 'Maltese', native: 'bil-Malti' },
        my: { name: 'Burmese', native: 'Myanmasa' },
        na: { name: 'Nauruan', native: 'Dorerin Naoero' },
        nb: {},
        nd: { name: 'North Ndebele', native: 'Sindebele' },
        ne: { name: 'Nepali', native: 'नेपाली' },
        nl: { name: 'Dutch', native: 'Nederlands' },
        nn: { name: 'Norwegian Nynorsk', native: 'Norsk (nynorsk)' },
        no: { name: 'Norwegian', native: 'Norsk (bokmål / riksmål)' },
        nr: { name: 'South Ndebele', native: 'isiNdebele' },
        ny: { name: 'Chichewa', native: 'Chi-Chewa' },
        oc: { name: 'Occitan', native: 'Occitan' },
        pa: { name: 'Panjabi / Punjabi', native: 'ਪੰਜਾਬੀ / पंजाबी / پنجابي' },
        pl: { name: 'Polish', native: 'Polski' },
        ps: { name: 'Pashto', native: 'پښتو', rtl: 1 },
        pt: { name: 'Portuguese', native: 'Português' },
        qu: { name: 'Quechua', native: 'Runa Simi' },
        rn: { name: 'Kirundi', native: 'Kirundi' },
        ro: { name: 'Romanian', native: 'Română' },
        ru: { name: 'Russian', native: 'Русский' },
        rw: { name: 'Rwandi', native: 'Kinyarwandi' },
        sg: { name: 'Sango', native: 'Sängö' },
        si: { name: 'Sinhalese', native: 'සිංහල' },
        sk: { name: 'Slovak', native: 'Slovenčina' },
        sl: { name: 'Slovenian', native: 'Slovenščina' },
        sm: { name: 'Samoan', native: 'Gagana Samoa' },
        sn: { name: 'Shona', native: 'chiShona' },
        so: { name: 'Somalia', native: 'Soomaaliga' },
        sq: { name: 'Albanian', native: 'Shqip' },
        sr: { name: 'Serbian', native: 'Српски' },
        ss: { name: 'Swati', native: 'SiSwati' },
        st: { name: 'Southern Sotho', native: 'Sesotho' },
        sv: { name: 'Swedish', native: 'Svenska' },
        sw: { name: 'Swahili', native: 'Kiswahili' },
        ta: { name: 'Tamil', native: 'தமிழ்' },
        tg: { name: 'Tajik', native: 'Тоҷикӣ' },
        th: { name: 'Thai', native: 'ไทย / Phasa Thai' },
        ti: { name: 'Tigrinya', native: 'ትግርኛ' },
        tk: { name: 'Turkmen', native: 'Туркмен / تركمن' },
        tn: { name: 'Tswana', native: 'Setswana' },
        to: { name: 'Tonga', native: 'Lea Faka-Tonga' },
        tr: { name: 'Turkish', native: 'Türkçe' },
        ts: { name: 'Tsonga', native: 'Xitsonga' },
        uk: { name: 'Ukrainian', native: 'Українська' },
        ur: { name: 'Urdu', native: 'اردو', rtl: 1 },
        uz: { name: 'Uzbek', native: 'Ўзбек' },
        ve: { name: 'Venda', native: 'Tshivenḓa' },
        vi: { name: 'Vietnamese', native: 'Tiếng Việt' },
        xh: { name: 'Xhosa', native: 'isiXhosa' },
        zh: { name: 'Chinese', native: '中文' },
        zu: { name: 'Zulu', native: 'isiZulu' }
    }
};

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(38);

var PropTypes = _interopRequireWildcard(_propTypes);

var _rcRate = __webpack_require__(811);

var _rcRate2 = _interopRequireDefault(_rcRate);

var _icon = __webpack_require__(75);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Rate = function (_React$Component) {
    (0, _inherits3['default'])(Rate, _React$Component);

    function Rate() {
        (0, _classCallCheck3['default'])(this, Rate);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Rate.__proto__ || Object.getPrototypeOf(Rate)).apply(this, arguments));

        _this.saveRate = function (node) {
            _this.rcRate = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Rate, [{
        key: 'focus',
        value: function focus() {
            this.rcRate.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcRate.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(_rcRate2['default'], (0, _extends3['default'])({ ref: this.saveRate }, this.props));
        }
    }]);
    return Rate;
}(React.Component);

exports['default'] = Rate;

Rate.propTypes = {
    prefixCls: PropTypes.string,
    character: PropTypes.node
};
Rate.defaultProps = {
    prefixCls: 'ant-rate',
    character: React.createElement(_icon2['default'], { type: 'star', theme: 'filled' })
};
module.exports = exports['default'];

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(33);

__webpack_require__(815);

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactImages = __webpack_require__(817);

var _reactImages2 = _interopRequireDefault(_reactImages);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

var _utils = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = _styledComponents2.default.div.withConfig({
    displayName: 'Gallery__Caption'
})(['color:', ';font-size:0.7em;padding:2px 4px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'], function (p) {
    return p.theme.textOffwhite;
});
var A = _styledComponents2.default.a.withConfig({
    displayName: 'Gallery__A'
})(['margin:20px 10px 0;border-radius:5px;box-shadow:2px 2px 4px 1px #000;overflow:hidden;']);

var Gallery = function (_PureComponent) {
    _inherits(Gallery, _PureComponent);

    function Gallery() {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this));

        _this.openLightbox = function (index, event) {
            event.preventDefault();
            _this.setState({
                currentImage: index,
                lightboxIsOpen: true
            });
        };
        _this.closeLightbox = function () {
            _this.setState({
                currentImage: 0,
                lightboxIsOpen: false
            });
        };
        _this.gotoPrevious = function () {
            _this.setState({
                currentImage: _this.state.currentImage - 1
            });
        };
        _this.gotoNext = function () {
            _this.setState({
                currentImage: _this.state.currentImage + 1
            });
        };
        _this.gotoImage = function (index) {
            _this.setState({
                currentImage: index
            });
        };
        _this.handleClickImage = function () {
            if (_this.state.currentImage === _this.props.images.length - 1) return;
            _this.gotoNext();
        };
        _this.renderGallery = function () {
            var _this$props = _this.props,
                images = _this$props.images,
                previewCount = _this$props.previewCount,
                showCaption = _this$props.showCaption,
                _this$props$justify = _this$props.justify,
                justify = _this$props$justify === undefined ? 'start' : _this$props$justify;

            if (!images || !images.length) return;
            var previewImages = images.slice(0, previewCount || images.length);
            return _react2.default.createElement(
                _styledCommon.Flex,
                { style: { margin: '-10px' }, justifyContent: justify },
                previewImages.map(function (image, i) {
                    return _react2.default.createElement(
                        A,
                        { href: image.src, key: i, onClick: function onClick(e) {
                                return _this.openLightbox(i, e);
                            } },
                        _react2.default.createElement('img', { src: image.thumbnail, alt: image.caption }),
                        showCaption === false || _react2.default.createElement(
                            Caption,
                            null,
                            image.caption
                        )
                    );
                })
            );
        };
        _this.state = {
            lightboxIsOpen: false,
            currentImage: 0
        };
        return _this;
    }

    _createClass(Gallery, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                (0, _utils.withoutProps)(this.props, Gallery.propTypes),
                this.props.heading && _react2.default.createElement(
                    'h2',
                    null,
                    this.props.heading
                ),
                this.props.subheading && _react2.default.createElement(
                    'p',
                    null,
                    this.props.subheading
                ),
                this.renderGallery(),
                _react2.default.createElement(_reactImages2.default, { currentImage: this.state.currentImage, images: this.props.images, isOpen: this.state.lightboxIsOpen, onClickImage: this.handleClickImage, onClickNext: this.gotoNext, onClickPrev: this.gotoPrevious, onClickThumbnail: this.gotoImage, onClose: this.closeLightbox, preventScroll: this.props.preventScroll, showThumbnails: this.props.showThumbnails, spinner: this.props.spinner, spinnerColor: this.props.spinnerColor, spinnerSize: this.props.spinnerSize, theme: this.props.theme, backdropClosesModal: true })
            );
        }
    }]);

    return Gallery;
}(_react.PureComponent);

exports.default = Gallery;

Gallery.displayName = 'Gallery';
Gallery.propTypes = {
    images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        thumbnail: _propTypes2.default.string.isRequired,
        srcset: _propTypes2.default.array,
        caption: _propTypes2.default.string
    })).isRequired,
    previewCount: _propTypes2.default.number,
    showCaption: _propTypes2.default.bool,
    justify: _propTypes2.default.string
};

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0';

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = [
// German umlauts
['ß', 'ss'], ['ä', 'ae'], ['Ä', 'Ae'], ['ö', 'oe'], ['Ö', 'Oe'], ['ü', 'ue'], ['Ü', 'Ue'],

// Vietnamese
['à', 'a'], ['À', 'A'], ['á', 'a'], ['Á', 'A'], ['â', 'a'], ['Â', 'A'], ['ã', 'a'], ['Ã', 'A'], ['è', 'e'], ['È', 'E'], ['é', 'e'], ['É', 'E'], ['ê', 'e'], ['Ê', 'E'], ['ì', 'i'], ['Ì', 'I'], ['í', 'i'], ['Í', 'I'], ['ò', 'o'], ['Ò', 'O'], ['ó', 'o'], ['Ó', 'O'], ['ô', 'o'], ['Ô', 'O'], ['õ', 'o'], ['Õ', 'O'], ['ù', 'u'], ['Ù', 'U'], ['ú', 'u'], ['Ú', 'U'], ['ý', 'y'], ['Ý', 'Y'], ['ă', 'a'], ['Ă', 'A'], ['Đ', 'D'], ['đ', 'd'], ['ĩ', 'i'], ['Ĩ', 'I'], ['ũ', 'u'], ['Ũ', 'U'], ['ơ', 'o'], ['Ơ', 'O'], ['ư', 'u'], ['Ư', 'U'], ['ạ', 'a'], ['Ạ', 'A'], ['ả', 'a'], ['Ả', 'A'], ['ấ', 'a'], ['Ấ', 'A'], ['ầ', 'a'], ['Ầ', 'A'], ['ẩ', 'a'], ['Ẩ', 'A'], ['ẫ', 'a'], ['Ẫ', 'A'], ['ậ', 'a'], ['Ậ', 'A'], ['ắ', 'a'], ['Ắ', 'A'], ['ằ', 'a'], ['Ằ', 'A'], ['ẳ', 'a'], ['Ẳ', 'A'], ['ẵ', 'a'], ['Ẵ', 'A'], ['ặ', 'a'], ['Ặ', 'A'], ['ẹ', 'e'], ['Ẹ', 'E'], ['ẻ', 'e'], ['Ẻ', 'E'], ['ẽ', 'e'], ['Ẽ', 'E'], ['ế', 'e'], ['Ế', 'E'], ['ề', 'e'], ['Ề', 'E'], ['ể', 'e'], ['Ể', 'E'], ['ễ', 'e'], ['Ễ', 'E'], ['ệ', 'e'], ['Ệ', 'E'], ['ỉ', 'i'], ['Ỉ', 'I'], ['ị', 'i'], ['Ị', 'I'], ['ọ', 'o'], ['Ọ', 'O'], ['ỏ', 'o'], ['Ỏ', 'O'], ['ố', 'o'], ['Ố', 'O'], ['ồ', 'o'], ['Ồ', 'O'], ['ổ', 'o'], ['Ổ', 'O'], ['ỗ', 'o'], ['Ỗ', 'O'], ['ộ', 'o'], ['Ộ', 'O'], ['ớ', 'o'], ['Ớ', 'O'], ['ờ', 'o'], ['Ờ', 'O'], ['ở', 'o'], ['Ở', 'O'], ['ỡ', 'o'], ['Ỡ', 'O'], ['ợ', 'o'], ['Ợ', 'O'], ['ụ', 'u'], ['Ụ', 'U'], ['ủ', 'u'], ['Ủ', 'U'], ['ứ', 'u'], ['Ứ', 'U'], ['ừ', 'u'], ['Ừ', 'U'], ['ử', 'u'], ['Ử', 'U'], ['ữ', 'u'], ['Ữ', 'U'], ['ự', 'u'], ['Ự', 'U'], ['ỳ', 'y'], ['Ỳ', 'Y'], ['ỵ', 'y'], ['Ỵ', 'Y'], ['ỷ', 'y'], ['Ỷ', 'Y'], ['ỹ', 'y'], ['Ỹ', 'Y'],

// Arabic
['ء', 'e'], ['آ', 'a'], ['أ', 'a'], ['ؤ', 'w'], ['إ', 'i'], ['ئ', 'y'], ['ا', 'a'], ['ب', 'b'], ['ة', 't'], ['ت', 't'], ['ث', 'th'], ['ج', 'j'], ['ح', 'h'], ['خ', 'kh'], ['د', 'd'], ['ذ', 'dh'], ['ر', 'r'], ['ز', 'z'], ['س', 's'], ['ش', 'sh'], ['ص', 's'], ['ض', 'd'], ['ط', 't'], ['ظ', 'z'], ['ع', 'e'], ['غ', 'gh'], ['ـ', '_'], ['ف', 'f'], ['ق', 'q'], ['ك', 'k'], ['ل', 'l'], ['م', 'm'], ['ن', 'n'], ['ه', 'h'], ['و', 'w'], ['ى', 'a'], ['ي', 'y'], ['َ‎', 'a'], ['ُ', 'u'], ['ِ‎', 'i'], ['٠', '0'], ['١', '1'], ['٢', '2'], ['٣', '3'], ['٤', '4'], ['٥', '5'], ['٦', '6'], ['٧', '7'], ['٩', '9'], ['۸', '8'],

// Russian
['А', 'A'], ['а', 'a'], ['Б', 'B'], ['б', 'b'], ['В', 'V'], ['в', 'v'], ['Г', 'G'], ['г', 'g'], ['Д', 'D'], ['д', 'd'], ['Е', 'E'], ['е', 'e'], ['Ж', 'Zh'], ['ж', 'zh'], ['З', 'Z'], ['з', 'z'], ['И', 'I'], ['и', 'i'], ['Й', 'J'], ['й', 'j'], ['К', 'K'], ['к', 'k'], ['Л', 'L'], ['л', 'l'], ['М', 'M'], ['м', 'm'], ['Н', 'N'], ['н', 'n'], ['О', 'O'], ['о', 'o'], ['П', 'P'], ['п', 'p'], ['Р', 'R'], ['р', 'r'], ['С', 'S'], ['с', 's'], ['Т', 'T'], ['т', 't'], ['У', 'U'], ['у', 'u'], ['Ф', 'F'], ['ф', 'f'], ['Х', 'H'], ['х', 'h'], ['Ц', 'Cz'], ['ц', 'cz'], ['Ч', 'Ch'], ['ч', 'ch'], ['Ш', 'Sh'], ['ш', 'sh'], ['Щ', 'Shh'], ['щ', 'shh'], ['Ъ', ''], ['ъ', ''], ['Ы', 'Y'], ['ы', 'y'], ['Ь', ''], ['ь', ''], ['Э', 'E'], ['э', 'e'], ['Ю', 'Yu'], ['ю', 'yu'], ['Я', 'Ya'], ['я', 'ya'], ['Ё', 'Yo'], ['ё', 'yo'],

// Romanian
['ș', 's'], ['Ș', 's'], ['ț', 't'], ['Ț', 't']];

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = [['&', ' and '], ['🦄', ' unicorn '], ['♥', ' love ']];

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProviderCell = __webpack_require__(788);

Object.defineProperty(exports, 'ProviderCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ProviderCell).default;
  }
});

var _LocationsCell = __webpack_require__(789);

Object.defineProperty(exports, 'LocationsCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocationsCell).default;
  }
});

var _CheckCell = __webpack_require__(804);

Object.defineProperty(exports, 'CheckCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckCell).default;
  }
});

var _SlotsCell = __webpack_require__(805);

Object.defineProperty(exports, 'SlotsCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SlotsCell).default;
  }
});

var _SlotsPriceCell = __webpack_require__(806);

Object.defineProperty(exports, 'SlotsPriceCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SlotsPriceCell).default;
  }
});

var _ModsCell = __webpack_require__(807);

Object.defineProperty(exports, 'ModsCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModsCell).default;
  }
});

var _CheckListCell = __webpack_require__(727);

Object.defineProperty(exports, 'CheckListCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckListCell).default;
  }
});

var _PlatformsCell = __webpack_require__(808);

Object.defineProperty(exports, 'PlatformsCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PlatformsCell).default;
  }
});

var _CustomerSupportCell = __webpack_require__(809);

Object.defineProperty(exports, 'CustomerSupportCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CustomerSupportCell).default;
  }
});

var _RatingCell = __webpack_require__(810);

Object.defineProperty(exports, 'RatingCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RatingCell).default;
  }
});

var _ControlPanelCell = __webpack_require__(816);

Object.defineProperty(exports, 'ControlPanelCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ControlPanelCell).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactFittext = __webpack_require__(712);

var _reactFittext2 = _interopRequireDefault(_reactFittext);

var _imageUrl = __webpack_require__(166);

var _imageUrl2 = _interopRequireDefault(_imageUrl);

var _slugify = __webpack_require__(759);

var _slugify2 = _interopRequireDefault(_slugify);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyledCell = (0, _styledComponents2.default)(_styledCommon.Cell).withConfig({
  displayName: 'ProviderCell__StyledCell'
})(['text-align:center;font-size:14px;color:', ';width:100%;img{display:block;margin:0 auto;max-width:100%;}'], function (p) {
  return p.theme.textOffwhite;
});
var InnerCell = (0, _styledComponents2.default)(_styledCommon.Flex).withConfig({
  displayName: 'ProviderCell__InnerCell'
})(['height:100%;width:100%;align-content:center;']);
var A = (0, _styledComponents2.default)(_styledCommon.StyledAnchor).withConfig({
  displayName: 'ProviderCell__A'
})(['height:100%;width:100%;']);
var Img = _styledComponents2.default.img.withConfig({
  displayName: 'ProviderCell__Img'
})(['max-height:55px;']);
var affiliated = [];

var ProviderCell = function (_React$PureComponent) {
  _inherits(ProviderCell, _React$PureComponent);

  function ProviderCell(props) {
    _classCallCheck(this, ProviderCell);

    var _this = _possibleConstructorReturn(this, (ProviderCell.__proto__ || Object.getPrototypeOf(ProviderCell)).call(this, props));

    _this._addAffiliated = function () {
      affiliated.push(_this.props.host.id);
    };
    _this._builder = (0, _imageUrl2.default)(props.siteData.sanityConfig);
    return _this;
  }

  _createClass(ProviderCell, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.img && this.img.complete) {
        this._addAffiliated();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          affiliateUrl = _props.affiliateUrl,
          id = _props.id,
          logo = _props.logo,
          name = _props.name,
          site = _props.siteData.site,
          _props$fitText = _props.fitText,
          fitText = _props$fitText === undefined ? true : _props$fitText,
          props = _objectWithoutProperties(_props, ['affiliateUrl', 'id', 'logo', 'name', 'siteData', 'fitText']);

      var compressor = fitText === true ? 0.9 : fitText;
      var track = ~affiliated.indexOf(id) ? null : _react2.default.createElement(Img, { ref: function ref(img) {
          _this2.img = img;
        }, src: affiliateUrl, onLoad: this._addAffiliated, onError: this._addAffiliated, width: 1, height: 1, style: { position: 'absolute', marginTop: -20000 } });
      return _react2.default.createElement(
        StyledCell,
        props,
        _react2.default.createElement(
          A,
          { href: '/hosts/' + (0, _slugify2.default)(name) },
          _react2.default.createElement(
            InnerCell,
            { flexDirection: 'column' },
            _react2.default.createElement(Img, { src: this._builder.image(logo).height(55).url(), alt: name + ' ' + site.game.name + ' server host logo' }),
            _react2.default.createElement(
              'div',
              { style: { alignSelf: 'stretch', lineHeight: 2 } },
              _react2.default.createElement(
                _reactFittext2.default,
                { style: { width: '100%' }, compressor: compressor || 0 },
                name
              )
            )
          )
        )
      );
    }
  }]);

  return ProviderCell;
}(_react2.default.PureComponent);

exports.default = (0, _reactStatic.withSiteData)(ProviderCell);

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popover = __webpack_require__(722);

var _popover2 = _interopRequireDefault(_popover);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['', '', '', ''], ['', '', '', '']),
    _templateObject2 = _taggedTemplateLiteral(['', '', ''], ['', '', '']);

__webpack_require__(723);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactFlagIconCss = __webpack_require__(791);

var _reactFlagIconCss2 = _interopRequireDefault(_reactFlagIconCss);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

var _utils = __webpack_require__(261);

var _geodata = __webpack_require__(760);

var _geodata2 = _interopRequireDefault(_geodata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flag = (0, _reactFlagIconCss2.default)(_react2.default, { useCssModules: false });
var FlagItem = _styledComponents2.default.span.withConfig({
  displayName: 'LocationsCell__FlagItem'
})(['', ' font-size:1.7em;padding:0 4px;.flag-icon{border-radius:5px;box-shadow:1px 1px 4px 1px #000;border:1px solid rgba(255,255,255,0.1);background-size:cover;}'], '' /* margin-top: 4px; */);
var StyledCell = (0, _styledComponents2.default)(_styledCommon.Cell).withConfig({
  displayName: 'LocationsCell__StyledCell'
})(['text-align:center;font-size:14px;color:', ';width:100%;img{display:block;margin:0 auto;max-width:60%;}'], function (p) {
  return p.theme.textOffwhite;
});
var FlagsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LocationsCell__FlagsContainer'
})(['width:100%;margin:0 -4px;']);

var LocationsCell = function (_React$PureComponent) {
  _inherits(LocationsCell, _React$PureComponent);

  function LocationsCell(props) {
    _classCallCheck(this, LocationsCell);

    return _possibleConstructorReturn(this, (LocationsCell.__proto__ || Object.getPrototypeOf(LocationsCell)).call(this, props));
  }

  _createClass(LocationsCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currency = _props.currency,
          locations = _props.locations,
          justifyContent = _props.justifyContent,
          props = _objectWithoutProperties(_props, ['currency', 'locations', 'justifyContent']);

      if (!locations) return _react2.default.createElement(
        'div',
        null,
        'Missing Locations Data'
      );
      var flags = locations.sort(function (_ref, _ref2) {
        var a = _ref.country;
        var b = _ref2.country;

        return _geodata2.default.countries[a].name.localeCompare(_geodata2.default.countries[b].name);
      }).map(function (_ref3) {
        var countryCode = _ref3.country,
            pops = _ref3.pops,
            extra = _ref3.extra;

        var country = _geodata2.default.countries[countryCode];
        var countryName = country.name;

        var symbol = (0, _utils.currencySymbolByCode)(currency);
        var popsItems = pops && pops.map(function (_ref4) {
          var city = _ref4.city,
              state = _ref4.state,
              cityExtra = _ref4.extra;

          var popTitle = (0, _utils.noEmpty)(_templateObject, city, state ? (0, _utils.noEmpty)(_templateObject2, city && ', ', state) : '', cityExtra ? ' (+' + symbol + cityExtra + ')' : '');
          return _react2.default.createElement(
            'div',
            { key: city || state },
            popTitle
          );
        });
        var title = countryName + (extra > 0 ? ' (+' + symbol + extra + ')' : '');
        return _react2.default.createElement(
          _popover2.default,
          { key: countryCode, overlayClassName: popsItems ? '' : 'hide-inner-content', content: _react2.default.createElement(
              _react.Fragment,
              null,
              popsItems
            ), arrowPointAtCenter: true, title: title },
          _react2.default.createElement(
            FlagItem,
            { className: 'bah-flag' },
            _react2.default.createElement(Flag, { code: countryCode })
          )
        );
      });
      return _react2.default.createElement(
        StyledCell,
        props,
        _react2.default.createElement(
          FlagsContainer,
          { flexWrap: 'wrap', justifyContent: justifyContent || "space-between", alignItems: 'center' },
          flags
        )
      );
    }
  }]);

  return LocationsCell;
}(_react2.default.PureComponent);

exports.default = LocationsCell;

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__FlagIcon_FlagIconFactory__ = __webpack_require__(792);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "default", function () {
  return __WEBPACK_IMPORTED_MODULE_0__FlagIcon_FlagIconFactory__["b"];
});
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CustomFlagIconFactory", function () {
  return __WEBPACK_IMPORTED_MODULE_0__FlagIcon_FlagIconFactory__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__types_flow__ = __webpack_require__(803);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__types_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types_flow__);
/* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "types", function () {
  return __WEBPACK_IMPORTED_MODULE_1__types_flow__;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__functions__ = __webpack_require__(709);
/* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "functions", function () {
  return __WEBPACK_IMPORTED_MODULE_2__functions__;
});

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return CustomFlagIconFactory;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__FlagIcon__ = __webpack_require__(793);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(800);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__functions__ = __webpack_require__(709);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__functions_props__ = __webpack_require__(707);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__functions_styles__ = __webpack_require__(726);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__types_propTypes__ = __webpack_require__(725);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var FlagIconFactory = function FlagIconFactory(React, options) {
  var computedOptions = Object(__WEBPACK_IMPORTED_MODULE_2__functions__["makeFlagIconOptions"])(options);
  var useCssModules = computedOptions.useCssModules,
      customCodes = computedOptions.customCodes;

  var FlagIconComponent = null;

  if (useCssModules) {
    var computedStyles = Object(__WEBPACK_IMPORTED_MODULE_2__functions__["makeStyles"])(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* default */], options);
    if (false) {
      validateStyles(computedStyles, computedOptions, options);
    }

    FlagIconComponent = Object(__WEBPACK_IMPORTED_MODULE_0__FlagIcon__["a" /* default */])(React, computedOptions, computedStyles);
  } else {
    FlagIconComponent = Object(__WEBPACK_IMPORTED_MODULE_0__FlagIcon__["a" /* default */])(React, computedOptions);
  }
  FlagIconComponent.displayName = 'FlagIcon';

  if (false) {
    var codes = getCountryCodes();

    if (customCodes) {
      codes = [].concat(_toConsumableArray(codes), _toConsumableArray(Object.keys(customCodes)));
    }

    FlagIconComponent.propTypes = MakeFlagIconPropsType(codes);
  }

  return FlagIconComponent;
};

/* harmony default export */__webpack_exports__["b"] = FlagIconFactory;

var CustomFlagIconFactory = function CustomFlagIconFactory(React, options) {
  return FlagIconFactory(React, options);
};

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__functions__ = __webpack_require__(709);

var FlagIcon = function FlagIcon(React, options, styles) {
  return function (props) {
    var _props$Component = props.Component,
        Component = _props$Component === undefined ? 'span' : _props$Component,
        children = props.children;

    return React.createElement(Component, { className: Object(__WEBPACK_IMPORTED_MODULE_0__functions__["makeClassnames"])(props, options, styles) }, children);
  };
};

/* harmony default export */__webpack_exports__["a"] = FlagIcon;

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return makeClassesObject;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(25);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__functions_classNameToStyleName__ = __webpack_require__(795);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(724);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var makeClassesObject = function makeClassesObject(props, options) {
  var _ref;

  var code = props.code,
      _props$flip = props.flip,
      flip = _props$flip === undefined ? '' : _props$flip,
      _props$size = props.size,
      size = _props$size === undefined ? '' : _props$size,
      _props$squared = props.squared,
      squared = _props$squared === undefined ? false : _props$squared,
      rotate = props.rotate,
      className = props.className,
      styleName = props.styleName;
  var themeStyles = options.themeStyles,
      useCssModules = options.useCssModules;

  return _ref = {}, _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefixName"], true), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefix"] + 'squared', squared), _defineProperty(_ref, '' + __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefix"] + size, size), _defineProperty(_ref, '' + __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefix"] + code, code), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefix"] + 'flip-' + flip, flip), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_2__constants__["flagIconClassesPrefix"] + 'rotate-' + (rotate || ''), rotate), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_2__constants__["baseThemeStyleName"], useCssModules && themeStyles && themeStyles[__WEBPACK_IMPORTED_MODULE_2__constants__["baseThemeStyleName"]]), _defineProperty(_ref, styleName || '', useCssModules && themeStyles && styleName && themeStyles[styleName]), _defineProperty(_ref, className || '', className), _ref;
};

/* harmony default export */__webpack_exports__["a"] = function (props, options, styles) {
  var useCssModules = options.useCssModules;

  var classesObject = makeClassesObject(props, options);
  var strClasses = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(classesObject);

  if (useCssModules) {
    var aClasses = strClasses.split(' ');
    var nClasses = aClasses.length;

    strClasses = aClasses.map(function (c, i) {
      if (props.className && i === nClasses - 1) return c;

      return Object(__WEBPACK_IMPORTED_MODULE_1__functions_classNameToStyleName__["a" /* default */])(c, styles || {});
    }).join(' ');
  }
  return strClasses;
};

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony default export */__webpack_exports__["a"] = function (className, styles) {
  if (!styles[className]) {
    throw new Error('Could not resolve the styleName ' + className);
  }

  return styles[className];
};

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__types_propTypes__ = __webpack_require__(725);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var defaultOptions = {
  useCssModules: true
};

/* harmony default export */__webpack_exports__["a"] = function (options) {
  var computedOptions = _extends({}, defaultOptions, options);

  __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(Object(__WEBPACK_IMPORTED_MODULE_1__types_propTypes__["a" /* MakeFlagIconOptionsPropType */])(), computedOptions, 'key', 'FlagIconFactory options');
  return computedOptions;
};

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
  return sizes;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
  return rotates;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return flips;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return countries;
});

var sizes = ['lg', '2x', '3x', '4x', '5x'];

var rotates = [30, 60, 90, 180, 270];

var flips = ['horizontal', 'vertical'];

var countries = [{
  name: 'Afghanistan',
  code: 'af'
}, {
  name: 'Åland Islands',
  code: 'ax'
}, {
  name: 'Albania',
  code: 'al'
}, {
  name: 'Algeria',
  code: 'dz'
}, {
  name: 'American Samoa',
  code: 'as'
}, {
  name: 'Andorra',
  code: 'ad'
}, {
  name: 'Angola',
  code: 'ao'
}, {
  name: 'Anguilla',
  code: 'ai'
}, {
  name: 'Antarctica',
  code: 'aq'
}, {
  name: 'Antigua and Barbuda',
  code: 'ag'
}, {
  name: 'Argentina',
  code: 'ar'
}, {
  name: 'Armenia',
  code: 'am'
}, {
  name: 'Aruba',
  code: 'aw'
}, {
  name: 'Australia',
  code: 'au'
}, {
  name: 'Austria',
  code: 'at'
}, {
  name: 'Azerbaijan',
  code: 'az'
}, {
  name: 'Bahamas',
  code: 'bs'
}, {
  name: 'Bahrain',
  code: 'bh'
}, {
  name: 'Bangladesh',
  code: 'bd'
}, {
  name: 'Barbados',
  code: 'bb'
}, {
  name: 'Belarus',
  code: 'by'
}, {
  name: 'Belgium',
  code: 'be'
}, {
  name: 'Belize',
  code: 'bz'
}, {
  name: 'Benin',
  code: 'bj'
}, {
  name: 'Bermuda',
  code: 'bm'
}, {
  name: 'Bhutan',
  code: 'bt'
}, {
  name: 'Bolivia, Plurinational State of',
  code: 'bo'
}, {
  name: 'Bonaire, Sint Eustatius and Saba',
  code: 'bq'
}, {
  name: 'Bosnia and Herzegovina',
  code: 'ba'
}, {
  name: 'Botswana',
  code: 'bw'
}, {
  name: 'Bouvet Island',
  code: 'bv'
}, {
  name: 'Brazil',
  code: 'br'
}, {
  name: 'British Indian Ocean Territory',
  code: 'io'
}, {
  name: 'Brunei Darussalam',
  code: 'bn'
}, {
  name: 'Bulgaria',
  code: 'bg'
}, {
  name: 'Burkina Faso',
  code: 'bf'
}, {
  name: 'Burundi',
  code: 'bi'
}, {
  name: 'Cambodia',
  code: 'kh'
}, {
  name: 'Cameroon',
  code: 'cm'
}, {
  name: 'Canada',
  code: 'ca'
}, {
  name: 'Cape Verde',
  code: 'cv'
}, {
  name: 'Cayman Islands',
  code: 'ky'
}, {
  name: 'Central African Republic',
  code: 'cf'
}, {
  name: 'Chad',
  code: 'td'
}, {
  name: 'Chile',
  code: 'cl'
}, {
  name: 'China',
  code: 'cn'
}, {
  name: 'Christmas Island',
  code: 'cx'
}, {
  name: 'Cocos (Keeling) Islands',
  code: 'cc'
}, {
  name: 'Colombia',
  code: 'co'
}, {
  name: 'Comoros',
  code: 'km'
}, {
  name: 'Congo',
  code: 'cg'
}, {
  name: 'Congo, the Democratic Republic of the',
  code: 'cd'
}, {
  name: 'Cook Islands',
  code: 'ck'
}, {
  name: 'Costa Rica',
  code: 'cr'
}, {
  name: "Côte d'Ivoire",
  code: 'ci'
}, {
  name: 'Croatia',
  code: 'hr'
}, {
  name: 'Cuba',
  code: 'cu'
}, {
  name: 'Curaçao',
  code: 'cw'
}, {
  name: 'Cyprus',
  code: 'cy'
}, {
  name: 'Czech Republic',
  code: 'cz'
}, {
  name: 'Denmark',
  code: 'dk'
}, {
  name: 'Djibouti',
  code: 'dj'
}, {
  name: 'Dominica',
  code: 'dm'
}, {
  name: 'Dominican Republic',
  code: 'do'
}, {
  name: 'Ecuador',
  code: 'ec'
}, {
  name: 'Egypt',
  code: 'eg'
}, {
  name: 'El Salvador',
  code: 'sv'
}, {
  name: 'Equatorial Guinea',
  code: 'gq'
}, {
  name: 'Eritrea',
  code: 'er'
}, {
  name: 'Estonia',
  code: 'ee'
}, {
  name: 'Ethiopia',
  code: 'et'
}, {
  name: 'European Union',
  code: 'eu'
}, {
  name: 'Falkland Islands (Malvinas)',
  code: 'fk'
}, {
  name: 'Faroe Islands',
  code: 'fo'
}, {
  name: 'Fiji',
  code: 'fj'
}, {
  name: 'Finland',
  code: 'fi'
}, {
  name: 'France',
  code: 'fr'
}, {
  name: 'French Guiana',
  code: 'gf'
}, {
  name: 'French Polynesia',
  code: 'pf'
}, {
  name: 'French Southern Territories',
  code: 'tf'
}, {
  name: 'Gabon',
  code: 'ga'
}, {
  name: 'Gambia',
  code: 'gm'
}, {
  name: 'Georgia',
  code: 'ge'
}, {
  name: 'Germany',
  code: 'de'
}, {
  name: 'Ghana',
  code: 'gh'
}, {
  name: 'Gibraltar',
  code: 'gi'
}, {
  name: 'Greece',
  code: 'gr'
}, {
  name: 'Greenland',
  code: 'gl'
}, {
  name: 'Grenada',
  code: 'gd'
}, {
  name: 'Guadeloupe',
  code: 'gp'
}, {
  name: 'Guam',
  code: 'gu'
}, {
  name: 'Guatemala',
  code: 'gt'
}, {
  name: 'Guernsey',
  code: 'gg'
}, {
  name: 'Guinea',
  code: 'gn'
}, {
  name: 'Guinea-Bissau',
  code: 'gw'
}, {
  name: 'Guyana',
  code: 'gy'
}, {
  name: 'Haiti',
  code: 'ht'
}, {
  name: 'Heard Island and McDonald Islands',
  code: 'hm'
}, {
  name: 'Holy See (Vatican City State)',
  code: 'va'
}, {
  name: 'Honduras',
  code: 'hn'
}, {
  name: 'Hong Kong',
  code: 'hk'
}, {
  name: 'Hungary',
  code: 'hu'
}, {
  name: 'Iceland',
  code: 'is'
}, {
  name: 'India',
  code: 'in'
}, {
  name: 'Indonesia',
  code: 'id'
}, {
  name: 'Iran, Islamic Republic of',
  code: 'ir'
}, {
  name: 'Iraq',
  code: 'iq'
}, {
  name: 'Ireland',
  code: 'ie'
}, {
  name: 'Isle of Man',
  code: 'im'
}, {
  name: 'Israel',
  code: 'il'
}, {
  name: 'Italy',
  code: 'it'
}, {
  name: 'Jamaica',
  code: 'jm'
}, {
  name: 'Japan',
  code: 'jp'
}, {
  name: 'Jersey',
  code: 'je'
}, {
  name: 'Jordan',
  code: 'jo'
}, {
  name: 'Kazakhstan',
  code: 'kz'
}, {
  name: 'Kenya',
  code: 'ke'
}, {
  name: 'Kiribati',
  code: 'ki'
}, {
  name: "Korea, Democratic People's Republic of",
  code: 'kp'
}, {
  name: 'Korea, Republic of',
  code: 'kr'
}, {
  name: 'Kuwait',
  code: 'kw'
}, {
  name: 'Kyrgyzstan',
  code: 'kg'
}, {
  name: "Lao People's Democratic Republic",
  code: 'la'
}, {
  name: 'Latvia',
  code: 'lv'
}, {
  name: 'Lebanon',
  code: 'lb'
}, {
  name: 'Lesotho',
  code: 'ls'
}, {
  name: 'Liberia',
  code: 'lr'
}, {
  name: 'Libya',
  code: 'ly'
}, {
  name: 'Liechtenstein',
  code: 'li'
}, {
  name: 'Lithuania',
  code: 'lt'
}, {
  name: 'Luxembourg',
  code: 'lu'
}, {
  name: 'Macao',
  code: 'mo'
}, {
  name: 'Macedonia, the Former Yugoslav Republic of',
  code: 'mk'
}, {
  name: 'Madagascar',
  code: 'mg'
}, {
  name: 'Malawi',
  code: 'mw'
}, {
  name: 'Malaysia',
  code: 'my'
}, {
  name: 'Maldives',
  code: 'mv'
}, {
  name: 'Mali',
  code: 'ml'
}, {
  name: 'Malta',
  code: 'mt'
}, {
  name: 'Marshall Islands',
  code: 'mh'
}, {
  name: 'Martinique',
  code: 'mq'
}, {
  name: 'Mauritania',
  code: 'mr'
}, {
  name: 'Mauritius',
  code: 'mu'
}, {
  name: 'Mayotte',
  code: 'yt'
}, {
  name: 'Mexico',
  code: 'mx'
}, {
  name: 'Micronesia, Federated States of',
  code: 'fm'
}, {
  name: 'Moldova, Republic of',
  code: 'md'
}, {
  name: 'Monaco',
  code: 'mc'
}, {
  name: 'Mongolia',
  code: 'mn'
}, {
  name: 'Montenegro',
  code: 'me'
}, {
  name: 'Montserrat',
  code: 'ms'
}, {
  name: 'Morocco',
  code: 'ma'
}, {
  name: 'Mozambique',
  code: 'mz'
}, {
  name: 'Myanmar',
  code: 'mm'
}, {
  name: 'Namibia',
  code: 'na'
}, {
  name: 'Nauru',
  code: 'nr'
}, {
  name: 'Nepal',
  code: 'np'
}, {
  name: 'Netherlands',
  code: 'nl'
}, {
  name: 'New Caledonia',
  code: 'nc'
}, {
  name: 'New Zealand',
  code: 'nz'
}, {
  name: 'Nicaragua',
  code: 'ni'
}, {
  name: 'Niger',
  code: 'ne'
}, {
  name: 'Nigeria',
  code: 'ng'
}, {
  name: 'Niue',
  code: 'nu'
}, {
  name: 'Norfolk Island',
  code: 'nf'
}, {
  name: 'Northern Mariana Islands',
  code: 'mp'
}, {
  name: 'Norway',
  code: 'no'
}, {
  name: 'Oman',
  code: 'om'
}, {
  name: 'Pakistan',
  code: 'pk'
}, {
  name: 'Palau',
  code: 'pw'
}, {
  name: 'Palestine, State of',
  code: 'ps'
}, {
  name: 'Panama',
  code: 'pa'
}, {
  name: 'Papua New Guinea',
  code: 'pg'
}, {
  name: 'Paraguay',
  code: 'py'
}, {
  name: 'Peru',
  code: 'pe'
}, {
  name: 'Philippines',
  code: 'ph'
}, {
  name: 'Pitcairn',
  code: 'pn'
}, {
  name: 'Poland',
  code: 'pl'
}, {
  name: 'Portugal',
  code: 'pt'
}, {
  name: 'Puerto Rico',
  code: 'pr'
}, {
  name: 'Qatar',
  code: 'qa'
}, {
  name: 'Réunion',
  code: 're'
}, {
  name: 'Romania',
  code: 'ro'
}, {
  name: 'Russian Federation',
  code: 'ru'
}, {
  name: 'Rwanda',
  code: 'rw'
}, {
  name: 'Saint Barthélemy',
  code: 'bl'
}, {
  name: 'Saint Helena, Ascension and Tristan da Cunha',
  code: 'sh'
}, {
  name: 'Saint Kitts and Nevis',
  code: 'kn'
}, {
  name: 'Saint Lucia',
  code: 'lc'
}, {
  name: 'Saint Martin (French part)',
  code: 'mf'
}, {
  name: 'Saint Pierre and Miquelon',
  code: 'pm'
}, {
  name: 'Saint Vincent and the Grenadines',
  code: 'vc'
}, {
  name: 'Samoa',
  code: 'ws'
}, {
  name: 'San Marino',
  code: 'sm'
}, {
  name: 'Sao Tome and Principe',
  code: 'st'
}, {
  name: 'Saudi Arabia',
  code: 'sa'
}, {
  name: 'Senegal',
  code: 'sn'
}, {
  name: 'Serbia',
  code: 'rs'
}, {
  name: 'Seychelles',
  code: 'sc'
}, {
  name: 'Sierra Leone',
  code: 'sl'
}, {
  name: 'Singapore',
  code: 'sg'
}, {
  name: 'Sint Maarten (Dutch part)',
  code: 'sx'
}, {
  name: 'Slovakia',
  code: 'sk'
}, {
  name: 'Slovenia',
  code: 'si'
}, {
  name: 'Solomon Islands',
  code: 'sb'
}, {
  name: 'Somalia',
  code: 'so'
}, {
  name: 'South Africa',
  code: 'za'
}, {
  name: 'South Georgia and the South Sandwich Islands',
  code: 'gs'
}, {
  name: 'South Sudan',
  code: 'ss'
}, {
  name: 'Spain',
  code: 'es'
}, {
  name: 'Sri Lanka',
  code: 'lk'
}, {
  name: 'Sudan',
  code: 'sd'
}, {
  name: 'Suriname',
  code: 'sr'
}, {
  name: 'Svalbard and Jan Mayen',
  code: 'sj'
}, {
  name: 'Swaziland',
  code: 'sz'
}, {
  name: 'Sweden',
  code: 'se'
}, {
  name: 'Switzerland',
  code: 'ch'
}, {
  name: 'Syrian Arab Republic',
  code: 'sy'
}, {
  name: 'Taiwan, Province of China',
  code: 'tw'
}, {
  name: 'Tajikistan',
  code: 'tj'
}, {
  name: 'Tanzania, United Republic of',
  code: 'tz'
}, {
  name: 'Thailand',
  code: 'th'
}, {
  name: 'Timor-Leste',
  code: 'tl'
}, {
  name: 'Togo',
  code: 'tg'
}, {
  name: 'Tokelau',
  code: 'tk'
}, {
  name: 'Tonga',
  code: 'to'
}, {
  name: 'Trinidad and Tobago',
  code: 'tt'
}, {
  name: 'Tunisia',
  code: 'tn'
}, {
  name: 'Turkey',
  code: 'tr'
}, {
  name: 'Turkmenistan',
  code: 'tm'
}, {
  name: 'Turks and Caicos Islands',
  code: 'tc'
}, {
  name: 'Tuvalu',
  code: 'tv'
}, {
  name: 'Uganda',
  code: 'ug'
}, {
  name: 'Ukraine',
  code: 'ua'
}, {
  name: 'United Arab Emirates',
  code: 'ae'
}, {
  name: 'United Kingdom',
  code: 'gb'
}, {
  name: 'England',
  code: 'gb-eng'
}, {
  name: 'Northern Ireland',
  code: 'gb-nir'
}, {
  name: 'Scotland',
  code: 'gb-sct'
}, {
  name: 'Wales',
  code: 'gb-wls'
}, {
  name: 'United Nations',
  code: 'un'
}, {
  name: 'United States',
  code: 'us'
}, {
  name: 'United States Minor Outlying Islands',
  code: 'um'
}, {
  name: 'Uruguay',
  code: 'uy'
}, {
  name: 'Uzbekistan',
  code: 'uz'
}, {
  name: 'Vanuatu',
  code: 'vu'
}, {
  name: 'Venezuela, Bolivarian Republic of',
  code: 've'
}, {
  name: 'Viet Nam',
  code: 'vn'
}, {
  name: 'Virgin Islands, British',
  code: 'vg'
}, {
  name: 'Virgin Islands, U.S.',
  code: 'vi'
}, {
  name: 'Wallis and Futuna',
  code: 'wf'
}, {
  name: 'Western Sahara',
  code: 'eh'
}, {
  name: 'Yemen',
  code: 'ye'
}, {
  name: 'Zambia',
  code: 'zm'
}, {
  name: 'Zimbabwe',
  code: 'zw'
}];

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return AddThemeStylesValidator;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return AddExactValidator;
});
var _this = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var fnThemeStylesValidator = function fnThemeStylesValidator(propsObject, propsValues, propName, componentName) {
  var useCssModules = propsValues.useCssModules,
      customCodes = propsValues.customCodes;

  if (!useCssModules) return;

  if (customCodes) {
    var themeStyles = propsValues.themeStyles;

    if (themeStyles) {
      var themeStylesClassNames = Object.keys(themeStyles);
      var result = Object.keys(customCodes).filter(function (customCode) {
        return !themeStylesClassNames.includes('flag-icon-' + customCode);
      });

      if (result.length > 0) {
        return new Error('Invalid prop(s) `themeStyles` supplied to `' + componentName + '`, expected `.flag-icon-[' + result.join('/') + ']`.');
      }
    } else {
      return new Error('Missing required prop(s) `themeStyles` supplied to `' + componentName + '`.');
    }
  }
};

var AddThemeStylesValidator = function AddThemeStylesValidator(obj) {
  var validatorKeyName = '__themeStyles__';
  if (Object.prototype.hasOwnProperty.call(obj, validatorKeyName)) {
    return obj;
  }

  return _extends({}, obj, _defineProperty({}, validatorKeyName, fnThemeStylesValidator.bind(_this, obj)));
};

var fnExactValidator = function fnExactValidator(propsObject, propsValues, propName, componentName) {
  var passedPropNames = Object.keys(propsValues);
  var extra = passedPropNames.filter(function (prop) {
    return !Object.prototype.hasOwnProperty.call(propsObject, prop);
  });

  if (extra.length > 0) {
    return new Error('Invalid prop(s) ' + JSON.stringify(extra) + ' supplied to `' + componentName + '`, expected one of [' + passedPropNames.join(',') + '].');
  }
};

var AddExactValidator = function AddExactValidator(obj) {
  var validatorKeyName = '__exact__';
  if (Object.prototype.hasOwnProperty.call(obj, validatorKeyName)) {
    return obj;
  }

  return _extends({}, obj, _defineProperty({}, validatorKeyName, fnExactValidator.bind(_this, obj)));
};

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__props__ = __webpack_require__(707);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "getCountries", function () {
  return __WEBPACK_IMPORTED_MODULE_0__props__["a"];
});
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "getCountryCodes", function () {
  return __WEBPACK_IMPORTED_MODULE_0__props__["b"];
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__ = __webpack_require__(801);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__styles_main_css__ = __webpack_require__(802);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_main_css__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var finalStyles = _extends({}, __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css___default.a, __WEBPACK_IMPORTED_MODULE_1__styles_main_css___default.a);

/* harmony default export */__webpack_exports__["a"] = finalStyles;

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
"use strict";

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

"use strict";

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckCell = function (_React$PureComponent) {
  _inherits(CheckCell, _React$PureComponent);

  function CheckCell() {
    _classCallCheck(this, CheckCell);

    return _possibleConstructorReturn(this, (CheckCell.__proto__ || Object.getPrototypeOf(CheckCell)).apply(this, arguments));
  }

  _createClass(CheckCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['checked', 'children']);

      return _react2.default.createElement(
        _styledCommon.Cell,
        props,
        _react2.default.createElement(
          'span',
          null,
          checked ? _react2.default.createElement(_styledCommon.Icons.Check, null) : _react2.default.createElement(_styledCommon.Icons.Error, null),
          children
        )
      );
    }
  }]);

  return CheckCell;
}(_react2.default.PureComponent);

exports.default = CheckCell;

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const MinMax = styled.span``
var SlotsCell = function (_React$PureComponent) {
    _inherits(SlotsCell, _React$PureComponent);

    function SlotsCell() {
        _classCallCheck(this, SlotsCell);

        return _possibleConstructorReturn(this, (SlotsCell.__proto__ || Object.getPrototypeOf(SlotsCell)).apply(this, arguments));
    }

    _createClass(SlotsCell, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$slots = _props.slots,
                unlimited = _props$slots.unlimited,
                max = _props$slots.max,
                min = _props$slots.min,
                props = _objectWithoutProperties(_props, ['slots']);

            return _react2.default.createElement(
                _styledCommon.Cell,
                props,
                unlimited ? 'Unlimited' : min + '-' + max,
                ' slots'
            );
        }
    }]);

    return SlotsCell;
}(_react2.default.PureComponent);

exports.default = SlotsCell;

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledCommon = __webpack_require__(260);

var _utils = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlotsPriceCell = function (_React$PureComponent) {
  _inherits(SlotsPriceCell, _React$PureComponent);

  function SlotsPriceCell() {
    _classCallCheck(this, SlotsPriceCell);

    return _possibleConstructorReturn(this, (SlotsPriceCell.__proto__ || Object.getPrototypeOf(SlotsPriceCell)).apply(this, arguments));
  }

  _createClass(SlotsPriceCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          price = _props.price,
          slots = _props.slots,
          currency = _props.currency,
          props = _objectWithoutProperties(_props, ['price', 'slots', 'currency']);

      var symb = (0, _utils.currencySymbolByCode)(currency);
      var priceMax = price.max.toFixed(2);
      var priceMin = price.min.toFixed(2);
      return _react2.default.createElement(
        _styledCommon.Cell,
        _extends({}, props, { alignItems: 'flex-end', justifyContent: 'space-around' }),
        _react2.default.createElement(
          _styledCommon.Flex,
          { flexDirection: 'column', alignItems: 'flex-start' },
          _react2.default.createElement(
            'div',
            null,
            'Price'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Slots'
          )
        ),
        _react2.default.createElement(
          _styledCommon.Flex,
          { flexDirection: 'column', alignItems: 'flex-end' },
          _react2.default.createElement(
            'div',
            null,
            symb,
            priceMax
          ),
          _react2.default.createElement(
            'div',
            null,
            slots.min
          )
        ),
        _react2.default.createElement(
          _styledCommon.Flex,
          { flexDirection: 'column', alignItems: 'flex-end' },
          _react2.default.createElement(
            'div',
            null,
            symb,
            priceMin
          ),
          _react2.default.createElement(
            'div',
            null,
            slots.max
          )
        )
      );
    }
  }]);

  return SlotsPriceCell;
}(_react2.default.PureComponent);

exports.default = SlotsPriceCell;

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledCommon = __webpack_require__(260);

var _CheckListCell = __webpack_require__(727);

var _CheckListCell2 = _interopRequireDefault(_CheckListCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// insert if
var a = [];
var ii = function ii(condition) {
    for (var _len = arguments.length, elements = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        elements[_key - 1] = arguments[_key];
    }

    return condition ? elements : a;
};

var ModsCell = function (_React$PureComponent) {
    _inherits(ModsCell, _React$PureComponent);

    function ModsCell() {
        _classCallCheck(this, ModsCell);

        return _possibleConstructorReturn(this, (ModsCell.__proto__ || Object.getPrototypeOf(ModsCell)).apply(this, arguments));
    }

    _createClass(ModsCell, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                mods = _props.mods,
                props = _objectWithoutProperties(_props, ['mods']);

            if (!mods) return _react2.default.createElement(_styledCommon.Cell, props);
            var list = [].concat(_toConsumableArray(ii(mods.supported, 'All Mods Supported')), _toConsumableArray(ii(mods.autoUpdate, 'Auto Updating Mods')), _toConsumableArray(ii(mods.oneclick, '1-Click Install & Update')), _toConsumableArray(ii(mods.modManager, 'Mod Manager GUI')));
            return _react2.default.createElement(
                _styledCommon.Cell,
                props,
                _react2.default.createElement(_CheckListCell2.default, { list: list })
            );
        }
    }]);

    return ModsCell;
}(_react2.default.PureComponent);

exports.default = ModsCell;

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Xbox = _styledCommon.Icons.Xbox,
    Playstation = _styledCommon.Icons.Playstation,
    Steam = _styledCommon.Icons.Steam;

var UL = _styledComponents2.default.ul.withConfig({
  displayName: 'PlatformsCell__UL'
})(['list-style:none;display:flex !important;flex-wrap:wrap;width:100%;align-items:center;justify-content:space-around;padding:0 6% !important;margin:0;']);

var Platform = function (_React$PureComponent) {
  _inherits(Platform, _React$PureComponent);

  function Platform() {
    _classCallCheck(this, Platform);

    return _possibleConstructorReturn(this, (Platform.__proto__ || Object.getPrototypeOf(Platform)).apply(this, arguments));
  }

  _createClass(Platform, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['type']);

      return _react2.default.createElement(
        'li',
        props,
        type === 'pc' ? _react2.default.createElement(Steam, null) : type === 'xbox' ? _react2.default.createElement(Xbox, null) : type === 'playstation' ? _react2.default.createElement(Playstation, null) : null
      );
    }
  }]);

  return Platform;
}(_react2.default.PureComponent);

var StPlatform = (0, _styledComponents2.default)(Platform).withConfig({
  displayName: 'PlatformsCell__StPlatform'
})(['padding:0 3px;max-width:50%;&:first-child{margin-left:0;}&:only-child{max-width:70%;}&:last-child{margin-right:0;}svg{height:100%;width:100%;}']);

var PlatformsCell = function (_React$PureComponent2) {
  _inherits(PlatformsCell, _React$PureComponent2);

  function PlatformsCell() {
    _classCallCheck(this, PlatformsCell);

    return _possibleConstructorReturn(this, (PlatformsCell.__proto__ || Object.getPrototypeOf(PlatformsCell)).apply(this, arguments));
  }

  _createClass(PlatformsCell, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          platforms = _props2.platforms,
          props = _objectWithoutProperties(_props2, ['platforms']);
      /*         const plats = platforms.reduce((sum, plat) => {
              sum[plat] = true
              return sum
          }, {}) */


      var plats = platforms.map(function (plat) {
        return _react2.default.createElement(StPlatform, { key: plat, type: plat });
      });
      return _react2.default.createElement(
        _styledCommon.Cell,
        props,
        _react2.default.createElement(
          UL,
          null,
          plats
        )
      );
    }
  }]);

  return PlatformsCell;
}(_react2.default.PureComponent);

exports.default = PlatformsCell;

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popover = __webpack_require__(722);

var _popover2 = _interopRequireDefault(_popover);

var _icon = __webpack_require__(75);

var _icon2 = _interopRequireDefault(_icon);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(723);

__webpack_require__(263);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Breaker = _styledComponents2.default.div.withConfig({
  displayName: 'CustomerSupportCell__Breaker'
})(['display:none;&:nth-child(4n){display:block;width:100%;height:1px;}']);
var StIcon = (0, _styledComponents2.default)(_icon2.default).withConfig({
  displayName: 'CustomerSupportCell__StIcon'
})(['padding:5px 4px;']);
var StCell = (0, _styledComponents2.default)(_styledCommon.Cell).withConfig({
  displayName: 'CustomerSupportCell__StCell'
})(['font-size:1.5em;align-content:center;']);

exports.default = function (props) {
  var _props$support = props.support,
      email = _props$support.email,
      ticket = _props$support.ticket,
      chat = _props$support.chat,
      is247 = _props$support.is247,
      p = _objectWithoutProperties(props, ['support']);

  return _react2.default.createElement(
    StCell,
    _extends({}, p, { flexWrap: 'wrap' }),
    _react2.default.createElement(
      _react.Fragment,
      null,
      chat && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _popover2.default,
          { content: 'Live Chat' },
          _react2.default.createElement(StIcon, { type: 'message' })
        ),
        _react2.default.createElement(Breaker, null)
      ),
      ' ',
      email && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _popover2.default,
          { content: 'Email' },
          _react2.default.createElement(StIcon, { type: 'mail' })
        ),
        _react2.default.createElement(Breaker, null)
      ),
      ' ',
      ticket && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _popover2.default,
          { content: 'Ticket System' },
          _react2.default.createElement(StIcon, { type: 'tag-o' })
        ),
        _react2.default.createElement(Breaker, null)
      ),
      ' ',
      is247 && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _popover2.default,
          { content: '24/7 Support' },
          _react2.default.createElement(StIcon, { type: 'clock-circle-o' })
        ),
        _react2.default.createElement(Breaker, null)
      ),
      ' '
    )
  );
};

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rate = __webpack_require__(763);

var _rate2 = _interopRequireDefault(_rate);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(764);

var _reactFittext = __webpack_require__(712);

var _reactFittext2 = _interopRequireDefault(_reactFittext);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import Rater from 'react-rater'


var A = _styledComponents2.default.a.withConfig({
    displayName: 'RatingCell__A'
})(['font-size:20px;text-align:center;color:', ';width:100%;line-height:1.3;'], function (p) {
    return p.theme.textOffwhite;
});

var RatingCell = function (_React$PureComponent) {
    _inherits(RatingCell, _React$PureComponent);

    function RatingCell(props) {
        _classCallCheck(this, RatingCell);

        var _this = _possibleConstructorReturn(this, (RatingCell.__proto__ || Object.getPrototypeOf(RatingCell)).call(this, props));

        _this._trackAffiliate = function () {
            if (!_this.state.track) _this.setState({ track: true });
        };
        _this.state = { track: false };
        return _this;
    }

    _createClass(RatingCell, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$rating = _props.rating,
                score = _props$rating.score,
                stars = _props$rating.stars,
                url = _props$rating.url,
                reviewCount = _props$rating.reviewCount,
                affiliateUrl = _props.affiliateUrl,
                _props$fitText = _props.fitText,
                fitText = _props$fitText === undefined ? true : _props$fitText,
                props = _objectWithoutProperties(_props, ['rating', 'affiliateUrl', 'fitText']);

            var rate = _react2.default.createElement(_rate2.default, { disabled: true, allowHalf: false, defaultValue: stars, count: 5 });
            var rating = fitText ? _react2.default.createElement(
                _reactFittext2.default,
                { compressor: 0.7 },
                rate
            ) : rate;
            return _react2.default.createElement(
                _styledCommon.Cell,
                props,
                this.state.track ? _react2.default.createElement('img', { alt: '', width: 1, height: 1, style: { marginTop: -20000, position: 'absolute' }, src: affiliateUrl }) : null,
                _react2.default.createElement(
                    A,
                    { href: url, onClick: this._trackAffiliate, target: '_blank', rel: 'nofollow noreferrer noopener' },
                    _react2.default.createElement(
                        'div',
                        null,
                        score
                    ),
                    rating,
                    ' ',
                    reviewCount ? '(' + reviewCount + ' reviews)' : null
                )
            );
        }
    }]);

    return RatingCell;
}(_react2.default.PureComponent);

exports.default = RatingCell;

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rate__ = __webpack_require__(812);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Rate__["a" /* default */]);

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Star__ = __webpack_require__(814);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function noop() {}

var Rate = function (_React$Component) {
  _inherits(Rate, _React$Component);

  function Rate(props) {
    _classCallCheck(this, Rate);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;
    if (value === undefined) {
      value = props.defaultValue;
    }

    _this.stars = {};

    _this.state = {
      value: value,
      focused: false,
      cleanedValue: null
    };
    return _this;
  }

  Rate.prototype.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus && !this.props.disabled) {
      this.focus();
    }
  };

  Rate.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    if ('value' in nextProps && nextProps.value !== undefined) {
      return _extends({}, state, {
        value: nextProps.value
      });
    }
    return state;
  };

  Rate.prototype.getStarDOM = function getStarDOM(index) {
    return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.stars[index]);
  };

  Rate.prototype.getStarValue = function getStarValue(index, x) {
    var value = index + 1;
    if (this.props.allowHalf) {
      var starEle = this.getStarDOM(index);
      var leftDis = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getOffsetLeft */])(starEle);
      var width = starEle.clientWidth;
      if (x - leftDis < width / 2) {
        value -= 0.5;
      }
    }
    return value;
  };

  Rate.prototype.focus = function focus() {
    if (!this.props.disabled) {
      this.rate.focus();
    }
  };

  Rate.prototype.blur = function blur() {
    if (!this.props.disabled) {
      this.rate.focus();
    }
  };

  Rate.prototype.changeValue = function changeValue(value) {
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
    this.props.onChange(value);
  };

  Rate.prototype.render = function render() {
    var _props = this.props,
        count = _props.count,
        allowHalf = _props.allowHalf,
        style = _props.style,
        prefixCls = _props.prefixCls,
        disabled = _props.disabled,
        className = _props.className,
        character = _props.character,
        tabIndex = _props.tabIndex;
    var _state = this.state,
        value = _state.value,
        hoverValue = _state.hoverValue,
        focused = _state.focused;

    var stars = [];
    var disabledClass = disabled ? prefixCls + '-disabled' : '';
    for (var index = 0; index < count; index++) {
      stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Star__["a" /* default */], {
        ref: this.saveRef(index),
        index: index,
        count: count,
        disabled: disabled,
        prefixCls: prefixCls + '-star',
        allowHalf: allowHalf,
        value: hoverValue === undefined ? value : hoverValue,
        onClick: this.onClick,
        onHover: this.onHover,
        key: index,
        character: character,
        focused: focused
      }));
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, disabledClass, className),
        style: style,
        onMouseLeave: disabled ? null : this.onMouseLeave,
        tabIndex: disabled ? -1 : tabIndex,
        onFocus: disabled ? null : this.onFocus,
        onBlur: disabled ? null : this.onBlur,
        onKeyDown: disabled ? null : this.onKeyDown,
        ref: this.saveRate,
        role: 'radiogroup'
      },
      stars
    );
  };

  return Rate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Rate.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  defaultValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  count: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  allowHalf: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  allowClear: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onHoverChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  character: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
Rate.defaultProps = {
  defaultValue: 0,
  count: 5,
  allowHalf: false,
  allowClear: true,
  style: {},
  prefixCls: 'rc-rate',
  onChange: noop,
  character: '★',
  onHoverChange: noop,
  tabIndex: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onHover = function (event, index) {
    var hoverValue = _this2.getStarValue(index, event.pageX);
    var cleanedValue = _this2.state.cleanedValue;

    if (hoverValue !== cleanedValue) {
      _this2.setState({
        hoverValue: hoverValue,
        cleanedValue: null
      });
    }
    _this2.props.onHoverChange(hoverValue);
  };

  this.onMouseLeave = function () {
    _this2.setState({
      hoverValue: undefined,
      cleanedValue: null
    });
    _this2.props.onHoverChange(undefined);
  };

  this.onClick = function (event, index) {
    var value = _this2.getStarValue(index, event.pageX);
    var isReset = false;
    if (_this2.props.allowClear) {
      isReset = value === _this2.state.value;
    }
    _this2.onMouseLeave(true);
    _this2.changeValue(isReset ? 0 : value);
    _this2.setState({
      cleanedValue: isReset ? value : null
    });
  };

  this.onFocus = function () {
    var onFocus = _this2.props.onFocus;

    _this2.setState({
      focused: true
    });
    if (onFocus) {
      onFocus();
    }
  };

  this.onBlur = function () {
    var onBlur = _this2.props.onBlur;

    _this2.setState({
      focused: false
    });
    if (onBlur) {
      onBlur();
    }
  };

  this.onKeyDown = function (event) {
    var keyCode = event.keyCode;
    var _props2 = _this2.props,
        count = _props2.count,
        allowHalf = _props2.allowHalf,
        onKeyDown = _props2.onKeyDown;
    var value = _this2.state.value;

    if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].RIGHT && value < count) {
      if (allowHalf) {
        value += 0.5;
      } else {
        value += 1;
      }
      _this2.changeValue(value);
      event.preventDefault();
    } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].LEFT && value > 0) {
      if (allowHalf) {
        value -= 0.5;
      } else {
        value -= 1;
      }
      _this2.changeValue(value);
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  this.saveRef = function (index) {
    return function (node) {
      _this2.stars[index] = node;
    };
  };

  this.saveRate = function (node) {
    _this2.rate = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Rate);

/* harmony default export */ __webpack_exports__["a"] = (Rate);

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetLeft;
function getScroll(w, top) {
  var ret = top ? w.pageYOffset : w.pageXOffset;
  var method = top ? 'scrollTop' : 'scrollLeft';
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  return pos.left;
}

/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Star = function (_React$Component) {
  _inherits(Star, _React$Component);

  function Star() {
    var _temp, _this, _ret;

    _classCallCheck(this, Star);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onHover = function (e) {
      var _this$props = _this.props,
          onHover = _this$props.onHover,
          index = _this$props.index;

      onHover(e, index);
    }, _this.onClick = function (e) {
      var _this$props2 = _this.props,
          onClick = _this$props2.onClick,
          index = _this$props2.index;

      onClick(e, index);
    }, _this.onKeyDown = function (e) {
      var _this$props3 = _this.props,
          onClick = _this$props3.onClick,
          index = _this$props3.index;

      if (e.keyCode === 13) {
        onClick(e, index);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Star.prototype.getClassName = function getClassName() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        index = _props.index,
        value = _props.value,
        allowHalf = _props.allowHalf,
        focused = _props.focused;

    var starValue = index + 1;
    var className = prefixCls;
    if (value === 0 && index === 0 && focused) {
      className += ' ' + prefixCls + '-focused';
    } else if (allowHalf && value + 0.5 === starValue) {
      className += ' ' + prefixCls + '-half ' + prefixCls + '-active';
      if (focused) {
        className += ' ' + prefixCls + '-focused';
      }
    } else {
      className += starValue <= value ? ' ' + prefixCls + '-full' : ' ' + prefixCls + '-zero';
      if (starValue === value && focused) {
        className += ' ' + prefixCls + '-focused';
      }
    }
    return className;
  };

  Star.prototype.render = function render() {
    var onHover = this.onHover,
        onClick = this.onClick,
        onKeyDown = this.onKeyDown;
    var _props2 = this.props,
        disabled = _props2.disabled,
        prefixCls = _props2.prefixCls,
        character = _props2.character,
        index = _props2.index,
        count = _props2.count,
        value = _props2.value;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      {
        className: this.getClassName(),
        onClick: disabled ? null : onClick,
        onKeyDown: disabled ? null : onKeyDown,
        onMouseMove: disabled ? null : onHover,
        role: 'radio',
        'aria-checked': value > index ? 'true' : 'false',
        'aria-posinset': index + 1,
        'aria-setsize': count,
        tabIndex: 0
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-first' },
        character
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-second' },
        character
      )
    );
  };

  return Star;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Star.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  allowHalf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  character: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  focused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (Star);

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _imageUrl = __webpack_require__(166);

var _imageUrl2 = _interopRequireDefault(_imageUrl);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledCommon = __webpack_require__(260);

var _Gallery = __webpack_require__(765);

var _Gallery2 = _interopRequireDefault(_Gallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StGallery = (0, _styledComponents2.default)(_Gallery2.default).withConfig({
    displayName: 'ControlPanelCell__StGallery'
})(['a{max-width:70%;margin-top:4px;img{max-width:100%;}}margin:10px;']);
var StFlex = (0, _styledComponents2.default)(_styledCommon.Flex).withConfig({
    displayName: 'ControlPanelCell__StFlex'
})(['font-size:0.9em;height:100%;']);

var ControlPanelCell = function (_React$PureComponent) {
    _inherits(ControlPanelCell, _React$PureComponent);

    function ControlPanelCell(props) {
        _classCallCheck(this, ControlPanelCell);

        var _this = _possibleConstructorReturn(this, (ControlPanelCell.__proto__ || Object.getPrototypeOf(ControlPanelCell)).call(this, props));

        _this.state = {};
        _this._closeLightbox = function () {
            _this.setState({
                isLightboxOpen: false,
                currentImage: 0
            });
        };
        _this.state = {
            isLightboxOpen: false,
            type: props.type ? props.type === 'tcadmin' ? 'TCAdmin' : 'Custom' : 'Unknown'
        };
        _this._builder = (0, _imageUrl2.default)(Object.assign({}, props.siteData.sanityConfig, {
            baseUrl: 'https://cdn.sanity.io'
        }));
        return _this;
    }

    _createClass(ControlPanelCell, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                screenshots = _props.screenshots,
                siteData = _props.siteData,
                type = _props.type,
                props = _objectWithoutProperties(_props, ['screenshots', 'siteData', 'type']);

            var sanityImages = screenshots && screenshots.map(function (_ref) {
                var caption = _ref.caption,
                    ss = _objectWithoutProperties(_ref, ['caption']);

                return {
                    src: _this2._builder.image(ss).url(),
                    thumbnail: _this2._builder.image(ss).url(),
                    caption: caption
                };
            });
            return _react2.default.createElement(
                StFlex,
                _extends({ flexDirection: 'column' }, props),
                this.state.type,
                sanityImages && sanityImages.length ? _react2.default.createElement(StGallery, { images: this.state.controlPanelScreenshots, previewCount: 1, showCaption: false, justify: 'center' }) : null
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            var Builder = (0, _imageUrl2.default)(Object.assign({}, nextProps.siteData.sanityConfig, {
                baseUrl: 'https://cdn.sanity.io'
            }));
            return {
                controlPanelScreenshots: (nextProps.screenshots || []).map(function (ss) {
                    return {
                        src: Builder.image(ss).url(),
                        thumbnail: Builder.image(ss).width(105).height(65).url(),
                        thumbnailWidth: 105,
                        thumbnailHeight: 65,
                        srcset: [240, 360, 500, 750, 900, 1080, 1300, 1600].map(function (w) {
                            return Builder.image(ss).fit('max').width(w).url() + ' ' + w + 'w';
                        }),
                        thumbnailCaption: ss.caption,
                        caption: ss.caption
                    };
                })
            };
        }
    }]);

    return ControlPanelCell;
}(_react2.default.PureComponent);

ControlPanelCell.propTypes = {
    screenshots: _propTypes2.default.array,
    type: _propTypes2.default.string.isRequired
};
exports.default = (0, _reactStatic.withSiteData)(ControlPanelCell);

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(728);

var _reactScrolllock = __webpack_require__(835);

var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _Arrow = __webpack_require__(734);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Container = __webpack_require__(844);

var _Container2 = _interopRequireDefault(_Container);

var _Footer = __webpack_require__(845);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(846);

var _Header2 = _interopRequireDefault(_Header);

var _PaginatedThumbnails = __webpack_require__(847);

var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);

var _Portal = __webpack_require__(849);

var _Portal2 = _interopRequireDefault(_Portal);

var _Spinner = __webpack_require__(860);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _bindFunctions = __webpack_require__(861);

var _bindFunctions2 = _interopRequireDefault(_bindFunctions);

var _canUseDom = __webpack_require__(862);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// consumers sometimes provide incorrect type or casing
function normalizeSourceSet(data) {
	var sourceSet = data.srcSet || data.srcset;

	if (Array.isArray(sourceSet)) {
		return sourceSet.join();
	}

	return sourceSet;
}

var Lightbox = function (_Component) {
	_inherits(Lightbox, _Component);

	function Lightbox(props) {
		_classCallCheck(this, Lightbox);

		var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));

		_this.theme = (0, _deepMerge2.default)(_theme2.default, props.theme);
		_this.classes = _aphrodite.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, _this.theme));
		_this.state = { imageLoaded: false };

		_bindFunctions2.default.call(_this, ['gotoNext', 'gotoPrev', 'closeBackdrop', 'handleKeyboardInput', 'handleImageLoaded']);
		return _this;
	}

	_createClass(Lightbox, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				theme: this.theme
			};
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.isOpen) {
				if (this.props.enableKeyboardInput) {
					window.addEventListener('keydown', this.handleKeyboardInput);
				}
				if (typeof this.props.currentImage === 'number') {
					this.preloadImage(this.props.currentImage, this.handleImageLoaded);
				}
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (!_canUseDom2.default) return;

			// preload images
			if (nextProps.preloadNextImage) {
				var currentIndex = this.props.currentImage;
				var nextIndex = nextProps.currentImage + 1;
				var prevIndex = nextProps.currentImage - 1;
				var preloadIndex = void 0;

				if (currentIndex && nextProps.currentImage > currentIndex) {
					preloadIndex = nextIndex;
				} else if (currentIndex && nextProps.currentImage < currentIndex) {
					preloadIndex = prevIndex;
				}

				// if we know the user's direction just get one image
				// otherwise, to be safe, we need to grab one in each direction
				if (preloadIndex) {
					this.preloadImage(preloadIndex);
				} else {
					this.preloadImage(prevIndex);
					this.preloadImage(nextIndex);
				}
			}

			// preload current image
			if (this.props.currentImage !== nextProps.currentImage || !this.props.isOpen && nextProps.isOpen) {
				var img = this.preloadImageData(nextProps.images[nextProps.currentImage], this.handleImageLoaded);
				if (img) this.setState({ imageLoaded: img.complete });
			}

			// add/remove event listeners
			if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
				window.addEventListener('keydown', this.handleKeyboardInput);
			}
			if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
				window.removeEventListener('keydown', this.handleKeyboardInput);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.props.enableKeyboardInput) {
				window.removeEventListener('keydown', this.handleKeyboardInput);
			}
		}

		// ==============================
		// METHODS
		// ==============================

	}, {
		key: 'preloadImage',
		value: function preloadImage(idx, onload) {
			return this.preloadImageData(this.props.images[idx], onload);
		}
	}, {
		key: 'preloadImageData',
		value: function preloadImageData(data, onload) {
			if (!data) return;
			var img = new Image();
			var sourceSet = normalizeSourceSet(data);

			// TODO: add error handling for missing images
			img.onerror = onload;
			img.onload = onload;
			img.src = data.src;

			if (sourceSet) img.srcset = sourceSet;

			return img;
		}
	}, {
		key: 'gotoNext',
		value: function gotoNext(event) {
			var _props = this.props,
			    currentImage = _props.currentImage,
			    images = _props.images;
			var imageLoaded = this.state.imageLoaded;


			if (!imageLoaded || currentImage === images.length - 1) return;

			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			this.props.onClickNext();
		}
	}, {
		key: 'gotoPrev',
		value: function gotoPrev(event) {
			var currentImage = this.props.currentImage;
			var imageLoaded = this.state.imageLoaded;


			if (!imageLoaded || currentImage === 0) return;

			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			this.props.onClickPrev();
		}
	}, {
		key: 'closeBackdrop',
		value: function closeBackdrop(event) {
			// make sure event only happens if they click the backdrop
			// and if the caption is widening the figure element let that respond too
			if (event.target.id === 'lightboxBackdrop' || event.target.tagName === 'FIGURE') {
				this.props.onClose();
			}
		}
	}, {
		key: 'handleKeyboardInput',
		value: function handleKeyboardInput(event) {
			if (event.keyCode === 37) {
				// left
				this.gotoPrev(event);
				return true;
			} else if (event.keyCode === 39) {
				// right
				this.gotoNext(event);
				return true;
			} else if (event.keyCode === 27) {
				// esc
				this.props.onClose();
				return true;
			}
			return false;
		}
	}, {
		key: 'handleImageLoaded',
		value: function handleImageLoaded() {
			this.setState({ imageLoaded: true });
		}

		// ==============================
		// RENDERERS
		// ==============================

	}, {
		key: 'renderArrowPrev',
		value: function renderArrowPrev() {
			if (this.props.currentImage === 0) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'left',
				icon: 'arrowLeft',
				onClick: this.gotoPrev,
				title: this.props.leftArrowTitle,
				type: 'button'
			});
		}
	}, {
		key: 'renderArrowNext',
		value: function renderArrowNext() {
			if (this.props.currentImage === this.props.images.length - 1) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'right',
				icon: 'arrowRight',
				onClick: this.gotoNext,
				title: this.props.rightArrowTitle,
				type: 'button'
			});
		}
	}, {
		key: 'renderDialog',
		value: function renderDialog() {
			var _props2 = this.props,
			    backdropClosesModal = _props2.backdropClosesModal,
			    isOpen = _props2.isOpen,
			    showThumbnails = _props2.showThumbnails,
			    width = _props2.width;
			var imageLoaded = this.state.imageLoaded;


			if (!isOpen) return _react2.default.createElement('span', { key: 'closed' });

			var offsetThumbnails = 0;
			if (showThumbnails) {
				offsetThumbnails = this.theme.thumbnail.size + this.theme.container.gutter.vertical;
			}

			return _react2.default.createElement(
				_Container2.default,
				{
					key: 'open',
					onClick: backdropClosesModal && this.closeBackdrop,
					onTouchEnd: backdropClosesModal && this.closeBackdrop
				},
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(this.classes.content), style: { marginBottom: offsetThumbnails, maxWidth: width } },
						imageLoaded && this.renderHeader(),
						this.renderImages(),
						this.renderSpinner(),
						imageLoaded && this.renderFooter()
					),
					imageLoaded && this.renderThumbnails(),
					imageLoaded && this.renderArrowPrev(),
					imageLoaded && this.renderArrowNext(),
					this.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
				)
			);
		}
	}, {
		key: 'renderImages',
		value: function renderImages() {
			var _props3 = this.props,
			    currentImage = _props3.currentImage,
			    images = _props3.images,
			    onClickImage = _props3.onClickImage,
			    showThumbnails = _props3.showThumbnails;
			var imageLoaded = this.state.imageLoaded;


			if (!images || !images.length) return null;

			var image = images[currentImage];
			var sourceSet = normalizeSourceSet(image);
			var sizes = sourceSet ? '100vw' : null;

			var thumbnailsSize = showThumbnails ? this.theme.thumbnail.size : 0;
			var heightOffset = this.theme.header.height + this.theme.footer.height + thumbnailsSize + this.theme.container.gutter.vertical + 'px';

			return _react2.default.createElement(
				'figure',
				{ className: (0, _aphrodite.css)(this.classes.figure) },
				_react2.default.createElement('img', {
					className: (0, _aphrodite.css)(this.classes.image, imageLoaded && this.classes.imageLoaded),
					onClick: onClickImage,
					sizes: sizes,
					alt: image.alt,
					src: image.src,
					srcSet: sourceSet,
					style: {
						cursor: onClickImage ? 'pointer' : 'auto',
						maxHeight: 'calc(100vh - ' + heightOffset + ')'
					}
				})
			);
		}
	}, {
		key: 'renderThumbnails',
		value: function renderThumbnails() {
			var _props4 = this.props,
			    images = _props4.images,
			    currentImage = _props4.currentImage,
			    onClickThumbnail = _props4.onClickThumbnail,
			    showThumbnails = _props4.showThumbnails,
			    thumbnailOffset = _props4.thumbnailOffset;


			if (!showThumbnails) return;

			return _react2.default.createElement(_PaginatedThumbnails2.default, {
				currentImage: currentImage,
				images: images,
				offset: thumbnailOffset,
				onClickThumbnail: onClickThumbnail
			});
		}
	}, {
		key: 'renderHeader',
		value: function renderHeader() {
			var _props5 = this.props,
			    closeButtonTitle = _props5.closeButtonTitle,
			    customControls = _props5.customControls,
			    onClose = _props5.onClose,
			    showCloseButton = _props5.showCloseButton;


			return _react2.default.createElement(_Header2.default, {
				customControls: customControls,
				onClose: onClose,
				showCloseButton: showCloseButton,
				closeButtonTitle: closeButtonTitle
			});
		}
	}, {
		key: 'renderFooter',
		value: function renderFooter() {
			var _props6 = this.props,
			    currentImage = _props6.currentImage,
			    images = _props6.images,
			    imageCountSeparator = _props6.imageCountSeparator,
			    showImageCount = _props6.showImageCount;


			if (!images || !images.length) return null;

			return _react2.default.createElement(_Footer2.default, {
				caption: images[currentImage].caption,
				countCurrent: currentImage + 1,
				countSeparator: imageCountSeparator,
				countTotal: images.length,
				showCount: showImageCount
			});
		}
	}, {
		key: 'renderSpinner',
		value: function renderSpinner() {
			var _props7 = this.props,
			    spinner = _props7.spinner,
			    spinnerColor = _props7.spinnerColor,
			    spinnerSize = _props7.spinnerSize;
			var imageLoaded = this.state.imageLoaded;

			var Spinner = spinner;

			return _react2.default.createElement(
				'div',
				{ className: (0, _aphrodite.css)(this.classes.spinner, !imageLoaded && this.classes.spinnerActive) },
				_react2.default.createElement(Spinner, {
					color: spinnerColor,
					size: spinnerSize
				})
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_Portal2.default,
				null,
				this.renderDialog()
			);
		}
	}]);

	return Lightbox;
}(_react.Component);

Lightbox.propTypes = {
	backdropClosesModal: _propTypes2.default.bool,
	closeButtonTitle: _propTypes2.default.string,
	currentImage: _propTypes2.default.number,
	customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
	enableKeyboardInput: _propTypes2.default.bool,
	imageCountSeparator: _propTypes2.default.string,
	images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		src: _propTypes2.default.string.isRequired,
		srcSet: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
		caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
		thumbnail: _propTypes2.default.string
	})).isRequired,
	isOpen: _propTypes2.default.bool,
	leftArrowTitle: _propTypes2.default.string,
	onClickImage: _propTypes2.default.func,
	onClickNext: _propTypes2.default.func,
	onClickPrev: _propTypes2.default.func,
	onClose: _propTypes2.default.func.isRequired,
	preloadNextImage: _propTypes2.default.bool,
	preventScroll: _propTypes2.default.bool,
	rightArrowTitle: _propTypes2.default.string,
	showCloseButton: _propTypes2.default.bool,
	showImageCount: _propTypes2.default.bool,
	showThumbnails: _propTypes2.default.bool,
	spinner: _propTypes2.default.func,
	spinnerColor: _propTypes2.default.string,
	spinnerSize: _propTypes2.default.number,
	theme: _propTypes2.default.object,
	thumbnailOffset: _propTypes2.default.number,
	width: _propTypes2.default.number
};
Lightbox.defaultProps = {
	closeButtonTitle: 'Close (Esc)',
	currentImage: 0,
	enableKeyboardInput: true,
	imageCountSeparator: ' of ',
	leftArrowTitle: 'Previous (Left arrow key)',
	onClickShowNextImage: true,
	preloadNextImage: true,
	preventScroll: true,
	rightArrowTitle: 'Next (Right arrow key)',
	showCloseButton: true,
	showImageCount: true,
	spinner: _Spinner2.default,
	spinnerColor: 'white',
	spinnerSize: 100,
	theme: {},
	thumbnailOffset: 2,
	width: 1024
};
Lightbox.childContextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	content: {
		position: 'relative'
	},
	figure: {
		margin: 0 // remove browser default
	},
	image: {
		display: 'block', // removes browser default gutter
		height: 'auto',
		margin: '0 auto', // maintain center on very short screens OR very narrow image
		maxWidth: '100%',

		// disable user select
		WebkitTouchCallout: 'none',
		userSelect: 'none',

		// opacity animation on image load
		opacity: 0,
		transition: 'opacity 0.3s'
	},
	imageLoaded: {
		opacity: 1
	},
	spinner: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		// opacity animation to make spinner appear with delay
		opacity: 0,
		transition: 'opacity 0.3s',
		pointerEvents: 'none'
	},
	spinnerActive: {
		opacity: 1
	}
};

exports.default = Lightbox;

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(819);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _inlineStylePrefixerStatic = __webpack_require__(821);

var _inlineStylePrefixerStatic2 = _interopRequireDefault(_inlineStylePrefixerStatic);

var _util = __webpack_require__(710);

/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries, pseudo selectors, and descendant
 * styles that can be used in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSSInner(".foo", {
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold",
 *         ">>bar": {
 *           _names: { "foo_bar": true },
 *           height: 10,
 *         }
 *       }
 *     });
 *
 * will make 5 calls to `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     generateCSSRuleset(".foo:active .foo_bar", { height: 10 }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */
var generateCSS = function generateCSS(selector, styleTypes, stringHandlers, useImportant) {
    var merged = styleTypes.reduce(_util.recursiveMerge);

    var declarations = {};
    var mediaQueries = {};
    var pseudoStyles = {};

    Object.keys(merged).forEach(function (key) {
        if (key[0] === ':') {
            pseudoStyles[key] = merged[key];
        } else if (key[0] === '@') {
            mediaQueries[key] = merged[key];
        } else {
            declarations[key] = merged[key];
        }
    });

    return generateCSSRuleset(selector, declarations, stringHandlers, useImportant) + Object.keys(pseudoStyles).map(function (pseudoSelector) {
        return generateCSSRuleset(selector + pseudoSelector, pseudoStyles[pseudoSelector], stringHandlers, useImportant);
    }).join("") + Object.keys(mediaQueries).map(function (mediaQuery) {
        var ruleset = generateCSS(selector, [mediaQueries[mediaQuery]], stringHandlers, useImportant);
        return mediaQuery + '{' + ruleset + '}';
    }).join("");
};

exports.generateCSS = generateCSS;
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */
var runStringHandlers = function runStringHandlers(declarations, stringHandlers) {
    var result = {};

    Object.keys(declarations).forEach(function (key) {
        // If a handler exists for this particular key, let it interpret
        // that value first before continuing
        if (stringHandlers && stringHandlers.hasOwnProperty(key)) {
            result[key] = stringHandlers[key](declarations[key]);
        } else {
            result[key] = declarations[key];
        }
    });

    return result;
};

/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */
var generateCSSRuleset = function generateCSSRuleset(selector, declarations, stringHandlers, useImportant) {
    var handledDeclarations = runStringHandlers(declarations, stringHandlers);

    var prefixedDeclarations = (0, _inlineStylePrefixerStatic2['default'])(handledDeclarations);

    var prefixedRules = (0, _util.flatten)((0, _util.objectToPairs)(prefixedDeclarations).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        if (Array.isArray(value)) {
            var _ret = (function () {
                // inline-style-prefix-all returns an array when there should be
                // multiple rules, we will flatten to single rules

                var prefixedValues = [];
                var unprefixedValues = [];

                value.forEach(function (v) {
                    if (v.indexOf('-') === 0) {
                        prefixedValues.push(v);
                    } else {
                        unprefixedValues.push(v);
                    }
                });

                prefixedValues.sort();
                unprefixedValues.sort();

                return {
                    v: prefixedValues.concat(unprefixedValues).map(function (v) {
                        return [key, v];
                    })
                };
            })();

            if (typeof _ret === 'object') return _ret.v;
        }
        return [[key, value]];
    }));

    var rules = prefixedRules.map(function (_ref3) {
        var _ref32 = _slicedToArray(_ref3, 2);

        var key = _ref32[0];
        var value = _ref32[1];

        var stringValue = (0, _util.stringifyValue)(key, value);
        var ret = (0, _util.kebabifyStyleName)(key) + ':' + stringValue + ';';
        return useImportant === false ? ret : (0, _util.importantify)(ret);
    }).join("");

    if (rules) {
        return selector + '{' + rules + '}';
    } else {
        return "";
    }
};
exports.generateCSSRuleset = generateCSSRuleset;

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(822);

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = __webpack_require__(730);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = __webpack_require__(731);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(823);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _position = __webpack_require__(825);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(826);

var _calc2 = _interopRequireDefault(_calc);

var _cursor = __webpack_require__(827);

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = __webpack_require__(828);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(829);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(830);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(831);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(833);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(834);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// special flexbox specifications


var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    [].concat(styles[property]).forEach(function (value, index) {
      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return assignStyles(styles, plugin(property, value));
      });
    });
  });

  return (0, _sortPrefixedStyle2.default)(styles);
}

function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (value) {
        var valueIndex = baseValue.indexOf(value);
        if (valueIndex > -1) {
          base[property].splice(valueIndex, 1);
        }
        base[property].push(value);
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortPrefixedStyle;

var _isPrefixedProperty = __webpack_require__(824);

var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function sortPrefixedStyle(style) {
  return Object.keys(style).sort(function (left, right) {
    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
      return -1;
    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
      return 1;
    }
    return 0;
  }).reduce(function (sortedStyle, prop) {
    sortedStyle[prop] = style[prop];
    return sortedStyle;
  }, {});
}
module.exports = exports['default'];

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return { position: ['-webkit-sticky', 'sticky'] };
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _joinPrefixedValue = __webpack_require__(708);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(711);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _joinPrefixedValue = __webpack_require__(708);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _joinPrefixedValue = __webpack_require__(708);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _joinPrefixedValue = __webpack_require__(708);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(711);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateStyleName = __webpack_require__(832);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _capitalizeString = __webpack_require__(731);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _isPrefixedValue = __webpack_require__(711);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _prefixProps = __webpack_require__(730);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);

        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection' && typeof value === 'string') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = __webpack_require__(836);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(168);

var _reactPropToggle = __webpack_require__(837);

var _utils = __webpack_require__(733);

var _withTouchListeners = __webpack_require__(839);

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOCK_COUNT = 0;

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    _classCallCheck(this, ScrollLock);

    return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      LOCK_COUNT++;
      if (_exenv.canUseDOM) {
        this.initialHeight = window.innerHeight;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      LOCK_COUNT = Math.max(LOCK_COUNT - 1, 0);

      if (_exenv.canUseDOM) {
        var offset = window.innerHeight - this.initialHeight;

        // adjust scroll if the window has been resized since the lock was engaged
        if (offset) {
          window.scrollTo(0, window.pageYOffset + offset);
        }
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      var accountForScrollbars = this.props.accountForScrollbars;

      // avoid overly incrementing padding

      var scrollbarSpacer = accountForScrollbars && LOCK_COUNT < 1 ? { 'padding-right': (0, _utils.getPadding)() + 'px' } : {};

      var height = (0, _utils.getDocumentHeight)() + 'px';

      return _react2.default.createElement(_reactPropToggle.SimpleToggle, {
        styles: _extends({
          'box-sizing': 'border-box', // account for possible declaration `width: 100%;` on body
          overflow: 'hidden',
          position: 'relative',
          height: height
        }, scrollbarSpacer)
      });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LifeCycleProvider = __webpack_require__(838);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LifeCycleProvider).default;
  }
});

var _PropToggle = __webpack_require__(732);

Object.defineProperty(exports, 'SimpleToggle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PropToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropToggle = __webpack_require__(732);

var _PropToggle2 = _interopRequireDefault(_PropToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LifeCycleProvider = function LifeCycleProvider(_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, ['isActive']);

  return isActive ? _react2.default.createElement(_PropToggle2.default, props) : null;
};

LifeCycleProvider.defaultProps = _PropToggle.defaultProps;

exports.default = LifeCycleProvider;

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withTouchListeners;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(168);

var _utils = __webpack_require__(733);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Module with the same interface as the core aphrodite module,
// except that styles injected do not automatically have !important
// appended to them.
//


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _inject = __webpack_require__(729);

var _indexJs = __webpack_require__(728);

var css = function css() {
    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
    }

    var useImportant = false; // Don't append !important to style definitions
    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports.StyleSheet = _indexJs.StyleSheet;
exports.StyleSheetServer = _indexJs.StyleSheetServer;
exports.StyleSheetTestUtils = _indexJs.StyleSheetTestUtils;
exports.css = css;

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
};

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
};

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Container(_ref, _ref2) {
	var theme = _ref2.theme;

	var props = _objectWithoutProperties(_ref, []);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement('div', _extends({ id: 'lightboxBackdrop',
		className: (0, _noImportant.css)(classes.container)
	}, props));
}

Container.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	container: {
		alignItems: 'center',
		backgroundColor: _theme2.default.container.background,
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		left: 0,
		paddingBottom: _theme2.default.container.gutter.vertical,
		paddingLeft: _theme2.default.container.gutter.horizontal,
		paddingRight: _theme2.default.container.gutter.horizontal,
		paddingTop: _theme2.default.container.gutter.vertical,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: _theme2.default.container.zIndex
	}
};

exports.default = Container;

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Footer(_ref, _ref2) {
	var theme = _ref2.theme;

	var caption = _ref.caption,
	    countCurrent = _ref.countCurrent,
	    countSeparator = _ref.countSeparator,
	    countTotal = _ref.countTotal,
	    showCount = _ref.showCount,
	    props = _objectWithoutProperties(_ref, ['caption', 'countCurrent', 'countSeparator', 'countTotal', 'showCount']);

	if (!caption && !showCount) return null;

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	var imageCount = showCount ? _react2.default.createElement(
		'div',
		{ className: (0, _noImportant.css)(classes.footerCount) },
		countCurrent,
		countSeparator,
		countTotal
	) : _react2.default.createElement('span', null);

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _noImportant.css)(classes.footer) }, props),
		caption ? _react2.default.createElement(
			'figcaption',
			{ className: (0, _noImportant.css)(classes.footerCaption) },
			caption
		) : _react2.default.createElement('span', null),
		imageCount
	);
}

Footer.propTypes = {
	caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	countCurrent: _propTypes2.default.number,
	countSeparator: _propTypes2.default.string,
	countTotal: _propTypes2.default.number,
	showCount: _propTypes2.default.bool
};
Footer.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	footer: {
		boxSizing: 'border-box',
		color: _theme2.default.footer.color,
		cursor: 'auto',
		display: 'flex',
		justifyContent: 'space-between',
		left: 0,
		lineHeight: 1.3,
		paddingBottom: _theme2.default.footer.gutter.vertical,
		paddingLeft: _theme2.default.footer.gutter.horizontal,
		paddingRight: _theme2.default.footer.gutter.horizontal,
		paddingTop: _theme2.default.footer.gutter.vertical
	},
	footerCount: {
		color: _theme2.default.footer.count.color,
		fontSize: _theme2.default.footer.count.fontSize,
		paddingLeft: '1em' // add a small gutter for the caption
	},
	footerCaption: {
		flex: '1 1 0'
	}
};

exports.default = Footer;

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

var _Icon = __webpack_require__(735);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header(_ref, _ref2) {
	var theme = _ref2.theme;

	var customControls = _ref.customControls,
	    onClose = _ref.onClose,
	    showCloseButton = _ref.showCloseButton,
	    closeButtonTitle = _ref.closeButtonTitle,
	    props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseButton', 'closeButtonTitle']);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _noImportant.css)(classes.header) }, props),
		customControls ? customControls : _react2.default.createElement('span', null),
		!!showCloseButton && _react2.default.createElement(
			'button',
			{
				title: closeButtonTitle,
				className: (0, _noImportant.css)(classes.close),
				onClick: onClose
			},
			_react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
		)
	);
}

Header.propTypes = {
	customControls: _propTypes2.default.array,
	onClose: _propTypes2.default.func.isRequired,
	showCloseButton: _propTypes2.default.bool
};
Header.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		height: _theme2.default.header.height
	},
	close: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		outline: 'none',
		position: 'relative',
		top: 0,
		verticalAlign: 'bottom',
		zIndex: 1,

		// increase hit area
		height: 40,
		marginRight: -10,
		padding: 10,
		width: 40
	}
};

exports.default = Header;

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _Thumbnail = __webpack_require__(848);

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

var _Arrow = __webpack_require__(734);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classes = _noImportant.StyleSheet.create({
	paginatedThumbnails: {
		bottom: _theme2.default.container.gutter.vertical,
		height: _theme2.default.thumbnail.size,
		padding: '0 50px',
		position: 'absolute',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		left: '50%',
		transform: 'translateX(-50%)'
	}
});

var arrowStyles = {
	height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
	width: 40
};

var PaginatedThumbnails = function (_Component) {
	_inherits(PaginatedThumbnails, _Component);

	function PaginatedThumbnails(props) {
		_classCallCheck(this, PaginatedThumbnails);

		var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));

		_this.state = {
			hasCustomPage: false
		};

		_this.gotoPrev = _this.gotoPrev.bind(_this);
		_this.gotoNext = _this.gotoNext.bind(_this);
		return _this;
	}

	_createClass(PaginatedThumbnails, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			// Component should be controlled, flush state when currentImage changes
			if (nextProps.currentImage !== this.props.currentImage) {
				this.setState({
					hasCustomPage: false
				});
			}
		}

		// ==============================
		// METHODS
		// ==============================

	}, {
		key: 'getFirst',
		value: function getFirst() {
			var _props = this.props,
			    currentImage = _props.currentImage,
			    offset = _props.offset;

			if (this.state.hasCustomPage) {
				return this.clampFirst(this.state.first);
			}
			return this.clampFirst(currentImage - offset);
		}
	}, {
		key: 'setFirst',
		value: function setFirst(event, newFirst) {
			var first = this.state.first;


			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			if (first === newFirst) return;

			this.setState({
				hasCustomPage: true,
				first: newFirst
			});
		}
	}, {
		key: 'gotoPrev',
		value: function gotoPrev(event) {
			this.setFirst(event, this.getFirst() - this.props.offset);
		}
	}, {
		key: 'gotoNext',
		value: function gotoNext(event) {
			this.setFirst(event, this.getFirst() + this.props.offset);
		}
	}, {
		key: 'clampFirst',
		value: function clampFirst(value) {
			var _props2 = this.props,
			    images = _props2.images,
			    offset = _props2.offset;


			var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side

			if (value < 0) {
				return 0;
			} else if (value + totalCount > images.length) {
				// Too far
				return images.length - totalCount;
			} else {
				return value;
			}
		}

		// ==============================
		// RENDERERS
		// ==============================

	}, {
		key: 'renderArrowPrev',
		value: function renderArrowPrev() {
			if (this.getFirst() <= 0) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'left',
				size: 'small',
				icon: 'arrowLeft',
				onClick: this.gotoPrev,
				style: arrowStyles,
				title: 'Previous (Left arrow key)',
				type: 'button'
			});
		}
	}, {
		key: 'renderArrowNext',
		value: function renderArrowNext() {
			var _props3 = this.props,
			    offset = _props3.offset,
			    images = _props3.images;

			var totalCount = 2 * offset + 1;
			if (this.getFirst() + totalCount >= images.length) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'right',
				size: 'small',
				icon: 'arrowRight',
				onClick: this.gotoNext,
				style: arrowStyles,
				title: 'Next (Right arrow key)',
				type: 'button'
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    images = _props4.images,
			    currentImage = _props4.currentImage,
			    onClickThumbnail = _props4.onClickThumbnail,
			    offset = _props4.offset;


			var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
			var thumbnails = [];
			var baseOffset = 0;
			if (images.length <= totalCount) {
				thumbnails = images;
			} else {
				// Try to center current image in list
				baseOffset = this.getFirst();
				thumbnails = images.slice(baseOffset, baseOffset + totalCount);
			}

			return _react2.default.createElement(
				'div',
				{ className: (0, _noImportant.css)(classes.paginatedThumbnails) },
				this.renderArrowPrev(),
				thumbnails.map(function (img, idx) {
					return _react2.default.createElement(_Thumbnail2.default, _extends({ key: baseOffset + idx
					}, img, {
						index: baseOffset + idx,
						onClick: onClickThumbnail,
						active: baseOffset + idx === currentImage }));
				}),
				this.renderArrowNext()
			);
		}
	}]);

	return PaginatedThumbnails;
}(_react.Component);

exports.default = PaginatedThumbnails;


PaginatedThumbnails.propTypes = {
	currentImage: _propTypes2.default.number,
	images: _propTypes2.default.array,
	offset: _propTypes2.default.number,
	onClickThumbnail: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

var _theme = __webpack_require__(698);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(702);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Thumbnail(_ref, _ref2) {
	var index = _ref.index,
	    src = _ref.src,
	    thumbnail = _ref.thumbnail,
	    active = _ref.active,
	    _onClick = _ref.onClick;
	var theme = _ref2.theme;

	var url = thumbnail ? thumbnail : src;
	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement('div', {
		className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
		onClick: function onClick(e) {
			e.preventDefault();
			e.stopPropagation();
			_onClick(index);
		},
		style: { backgroundImage: 'url("' + url + '")' }
	});
}

Thumbnail.propTypes = {
	active: _propTypes2.default.bool,
	index: _propTypes2.default.number,
	onClick: _propTypes2.default.func.isRequired,
	src: _propTypes2.default.string,
	thumbnail: _propTypes2.default.string
};

Thumbnail.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	thumbnail: {
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		borderRadius: 2,
		boxShadow: 'inset 0 0 0 1px hsla(0,0%,100%,.2)',
		cursor: 'pointer',
		display: 'inline-block',
		height: _theme2.default.thumbnail.size,
		margin: _theme2.default.thumbnail.gutter,
		overflow: 'hidden',
		width: _theme2.default.thumbnail.size
	},
	thumbnail__active: {
		boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
	}
};

exports.default = Thumbnail;

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(850);

var _reactDom = __webpack_require__(15);

var _PassContext = __webpack_require__(859);

var _PassContext2 = _interopRequireDefault(_PassContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_Component) {
	_inherits(Portal, _Component);

	function Portal() {
		_classCallCheck(this, Portal);

		var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

		_this.portalElement = null;
		return _this;
	}

	_createClass(Portal, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var p = document.createElement('div');
			document.body.appendChild(p);
			this.portalElement = p;
			this.componentDidUpdate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			// Animate fade on mount/unmount
			var duration = 200;
			var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: 0.01; transition: opacity ' + duration + 'ms; }\n\t\t';

			(0, _reactDom.render)(_react2.default.createElement(
				_PassContext2.default,
				{ context: this.context },
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'style',
						null,
						styles
					),
					_react2.default.createElement(
						_reactTransitionGroup.TransitionGroup,
						this.props,
						_react2.default.createElement(
							_reactTransitionGroup.CSSTransition,
							{ timeout: { enter: duration, exit: duration }, classNames: 'fade' },
							this.props.children
						)
					)
				)
			), this.portalElement);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			(0, _reactDom.unmountComponentAtNode)(this.portalElement);
			document.body.removeChild(this.portalElement);
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return Portal;
}(_react.Component);

exports.default = Portal;


Portal.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(851);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(857);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(738);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(736);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(704);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(854);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(856);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(736);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(853);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(855);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(704);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _TransitionGroup = __webpack_require__(738);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Pass the Lightbox context through to the Portal's descendents
// StackOverflow discussion http://goo.gl/oclrJ9

var PassContext = function (_Component) {
	_inherits(PassContext, _Component);

	function PassContext() {
		_classCallCheck(this, PassContext);

		return _possibleConstructorReturn(this, (PassContext.__proto__ || Object.getPrototypeOf(PassContext)).apply(this, arguments));
	}

	_createClass(PassContext, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return this.props.context;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return PassContext;
}(_react.Component);

PassContext.propTypes = {
	context: _propTypes2.default.object.isRequired
};
PassContext.childContextTypes = {
	theme: _propTypes2.default.object
};

exports.default = PassContext;

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(699);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(props) {
	var classes = _noImportant.StyleSheet.create(styles(props));

	return _react2.default.createElement(
		'div',
		{ className: (0, _noImportant.css)(classes.spinner) },
		_react2.default.createElement('div', { className: (0, _noImportant.css)(classes.ripple) })
	);
};

Spinner.propTypes = {
	color: _propTypes2.default.string,
	size: _propTypes2.default.number
};

var rippleKeyframes = {
	'0%': {
		top: '50%',
		left: '50%',
		width: 0,
		height: 0,
		opacity: 1
	},
	'100%': {
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		opacity: 0
	}
};

var styles = function styles(_ref) {
	var color = _ref.color,
	    size = _ref.size;
	return {
		spinner: {
			display: 'inline-block',
			position: 'relative',
			width: size,
			height: size
		},
		ripple: {
			position: 'absolute',
			border: '4px solid ' + color,
			opacity: 1,
			borderRadius: '50%',
			animationName: rippleKeyframes,
			animationDuration: '1s',
			animationTimingFunction: 'cubic-bezier(0, 0.2, 0.8, 1)',
			animationIterationCount: 'infinite'
		}
	};
};

exports.default = Spinner;

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = bindFunctions;
/**
	Bind multiple component methods:

	* @param {this} context
	* @param {Array} functions

	constructor() {
		...
		bindFunctions.call(this, ['handleClick', 'handleOther']);
	}
*/

function bindFunctions(functions) {
	var _this = this;

	functions.forEach(function (f) {
		return _this[f] = _this[f].bind(_this);
	});
};

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Return true if window + document

exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Host.b09f09cd.js